/* eslint-disable quotes */
export const leiCountryRegionSelect = {
    AE: [
        {
            value: 'AE-AJ',
            labelcz: 'Ajman'
        },
        {
            value: 'AE-AZ',
            labelcz: 'Abu Dhabi'
        },
        {
            value: 'AE-DU',
            labelcz: 'Dubai'
        },
        {
            value: 'AE-FU',
            labelcz: 'Fujairah'
        },
        {
            value: 'AE-RK',
            labelcz: 'Ras al-Khaimah'
        },
        {
            value: 'AE-SH',
            labelcz: 'Sharjah'
        },
        {
            value: 'AE-UQ',
            labelcz: 'Umm al-Quwain'
        }
    ],
    AT: [
        {
            value: 'AT-1',
            labelcz: 'Burgenland'
        },
        {
            value: 'AT-2',
            labelcz: 'Kärnten'
        },
        {
            value: 'AT-3',
            labelcz: 'Niederösterreich'
        },
        {
            value: 'AT-4',
            labelcz: 'Oberösterreich'
        },
        {
            value: 'AT-5',
            labelcz: 'Salzburg'
        },
        {
            value: 'AT-6',
            labelcz: 'Steiermark'
        },
        {
            value: 'AT-7',
            labelcz: 'Tirol'
        },
        {
            value: 'AT-8',
            labelcz: 'Vorarlberg'
        },
        {
            value: 'AT-9',
            labelcz: 'Wien'
        }
    ],
    BG: [
        {
            value: 'BG-01',
            labelcz: 'Blagoevgrad'
        },
        {
            value: 'BG-02',
            labelcz: 'Burgas'
        },
        {
            value: 'BG-03',
            labelcz: 'Varna'
        },
        {
            value: 'BG-04',
            labelcz: 'Veliko Tarnovo'
        },
        {
            value: 'BG-05',
            labelcz: 'Vidin'
        },
        {
            value: 'BG-06',
            labelcz: 'Vratsa'
        },
        {
            value: 'BG-07',
            labelcz: 'Gabrovo'
        },
        {
            value: 'BG-08',
            labelcz: 'Dobrich'
        },
        {
            value: 'BG-09',
            labelcz: 'Kardzhali'
        },
        {
            value: 'BG-10',
            labelcz: 'Kyustendil'
        },
        {
            value: 'BG-11',
            labelcz: 'Lovech'
        },
        {
            value: 'BG-12',
            labelcz: 'Montana'
        },
        {
            value: 'BG-13',
            labelcz: 'Pazardzhik'
        },
        {
            value: 'BG-14',
            labelcz: 'Pernik'
        },
        {
            value: 'BG-15',
            labelcz: 'Pleven'
        },
        {
            value: 'BG-16',
            labelcz: 'Plovdiv'
        },
        {
            value: 'BG-17',
            labelcz: 'Razgrad'
        },
        {
            value: 'BG-18',
            labelcz: 'Ruse'
        },
        {
            value: 'BG-19',
            labelcz: 'Silistra'
        },
        {
            value: 'BG-20',
            labelcz: 'Sliven'
        },
        {
            value: 'BG-21',
            labelcz: 'Smolyan'
        },
        {
            value: 'BG-22',
            labelcz: 'Sofia (stolitsa)'
        },
        {
            value: 'BG-23',
            labelcz: 'Sofia'
        },
        {
            value: 'BG-24',
            labelcz: 'Stara Zagora'
        },
        {
            value: 'BG-25',
            labelcz: 'Targovishte'
        },
        {
            value: 'BG-26',
            labelcz: 'Haskovo'
        },
        {
            value: 'BG-27',
            labelcz: 'Shumen'
        },
        {
            value: 'BG-28',
            labelcz: 'Yambol'
        }
    ],
    BZ: [
        {
            value: 'BZ-BZ',
            labelcz: 'Belize'
        },
        {
            value: 'BZ-CY',
            labelcz: 'Cayo'
        },
        {
            value: 'BZ-CZL',
            labelcz: 'Corozal'
        },
        {
            value: 'BZ-OW',
            labelcz: 'Orange Walk'
        },
        {
            value: 'BZ-SC',
            labelcz: 'Stann Creek'
        },
        {
            value: 'BZ-TOL',
            labelcz: 'Toledo'
        }
    ],
    CA: [
        {
            value: 'CA-AB',
            labelcz: 'Alberta'
        },
        {
            value: 'CA-BC',
            labelcz: 'British Columbia'
        },
        {
            value: 'CA-MB',
            labelcz: 'Manitoba'
        },
        {
            value: 'CA-NB',
            labelcz: 'New Brunswick'
        },
        {
            value: 'CA-NL',
            labelcz: 'Newfoundland and Labrador'
        },
        {
            value: 'CA-NS',
            labelcz: 'Nova Scotia'
        },
        {
            value: 'CA-NT',
            labelcz: 'Northwest Territories'
        },
        {
            value: 'CA-NU',
            labelcz: 'Nunavut'
        },
        {
            value: 'CA-ON',
            labelcz: 'Ontario'
        },
        {
            value: 'CA-PE',
            labelcz: 'Prince Edward Island'
        },
        {
            value: 'CA-QC',
            labelcz: 'Quebec'
        },
        {
            value: 'CA-SK',
            labelcz: 'Saskatchewan'
        },
        {
            value: 'CA-YT',
            labelcz: 'Yukon'
        }
    ],

    CN: [
        {
            value: 'CN-AH',
            labelcz: 'Anhui'
        },
        {
            value: 'CN-BJ',
            labelcz: 'Beijing'
        },
        {
            value: 'CN-CQ',
            labelcz: 'Chongqing'
        },
        {
            value: 'CN-FJ',
            labelcz: 'Fujian'
        },
        {
            value: 'CN-GD',
            labelcz: 'Guangdong'
        },
        {
            value: 'CN-GS',
            labelcz: 'Gansu'
        },
        {
            value: 'CN-GX',
            labelcz: 'Guangxi Zhuang'
        },
        {
            value: 'CN-GZ',
            labelcz: 'Guizhou'
        },
        {
            value: 'CN-HA',
            labelcz: 'Henan'
        },
        {
            value: 'CN-HB',
            labelcz: 'Hubei'
        },
        {
            value: 'CN-HE',
            labelcz: 'Hebei'
        },
        {
            value: 'CN-HI',
            labelcz: 'Hainan'
        },
        {
            value: 'CN-HK',
            labelcz: 'Hong Kong'
        },
        {
            value: 'CN-HL',
            labelcz: 'Heilongjiang'
        },
        {
            value: 'CN-HN',
            labelcz: 'Hunan'
        },
        {
            value: 'CN-JL',
            labelcz: 'Jilin'
        },
        {
            value: 'CN-JS',
            labelcz: 'Jiangsu'
        },
        {
            value: 'CN-JX',
            labelcz: 'Jiangxi'
        },
        {
            value: 'CN-LN',
            labelcz: 'Liaoning'
        },
        {
            value: 'CN-MO',
            labelcz: 'Macao'
        },
        {
            value: 'CN-NM',
            labelcz: 'Inner Mongolia'
        },
        {
            value: 'CN-NX',
            labelcz: 'Ningxia Hui'
        },
        {
            value: 'CN-QH',
            labelcz: 'Qinghai'
        },
        {
            value: 'CN-SC',
            labelcz: 'Sichuan'
        },
        {
            value: 'CN-SD',
            labelcz: 'Shandong'
        },
        {
            value: 'CN-SH',
            labelcz: 'Shanghai'
        },
        {
            value: 'CN-SN',
            labelcz: 'Shaanxi'
        },
        {
            value: 'CN-SX',
            labelcz: 'Shanxi'
        },
        {
            value: 'CN-TJ',
            labelcz: 'Tianjin'
        },
        {
            value: 'CN-XJ',
            labelcz: 'Xinjiang Uyghur'
        },
        {
            value: 'CN-XZ',
            labelcz: 'Xizang (Tibet)'
        },
        {
            value: 'CN-YN',
            labelcz: 'Yunnan'
        },
        {
            value: 'CN-ZJ',
            labelcz: 'Zhejiang'
        }
    ],
    CY: [
        {
            value: 'CY-04',
            labelcz: 'Ammochostos'
        },
        {
            value: 'CY-06',
            labelcz: 'Keryneia'
        },
        {
            value: 'CY-03',
            labelcz: 'Larnaka'
        },
        {
            value: 'CY-01',
            labelcz: 'Lefkosia'
        },
        {
            value: 'CY-02',
            labelcz: 'Lemesos'
        },
        {
            value: 'CY-05',
            labelcz: 'Pafos'
        }
    ],
    CZ: [
        {
            value: 'CZ-31',
            labelcz: 'Jihočeský kraj'
        },
        {
            value: 'CZ-64',
            labelcz: 'Jihomoravský kraj'
        },
        {
            value: 'CZ-41',
            labelcz: 'Karlovarský kraj'
        },
        {
            value: 'CZ-52',
            labelcz: 'Královéhradecký kraj'
        },
        {
            value: 'CZ-51',
            labelcz: 'Liberecký kraj'
        },
        {
            value: 'CZ-80',
            labelcz: 'Moravskoslezský kraj'
        },
        {
            value: 'CZ-71',
            labelcz: 'Olomoucký kraj'
        },
        {
            value: 'CZ-53',
            labelcz: 'Pardubický kraj'
        },
        {
            value: 'CZ-32',
            labelcz: 'Plzeňský kraj'
        },
        {
            value: 'CZ-10',
            labelcz: 'Praha, Hlavní město'
        },
        {
            value: 'CZ-20',
            labelcz: 'Středočeský kraj'
        },
        {
            value: 'CZ-42',
            labelcz: 'Ústecký kraj'
        },
        {
            value: 'CZ-63',
            labelcz: 'Kraj Vysočina'
        },
        {
            value: 'CZ-72',
            labelcz: 'Zlínský kraj'
        }
    ],
    DE: [
        {
            value: 'DE-BW',
            labelcz: 'Baden-Württemberg'
        },
        {
            value: 'DE-BY',
            labelcz: 'Bayern'
        },
        {
            value: 'DE-BE',
            labelcz: 'Berlin'
        },
        {
            value: 'DE-BB',
            labelcz: 'Brandenburg'
        },
        {
            value: 'DE-HB',
            labelcz: 'Bremen'
        },
        {
            value: 'DE-HH',
            labelcz: 'Hamburg'
        },
        {
            value: 'DE-HE',
            labelcz: 'Hessen'
        },
        {
            value: 'DE-MV',
            labelcz: 'Mecklenburg-Vorpommern'
        },
        {
            value: 'DE-NI',
            labelcz: 'Niedersachsen'
        },
        {
            value: 'DE-NW',
            labelcz: 'Nordrhein-Westfalen'
        },
        {
            value: 'DE-RP',
            labelcz: 'Rheinland-Pfalz'
        },
        {
            value: 'DE-SL',
            labelcz: 'Saarland'
        },
        {
            value: 'DE-SN',
            labelcz: 'Sachsen'
        },
        {
            value: 'DE-ST',
            labelcz: 'Sachsen-Anhalt'
        },
        {
            value: 'DE-SH',
            labelcz: 'Schleswig-Holstein'
        },
        {
            value: 'DE-TH',
            labelcz: 'Thüringen'
        }
    ],
    EE: [
        {
            value: 'EE-37',
            labelcz: 'Harjumaa'
        },
        {
            value: 'EE-39',
            labelcz: 'Hiiumaa'
        },
        {
            value: 'EE-45',
            labelcz: 'Ida-Virumaa'
        },
        {
            value: 'EE-50',
            labelcz: 'Jõgevamaa'
        },
        {
            value: 'EE-52',
            labelcz: 'Järvamaa'
        },
        {
            value: 'EE-56',
            labelcz: 'Läänemaa'
        },
        {
            value: 'EE-60',
            labelcz: 'Lääne-Virumaa'
        },
        {
            value: 'EE-64',
            labelcz: 'Põlvamaa'
        },
        {
            value: 'EE-68',
            labelcz: 'Pärnumaa'
        },
        {
            value: 'EE-71',
            labelcz: 'Raplamaa'
        },
        {
            value: 'EE-74',
            labelcz: 'Saaremaa'
        },
        {
            value: 'EE-79',
            labelcz: 'Tartumaa'
        },
        {
            value: 'EE-81',
            labelcz: 'Valgamaa'
        },
        {
            value: 'EE-84',
            labelcz: 'Viljandimaa'
        },
        {
            value: 'EE-87',
            labelcz: 'Võrumaa'
        }
    ],
    ES: [
        {
            value: 'ES-A',
            labelcz: 'Alicante'
        },
        {
            value: 'ES-AB',
            labelcz: 'Albacete'
        },
        {
            value: 'ES-AL',
            labelcz: 'Almería'
        },
        {
            value: 'ES-AN',
            labelcz: 'Andalucía'
        },
        {
            value: 'ES-AR',
            labelcz: 'Aragón'
        },
        {
            value: 'ES-AS',
            labelcz: 'Asturias, Principado de'
        },
        {
            value: 'ES-AV',
            labelcz: 'Ávila'
        },
        {
            value: 'ES-B',
            labelcz: 'Barcelona'
        },
        {
            value: 'ES-BA',
            labelcz: 'Badajoz'
        },
        {
            value: 'ES-BI',
            labelcz: 'Bizkaia'
        },
        {
            value: 'ES-BU',
            labelcz: 'Burgos'
        },
        {
            value: 'ES-C',
            labelcz: 'A Coruña'
        },
        {
            value: 'ES-CA',
            labelcz: 'Cádiz'
        },
        {
            value: 'ES-CB',
            labelcz: 'Cantabria'
        },
        {
            value: 'ES-CC',
            labelcz: 'Cáceres'
        },
        {
            value: 'ES-CE',
            labelcz: 'Ceuta'
        },
        {
            value: 'ES-CL',
            labelcz: 'Castilla y León'
        },
        {
            value: 'ES-CM',
            labelcz: 'Castilla-La Mancha'
        },
        {
            value: 'ES-CN',
            labelcz: 'Canarias'
        },
        {
            value: 'ES-CO',
            labelcz: 'Córdoba'
        },
        {
            value: 'ES-CR',
            labelcz: 'Ciudad Real'
        },
        {
            value: 'ES-CS',
            labelcz: 'Castellón'
        },
        {
            value: 'ES-CT',
            labelcz: 'Cataluña'
        },
        {
            value: 'ES-CU',
            labelcz: 'Cuenca'
        },
        {
            value: 'ES-EX',
            labelcz: 'Extremadura'
        },
        {
            value: 'ES-GA',
            labelcz: 'Galicia'
        },
        {
            value: 'ES-GC',
            labelcz: 'Las Palmas'
        },
        {
            value: 'ES-GI',
            labelcz: 'Girona'
        },
        {
            value: 'ES-GR',
            labelcz: 'Granada'
        },
        {
            value: 'ES-GU',
            labelcz: 'Guadalajara'
        },
        {
            value: 'ES-H',
            labelcz: 'Huelva'
        },
        {
            value: 'ES-HU',
            labelcz: 'Huesca'
        },
        {
            value: 'ES-IB',
            labelcz: 'Illes Balears'
        },
        {
            value: 'ES-J',
            labelcz: 'Jaén'
        },
        {
            value: 'ES-L',
            labelcz: 'Lleida'
        },
        {
            value: 'ES-LE',
            labelcz: 'León'
        },
        {
            value: 'ES-LO',
            labelcz: 'La Rioja'
        },
        {
            value: 'ES-LU',
            labelcz: 'Lugo'
        },
        {
            value: 'ES-M',
            labelcz: 'Madrid'
        },
        {
            value: 'ES-MA',
            labelcz: 'Málaga'
        },
        {
            value: 'ES-MC',
            labelcz: 'Murcia, Región de'
        },
        {
            value: 'ES-MD',
            labelcz: 'Madrid, Comunidad de'
        },
        {
            value: 'ES-ML',
            labelcz: 'Melilla'
        },
        {
            value: 'ES-MU',
            labelcz: 'Murcia'
        },
        {
            value: 'ES-NA',
            labelcz: 'Navarra'
        },
        {
            value: 'ES-NC',
            labelcz: 'Navarra, Comunidad Foral de'
        },
        {
            value: 'ES-O',
            labelcz: 'Asturias'
        },
        {
            value: 'ES-OR',
            labelcz: 'Ourense'
        },
        {
            value: 'ES-P',
            labelcz: 'Palencia'
        },
        {
            value: 'ES-PM',
            labelcz: 'Illes Balears'
        },
        {
            value: 'ES-PO',
            labelcz: 'Pontevedra'
        },
        {
            value: 'ES-PV',
            labelcz: 'País Vasco'
        },
        {
            value: 'ES-RI',
            labelcz: 'La Rioja'
        },
        {
            value: 'ES-S',
            labelcz: 'Cantabria'
        },
        {
            value: 'ES-SA',
            labelcz: 'Salamanca'
        },
        {
            value: 'ES-SE',
            labelcz: 'Sevilla'
        },
        {
            value: 'ES-SG',
            labelcz: 'Segovia'
        },
        {
            value: 'ES-SO',
            labelcz: 'Soria'
        },
        {
            value: 'ES-SS',
            labelcz: 'Gipuzkoa'
        },
        {
            value: 'ES-T',
            labelcz: 'Tarragona'
        },
        {
            value: 'ES-TE',
            labelcz: 'Teruel'
        },
        {
            value: 'ES-TF',
            labelcz: 'Santa Cruz de Tenerife'
        },
        {
            value: 'ES-TO',
            labelcz: 'Toledo'
        },
        {
            value: 'ES-V',
            labelcz: 'Valencia'
        },
        {
            value: 'ES-VA',
            labelcz: 'Valladolid'
        },
        {
            value: 'ES-VC',
            labelcz: 'Valenciana, Comunitat'
        },
        {
            value: 'ES-VI',
            labelcz: 'Álava'
        },
        {
            value: 'ES-Z',
            labelcz: 'Zaragoza'
        },
        {
            value: 'ES-ZA',
            labelcz: 'Zamora'
        }
    ],

    FR: [
        {
            value: 'FR-ARA',
            labelcz: 'Auvergne-Rhône-Alpes'
        },
        {
            value: 'FR-BFC',
            labelcz: 'Bourgogne-Franche-Comté'
        },
        {
            value: 'FR-BRE',
            labelcz: 'Bretagne'
        },
        {
            value: 'FR-CVL',
            labelcz: 'Centre-Val de Loire'
        },
        {
            value: 'FR-GES',
            labelcz: 'Grand Est'
        },
        {
            value: 'FR-HDF',
            labelcz: 'Hauts-de-France'
        },
        {
            value: 'FR-IDF',
            labelcz: 'Île-de-France'
        },
        {
            value: 'FR-NAQ',
            labelcz: 'Nouvelle-Aquitaine'
        },
        {
            value: 'FR-NOR',
            labelcz: 'Normandie'
        },
        {
            value: 'FR-OCC',
            labelcz: 'Occitanie'
        },
        {
            value: 'FR-PAC',
            labelcz: "Provence-Alpes-Côte d'Azur"
        },
        {
            value: 'FR-PDL',
            labelcz: 'Pays de la Loire'
        },
        {
            value: 'FR-01',
            labelcz: 'Ain'
        },
        {
            value: 'FR-02',
            labelcz: 'Aisne'
        },
        {
            value: 'FR-03',
            labelcz: 'Allier'
        },
        {
            value: 'FR-04',
            labelcz: 'Alpes-de-Haute-Provence'
        },
        {
            value: 'FR-05',
            labelcz: 'Hautes-Alpes'
        },
        {
            value: 'FR-06',
            labelcz: 'Alpes-Maritimes'
        },
        {
            value: 'FR-07',
            labelcz: 'Ardèche'
        },
        {
            value: 'FR-08',
            labelcz: 'Ardennes'
        },
        {
            value: 'FR-09',
            labelcz: 'Ariège'
        },
        {
            value: 'FR-10',
            labelcz: 'Aube'
        },
        {
            value: 'FR-11',
            labelcz: 'Aude'
        },
        {
            value: 'FR-12',
            labelcz: 'Aveyron'
        },
        {
            value: 'FR-13',
            labelcz: 'Bouches-du-Rhône'
        },
        {
            value: 'FR-14',
            labelcz: 'Calvados'
        },
        {
            value: 'FR-15',
            labelcz: 'Cantal'
        },
        {
            value: 'FR-16',
            labelcz: 'Charente'
        },
        {
            value: 'FR-17',
            labelcz: 'Charente-Maritime'
        },
        {
            value: 'FR-18',
            labelcz: 'Cher'
        },
        {
            value: 'FR-19',
            labelcz: 'Corrèze'
        },
        {
            value: 'FR-2A',
            labelcz: 'Corse-du-Sud'
        },
        {
            value: 'FR-2B',
            labelcz: 'Haute-Corse'
        },
        {
            value: 'FR-20R',
            labelcz: 'Corse'
        },
        {
            value: 'FR-21',
            labelcz: "Côte-d'Or"
        },
        {
            value: 'FR-22',
            labelcz: "Côtes-d'Armor"
        },
        {
            value: 'FR-23',
            labelcz: 'Creuse'
        },
        {
            value: 'FR-24',
            labelcz: 'Dordogne'
        },
        {
            value: 'FR-25',
            labelcz: 'Doubs'
        },
        {
            value: 'FR-26',
            labelcz: 'Drôme'
        },
        {
            value: 'FR-27',
            labelcz: 'Eure'
        },
        {
            value: 'FR-28',
            labelcz: 'Eure-et-Loir'
        },
        {
            value: 'FR-29',
            labelcz: 'Finistère'
        },
        {
            value: 'FR-30',
            labelcz: 'Gard'
        },
        {
            value: 'FR-31',
            labelcz: 'Haute-Garonne'
        },
        {
            value: 'FR-32',
            labelcz: 'Gers'
        },
        {
            value: 'FR-33',
            labelcz: 'Gironde'
        },
        {
            value: 'FR-34',
            labelcz: 'Hérault'
        },
        {
            value: 'FR-35',
            labelcz: 'Ille-et-Vilaine'
        },
        {
            value: 'FR-36',
            labelcz: 'Indre'
        },
        {
            value: 'FR-37',
            labelcz: 'Indre-et-Loire'
        },
        {
            value: 'FR-38',
            labelcz: 'Isère'
        },
        {
            value: 'FR-39',
            labelcz: 'Jura'
        },
        {
            value: 'FR-40',
            labelcz: 'Landes'
        },
        {
            value: 'FR-41',
            labelcz: 'Loir-et-Cher'
        },
        {
            value: 'FR-42',
            labelcz: 'Loire'
        },
        {
            value: 'FR-43',
            labelcz: 'Haute-Loire'
        },
        {
            value: 'FR-44',
            labelcz: 'Loire-Atlantique'
        },
        {
            value: 'FR-45',
            labelcz: 'Loiret'
        },
        {
            value: 'FR-46',
            labelcz: 'Lot'
        },
        {
            value: 'FR-47',
            labelcz: 'Lot-et-Garonne'
        },
        {
            value: 'FR-48',
            labelcz: 'Lozère'
        },
        {
            value: 'FR-49',
            labelcz: 'Maine-et-Loire'
        },
        {
            value: 'FR-50',
            labelcz: 'Manche'
        },
        {
            value: 'FR-51',
            labelcz: 'Marne'
        },
        {
            value: 'FR-52',
            labelcz: 'Haute-Marne'
        },
        {
            value: 'FR-53',
            labelcz: 'Mayenne'
        },
        {
            value: 'FR-54',
            labelcz: 'Meurthe-et-Moselle'
        },
        {
            value: 'FR-55',
            labelcz: 'Meuse'
        },
        {
            value: 'FR-56',
            labelcz: 'Morbihan'
        },
        {
            value: 'FR-57',
            labelcz: 'Moselle'
        },
        {
            value: 'FR-58',
            labelcz: 'Nièvre'
        },
        {
            value: 'FR-59',
            labelcz: 'Nord'
        },
        {
            value: 'FR-6AE',
            labelcz: 'Alsace'
        },
        {
            value: 'FR-60',
            labelcz: 'Oise'
        },
        {
            value: 'FR-61',
            labelcz: 'Orne'
        },
        {
            value: 'FR-62',
            labelcz: 'Pas-de-Calais'
        },
        {
            value: 'FR-63',
            labelcz: 'Puy-de-Dôme'
        },
        {
            value: 'FR-64',
            labelcz: 'Pyrénées-Atlantiques'
        },
        {
            value: 'FR-65',
            labelcz: 'Hautes-Pyrénées'
        },
        {
            value: 'FR-66',
            labelcz: 'Pyrénées-Orientales'
        },
        {
            value: 'FR-67',
            labelcz: 'Bas-Rhin'
        },
        {
            value: 'FR-68',
            labelcz: 'Haut-Rhin'
        },
        {
            value: 'FR-69',
            labelcz: 'Rhône'
        },
        {
            value: 'FR-69M',
            labelcz: 'Métropole de Lyon'
        },
        {
            value: 'FR-70',
            labelcz: 'Haute-Saône'
        },
        {
            value: 'FR-71',
            labelcz: 'Saône-et-Loire'
        },
        {
            value: 'FR-72',
            labelcz: 'Sarthe'
        },
        {
            value: 'FR-73',
            labelcz: 'Savoie'
        },
        {
            value: 'FR-74',
            labelcz: 'Haute-Savoie'
        },
        {
            value: 'FR-75C',
            labelcz: 'Paris'
        },
        {
            value: 'FR-76',
            labelcz: 'Seine-Maritime'
        },
        {
            value: 'FR-77',
            labelcz: 'Seine-et-Marne'
        },
        {
            value: 'FR-78',
            labelcz: 'Yvelines'
        },
        {
            value: 'FR-79',
            labelcz: 'Deux-Sèvres'
        },
        {
            value: 'FR-80',
            labelcz: 'Somme'
        },
        {
            value: 'FR-81',
            labelcz: 'Tarn'
        },
        {
            value: 'FR-82',
            labelcz: 'Tarn-et-Garonne'
        },
        {
            value: 'FR-83',
            labelcz: 'Var'
        },
        {
            value: 'FR-84',
            labelcz: 'Vaucluse'
        },
        {
            value: 'FR-85',
            labelcz: 'Vendée'
        },
        {
            value: 'FR-86',
            labelcz: 'Vienne'
        },
        {
            value: 'FR-87',
            labelcz: 'Haute-Vienne'
        },
        {
            value: 'FR-88',
            labelcz: 'Vosges'
        },
        {
            value: 'FR-89',
            labelcz: 'Yonne'
        },
        {
            value: 'FR-90',
            labelcz: 'Territoire de Belfort'
        },
        {
            value: 'FR-91',
            labelcz: 'Essonne'
        },
        {
            value: 'FR-92',
            labelcz: 'Hauts-de-Seine'
        },
        {
            value: 'FR-93',
            labelcz: 'Seine-Saint-Denis'
        },
        {
            value: 'FR-94',
            labelcz: 'Val-de-Marne'
        },
        {
            value: 'FR-95',
            labelcz: "Val-d'Oise"
        },
        {
            value: 'FR-971',
            labelcz: 'Guadeloupe'
        },
        {
            value: 'FR-972',
            labelcz: 'Martinique'
        },
        {
            value: 'FR-973',
            labelcz: 'Guyane'
        },
        {
            value: 'FR-974',
            labelcz: 'La Réunion'
        },
        {
            value: 'FR-976',
            labelcz: 'Mayotte'
        }
    ],
    GB: [
        {
            value: 'GB-ABC',
            labelcz: 'Armagh City, Banbridge and Craigavon'
        },
        {
            value: 'GB-ABD',
            labelcz: 'Aberdeenshire'
        },
        {
            value: 'GB-ABE',
            labelcz: 'Aberdeen City'
        },
        {
            value: 'GB-AGB',
            labelcz: 'Argyll and Bute'
        },
        {
            value: 'GB-AGY',
            labelcz: 'Isle of Anglesey'
        },
        {
            value: 'GB-AND',
            labelcz: 'Ards and North Down'
        },
        {
            value: 'GB-ANN',
            labelcz: 'Antrim and Newtownabbey'
        },
        {
            value: 'GB-ANS',
            labelcz: 'Angus'
        },
        {
            value: 'GB-BAS',
            labelcz: 'Bath and North East Somerset'
        },
        {
            value: 'GB-BBD',
            labelcz: 'Blackburn with Darwen'
        },
        {
            value: 'GB-BCP',
            labelcz: 'Bournemouth, Christchurch and Poole'
        },
        {
            value: 'GB-BDF',
            labelcz: 'Bedford'
        },
        {
            value: 'GB-BDG',
            labelcz: 'Barking and Dagenham'
        },
        {
            value: 'GB-BEN',
            labelcz: 'Brent'
        },
        {
            value: 'GB-BEX',
            labelcz: 'Bexley'
        },
        {
            value: 'GB-BFS',
            labelcz: 'Belfast City'
        },
        {
            value: 'GB-BGE',
            labelcz: 'Bridgend'
        },
        {
            value: 'GB-BGW',
            labelcz: 'Blaenau Gwent'
        },
        {
            value: 'GB-BIR',
            labelcz: 'Birmingham'
        },
        {
            value: 'GB-BKM',
            labelcz: 'Buckinghamshire'
        },
        {
            value: 'GB-BNE',
            labelcz: 'Barnet'
        },
        {
            value: 'GB-BNH',
            labelcz: 'Brighton and Hove'
        },
        {
            value: 'GB-BNS',
            labelcz: 'Barnsley'
        },
        {
            value: 'GB-BOL',
            labelcz: 'Bolton'
        },
        {
            value: 'GB-BPL',
            labelcz: 'Blackpool'
        },
        {
            value: 'GB-BRC',
            labelcz: 'Bracknell Forest'
        },
        {
            value: 'GB-BRD',
            labelcz: 'Bradford'
        },
        {
            value: 'GB-BRY',
            labelcz: 'Bromley'
        },
        {
            value: 'GB-BST',
            labelcz: 'Bristol, City of'
        },
        {
            value: 'GB-BUR',
            labelcz: 'Bury'
        },
        {
            value: 'GB-CAM',
            labelcz: 'Cambridgeshire'
        },
        {
            value: 'GB-CAY',
            labelcz: 'Caerphilly'
        },
        {
            value: 'GB-CBF',
            labelcz: 'Central Bedfordshire'
        },
        {
            value: 'GB-CCG',
            labelcz: 'Causeway Coast and Glens'
        },
        {
            value: 'GB-CGN',
            labelcz: 'Ceredigion'
        },
        {
            value: 'GB-CLD',
            labelcz: 'Calderdale'
        },
        {
            value: 'GB-CLK',
            labelcz: 'Clackmannanshire'
        },
        {
            value: 'GB-CMA',
            labelcz: 'Cumbria'
        },
        {
            value: 'GB-CMD',
            labelcz: 'Camden'
        },
        {
            value: 'GB-CMN',
            labelcz: 'Carmarthenshire'
        },
        {
            value: 'GB-CON',
            labelcz: 'Cornwall'
        },
        {
            value: 'GB-COV',
            labelcz: 'Coventry'
        },
        {
            value: 'GB-CRF',
            labelcz: 'Cardiff'
        },
        {
            value: 'GB-CRY',
            labelcz: 'Croydon'
        },
        {
            value: 'GB-CWY',
            labelcz: 'Conwy'
        },
        {
            value: 'GB-DAL',
            labelcz: 'Darlington'
        },
        {
            value: 'GB-DBY',
            labelcz: 'Derbyshire'
        },
        {
            value: 'GB-DEN',
            labelcz: 'Denbighshire'
        },
        {
            value: 'GB-DER',
            labelcz: 'Derby'
        },
        {
            value: 'GB-DEV',
            labelcz: 'Devon'
        },
        {
            value: 'GB-DGY',
            labelcz: 'Dumfries and Galloway'
        },
        {
            value: 'GB-DNC',
            labelcz: 'Doncaster'
        },
        {
            value: 'GB-DND',
            labelcz: 'Dundee City'
        },
        {
            value: 'GB-DOR',
            labelcz: 'Dorset'
        },
        {
            value: 'GB-DRS',
            labelcz: 'Derry and Strabane'
        },
        {
            value: 'GB-DUD',
            labelcz: 'Dudley'
        },
        {
            value: 'GB-DUR',
            labelcz: 'Durham, County'
        },
        {
            value: 'GB-EAL',
            labelcz: 'Ealing'
        },
        {
            value: 'GB-EAY',
            labelcz: 'East Ayrshire'
        },
        {
            value: 'GB-EDH',
            labelcz: 'Edinburgh, City of'
        },
        {
            value: 'GB-EDU',
            labelcz: 'East Dunbartonshire'
        },
        {
            value: 'GB-ELN',
            labelcz: 'East Lothian'
        },
        {
            value: 'GB-ELS',
            labelcz: 'Eilean Siar'
        },
        {
            value: 'GB-ENF',
            labelcz: 'Enfield'
        },
        {
            value: 'GB-ENG',
            labelcz: 'England'
        },
        {
            value: 'GB-ERW',
            labelcz: 'East Renfrewshire'
        },
        {
            value: 'GB-ERY',
            labelcz: 'East Riding of Yorkshire'
        },
        {
            value: 'GB-ESS',
            labelcz: 'Essex'
        },
        {
            value: 'GB-ESX',
            labelcz: 'East Sussex'
        },
        {
            value: 'GB-FAL',
            labelcz: 'Falkirk'
        },
        {
            value: 'GB-FIF',
            labelcz: 'Fife'
        },
        {
            value: 'GB-FLN',
            labelcz: 'Flintshire'
        },
        {
            value: 'GB-FMO',
            labelcz: 'Fermanagh and Omagh'
        },
        {
            value: 'GB-GAT',
            labelcz: 'Gateshead'
        },
        {
            value: 'GB-GLG',
            labelcz: 'Glasgow City'
        },
        {
            value: 'GB-GLS',
            labelcz: 'Gloucestershire'
        },
        {
            value: 'GB-GRE',
            labelcz: 'Greenwich'
        },
        {
            value: 'GB-GWN',
            labelcz: 'Gwynedd'
        },
        {
            value: 'GB-HAL',
            labelcz: 'Halton'
        },
        {
            value: 'GB-HAM',
            labelcz: 'Hampshire'
        },
        {
            value: 'GB-HAV',
            labelcz: 'Havering'
        },
        {
            value: 'GB-HCK',
            labelcz: 'Hackney'
        },
        {
            value: 'GB-HEF',
            labelcz: 'Herefordshire'
        },
        {
            value: 'GB-HIL',
            labelcz: 'Hillingdon'
        },
        {
            value: 'GB-HLD',
            labelcz: 'Highland'
        },
        {
            value: 'GB-HMF',
            labelcz: 'Hammersmith and Fulham'
        },
        {
            value: 'GB-HNS',
            labelcz: 'Hounslow'
        },
        {
            value: 'GB-HPL',
            labelcz: 'Hartlepool'
        },
        {
            value: 'GB-HRT',
            labelcz: 'Hertfordshire'
        },
        {
            value: 'GB-HRW',
            labelcz: 'Harrow'
        },
        {
            value: 'GB-HRY',
            labelcz: 'Haringey'
        },
        {
            value: 'GB-CHE',
            labelcz: 'Cheshire East'
        },
        {
            value: 'GB-CHW',
            labelcz: 'Cheshire West and Chester'
        },
        {
            value: 'GB-IOS',
            labelcz: 'Isles of Scilly'
        },
        {
            value: 'GB-IOW',
            labelcz: 'Isle of Wight'
        },
        {
            value: 'GB-ISL',
            labelcz: 'Islington'
        },
        {
            value: 'GB-IVC',
            labelcz: 'Inverclyde'
        },
        {
            value: 'GB-KEC',
            labelcz: 'Kensington and Chelsea'
        },
        {
            value: 'GB-KEN',
            labelcz: 'Kent'
        },
        {
            value: 'GB-KHL',
            labelcz: 'Kingston upon Hull'
        },
        {
            value: 'GB-KIR',
            labelcz: 'Kirklees'
        },
        {
            value: 'GB-KTT',
            labelcz: 'Kingston upon Thames'
        },
        {
            value: 'GB-KWL',
            labelcz: 'Knowsley'
        },
        {
            value: 'GB-LAN',
            labelcz: 'Lancashire'
        },
        {
            value: 'GB-LBC',
            labelcz: 'Lisburn and Castlereagh'
        },
        {
            value: 'GB-LBH',
            labelcz: 'Lambeth'
        },
        {
            value: 'GB-LCE',
            labelcz: 'Leicester'
        },
        {
            value: 'GB-LDS',
            labelcz: 'Leeds'
        },
        {
            value: 'GB-LEC',
            labelcz: 'Leicestershire'
        },
        {
            value: 'GB-LEW',
            labelcz: 'Lewisham'
        },
        {
            value: 'GB-LIN',
            labelcz: 'Lincolnshire'
        },
        {
            value: 'GB-LIV',
            labelcz: 'Liverpool'
        },
        {
            value: 'GB-LND',
            labelcz: 'London, City of'
        },
        {
            value: 'GB-LUT',
            labelcz: 'Luton'
        },
        {
            value: 'GB-MAN',
            labelcz: 'Manchester'
        },
        {
            value: 'GB-MDB',
            labelcz: 'Middlesbrough'
        },
        {
            value: 'GB-MDW',
            labelcz: 'Medway'
        },
        {
            value: 'GB-MEA',
            labelcz: 'Mid and East Antrim'
        },
        {
            value: 'GB-MIK',
            labelcz: 'Milton Keynes'
        },
        {
            value: 'GB-MLN',
            labelcz: 'Midlothian'
        },
        {
            value: 'GB-MON',
            labelcz: 'Monmouthshire'
        },
        {
            value: 'GB-MRT',
            labelcz: 'Merton'
        },
        {
            value: 'GB-MRY',
            labelcz: 'Moray'
        },
        {
            value: 'GB-MTY',
            labelcz: 'Merthyr Tydfil'
        },
        {
            value: 'GB-MUL',
            labelcz: 'Mid-Ulster'
        },
        {
            value: 'GB-NAY',
            labelcz: 'North Ayrshire'
        },
        {
            value: 'GB-NBL',
            labelcz: 'Northumberland'
        },
        {
            value: 'GB-NEL',
            labelcz: 'North East Lincolnshire'
        },
        {
            value: 'GB-NET',
            labelcz: 'Newcastle upon Tyne'
        },
        {
            value: 'GB-NFK',
            labelcz: 'Norfolk'
        },
        {
            value: 'GB-NGM',
            labelcz: 'Nottingham'
        },
        {
            value: 'GB-NIR',
            labelcz: 'Northern Ireland'
        },
        {
            value: 'GB-NLK',
            labelcz: 'North Lanarkshire'
        },
        {
            value: 'GB-NLN',
            labelcz: 'North Lincolnshire'
        },
        {
            value: 'GB-NMD',
            labelcz: 'Newry, Mourne and Down'
        },
        {
            value: 'GB-NNH',
            labelcz: 'North Northamptonshire'
        },
        {
            value: 'GB-NSM',
            labelcz: 'North Somerset'
        },
        {
            value: 'GB-NTL',
            labelcz: 'Neath Port Talbot'
        },
        {
            value: 'GB-NTT',
            labelcz: 'Nottinghamshire'
        },
        {
            value: 'GB-NTY',
            labelcz: 'North Tyneside'
        },
        {
            value: 'GB-NWM',
            labelcz: 'Newham'
        },
        {
            value: 'GB-NWP',
            labelcz: 'Newport'
        },
        {
            value: 'GB-NYK',
            labelcz: 'North Yorkshire'
        },
        {
            value: 'GB-OLD',
            labelcz: 'Oldham'
        },
        {
            value: 'GB-ORK',
            labelcz: 'Orkney Islands'
        },
        {
            value: 'GB-OXF',
            labelcz: 'Oxfordshire'
        },
        {
            value: 'GB-PEM',
            labelcz: 'Pembrokeshire'
        },
        {
            value: 'GB-PKN',
            labelcz: 'Perth and Kinross'
        },
        {
            value: 'GB-PLY',
            labelcz: 'Plymouth'
        },
        {
            value: 'GB-POR',
            labelcz: 'Portsmouth'
        },
        {
            value: 'GB-POW',
            labelcz: 'Powys'
        },
        {
            value: 'GB-PTE',
            labelcz: 'Peterborough'
        },
        {
            value: 'GB-RCC',
            labelcz: 'Redcar and Cleveland'
        },
        {
            value: 'GB-RCT',
            labelcz: 'Rhondda Cynon Taff'
        },
        {
            value: 'GB-RDB',
            labelcz: 'Redbridge'
        },
        {
            value: 'GB-RDG',
            labelcz: 'Reading'
        },
        {
            value: 'GB-RFW',
            labelcz: 'Renfrewshire'
        },
        {
            value: 'GB-RCH',
            labelcz: 'Rochdale'
        },
        {
            value: 'GB-RIC',
            labelcz: 'Richmond upon Thames'
        },
        {
            value: 'GB-ROT',
            labelcz: 'Rotherham'
        },
        {
            value: 'GB-RUT',
            labelcz: 'Rutland'
        },
        {
            value: 'GB-SAW',
            labelcz: 'Sandwell'
        },
        {
            value: 'GB-SAY',
            labelcz: 'South Ayrshire'
        },
        {
            value: 'GB-SCB',
            labelcz: 'Scottish Borders'
        },
        {
            value: 'GB-SCT',
            labelcz: 'Scotland'
        },
        {
            value: 'GB-SFK',
            labelcz: 'Suffolk'
        },
        {
            value: 'GB-SFT',
            labelcz: 'Sefton'
        },
        {
            value: 'GB-SGC',
            labelcz: 'South Gloucestershire'
        },
        {
            value: 'GB-SHF',
            labelcz: 'Sheffield'
        },
        {
            value: 'GB-SHN',
            labelcz: 'St. Helens'
        },
        {
            value: 'GB-SHR',
            labelcz: 'Shropshire'
        },
        {
            value: 'GB-SKP',
            labelcz: 'Stockport'
        },
        {
            value: 'GB-SLF',
            labelcz: 'Salford'
        },
        {
            value: 'GB-SLG',
            labelcz: 'Slough'
        },
        {
            value: 'GB-SLK',
            labelcz: 'South Lanarkshire'
        },
        {
            value: 'GB-SND',
            labelcz: 'Sunderland'
        },
        {
            value: 'GB-SOL',
            labelcz: 'Solihull'
        },
        {
            value: 'GB-SOM',
            labelcz: 'Somerset'
        },
        {
            value: 'GB-SOS',
            labelcz: 'Southend-on-Sea'
        },
        {
            value: 'GB-SRY',
            labelcz: 'Surrey'
        },
        {
            value: 'GB-STE',
            labelcz: 'Stoke-on-Trent'
        },
        {
            value: 'GB-STG',
            labelcz: 'Stirling'
        },
        {
            value: 'GB-STH',
            labelcz: 'Southampton'
        },
        {
            value: 'GB-STN',
            labelcz: 'Sutton'
        },
        {
            value: 'GB-STS',
            labelcz: 'Staffordshire'
        },
        {
            value: 'GB-STT',
            labelcz: 'Stockton-on-Tees'
        },
        {
            value: 'GB-STY',
            labelcz: 'South Tyneside'
        },
        {
            value: 'GB-SWA',
            labelcz: 'Swansea'
        },
        {
            value: 'GB-SWD',
            labelcz: 'Swindon'
        },
        {
            value: 'GB-SWK',
            labelcz: 'Southwark'
        },
        {
            value: 'GB-TAM',
            labelcz: 'Tameside'
        },
        {
            value: 'GB-TFW',
            labelcz: 'Telford and Wrekin'
        },
        {
            value: 'GB-THR',
            labelcz: 'Thurrock'
        },
        {
            value: 'GB-TOB',
            labelcz: 'Torbay'
        },
        {
            value: 'GB-TOF',
            labelcz: 'Torfaen'
        },
        {
            value: 'GB-TRF',
            labelcz: 'Trafford'
        },
        {
            value: 'GB-TWH',
            labelcz: 'Tower Hamlets'
        },
        {
            value: 'GB-VGL',
            labelcz: 'Vale of Glamorgan, The'
        },
        {
            value: 'GB-WAR',
            labelcz: 'Warwickshire'
        },
        {
            value: 'GB-WBK',
            labelcz: 'West Berkshire'
        },
        {
            value: 'GB-WDU',
            labelcz: 'West Dunbartonshire'
        },
        {
            value: 'GB-WFT',
            labelcz: 'Waltham Forest'
        },
        {
            value: 'GB-WGN',
            labelcz: 'Wigan'
        },
        {
            value: 'GB-WIL',
            labelcz: 'Wiltshire'
        },
        {
            value: 'GB-WKF',
            labelcz: 'Wakefield'
        },
        {
            value: 'GB-WLL',
            labelcz: 'Walsall'
        },
        {
            value: 'GB-WLN',
            labelcz: 'West Lothian'
        },
        {
            value: 'GB-WLS',
            labelcz: 'Wales'
        },
        {
            value: 'GB-WLV',
            labelcz: 'Wolverhampton'
        },
        {
            value: 'GB-WND',
            labelcz: 'Wandsworth'
        },
        {
            value: 'GB-WNH',
            labelcz: 'West Northamptonshire'
        },
        {
            value: 'GB-WNM',
            labelcz: 'Windsor and Maidenhead'
        },
        {
            value: 'GB-WOK',
            labelcz: 'Wokingham'
        },
        {
            value: 'GB-WOR',
            labelcz: 'Worcestershire'
        },
        {
            value: 'GB-WRL',
            labelcz: 'Wirral'
        },
        {
            value: 'GB-WRT',
            labelcz: 'Warrington'
        },
        {
            value: 'GB-WRX',
            labelcz: 'Wrexham'
        },
        {
            value: 'GB-WSM',
            labelcz: 'Westminster'
        },
        {
            value: 'GB-WSX',
            labelcz: 'West Sussex'
        },
        {
            value: 'GB-YOR',
            labelcz: 'York'
        },
        {
            value: 'GB-ZET',
            labelcz: 'Shetland Islands'
        }
    ],
    HR: [
        {
            value: 'HR-21',
            labelcz: 'Grad Zagreb'
        },
        {
            value: 'HR-07',
            labelcz: 'Bjelovarsko-bilogorska županija'
        },
        {
            value: 'HR-12',
            labelcz: 'Brodsko-posavska županija'
        },
        {
            value: 'HR-19',
            labelcz: 'Dubrovačko-neretvanska županija'
        },
        {
            value: 'HR-18',
            labelcz: 'Istarska županija'
        },
        {
            value: 'HR-04',
            labelcz: 'Karlovačka županija'
        },
        {
            value: 'HR-06',
            labelcz: 'Koprivničko-križevačka županija'
        },
        {
            value: 'HR-02',
            labelcz: 'Krapinsko-zagorska županija'
        },
        {
            value: 'HR-09',
            labelcz: 'Ličko-senjska županija'
        },
        {
            value: 'HR-20',
            labelcz: 'Međimurska županija'
        },
        {
            value: 'HR-14',
            labelcz: 'Osječko-baranjska županija'
        },
        {
            value: 'HR-11',
            labelcz: 'Požeško-slavonska županija'
        },
        {
            value: 'HR-08',
            labelcz: 'Primorsko-goranska županija'
        },
        {
            value: 'HR-03',
            labelcz: 'Sisačko-moslavačka županija'
        },
        {
            value: 'HR-17',
            labelcz: 'Splitsko-dalmatinska županija'
        },
        {
            value: 'HR-15',
            labelcz: 'Šibensko-kninska županija'
        },
        {
            value: 'HR-05',
            labelcz: 'Varaždinska županija'
        },
        {
            value: 'HR-10',
            labelcz: 'Virovitičko-podravska županija'
        },
        {
            value: 'HR-16',
            labelcz: 'Vukovarsko-srijemska županija'
        },
        {
            value: 'HR-13',
            labelcz: 'Zadarska županija'
        },
        {
            value: 'HR-01',
            labelcz: 'Zagrebačka županija'
        }
    ],
    HU: [
        {
            value: 'HU-BU',
            labelcz: 'Budapest'
        },
        {
            value: 'HU-BK',
            labelcz: 'Bács-Kiskun'
        },
        {
            value: 'HU-BA',
            labelcz: 'Baranya'
        },
        {
            value: 'HU-BE',
            labelcz: 'Békés'
        },
        {
            value: 'HU-BZ',
            labelcz: 'Borsod-Abaúj-Zemplén'
        },
        {
            value: 'HU-CS',
            labelcz: 'Csongrád'
        },
        {
            value: 'HU-FE',
            labelcz: 'Fejér'
        },
        {
            value: 'HU-GS',
            labelcz: 'Győr-Moson-Sopron'
        },
        {
            value: 'HU-HB',
            labelcz: 'Hajdú-Bihar'
        },
        {
            value: 'HU-HE',
            labelcz: 'Heves'
        },
        {
            value: 'HU-JN',
            labelcz: 'Jász-Nagykun-Szolnok'
        },
        {
            value: 'HU-KE',
            labelcz: 'Komárom-Esztergom'
        },
        {
            value: 'HU-NO',
            labelcz: 'Nógrád'
        },
        {
            value: 'HU-PE',
            labelcz: 'Pest'
        },
        {
            value: 'HU-SO',
            labelcz: 'Somogy'
        },
        {
            value: 'HU-SZ',
            labelcz: 'Szabolcs-Szatmár-Bereg'
        },
        {
            value: 'HU-TO',
            labelcz: 'Tolna'
        },
        {
            value: 'HU-VA',
            labelcz: 'Vas'
        },
        {
            value: 'HU-VE',
            labelcz: 'Veszprém'
        },
        {
            value: 'HU-ZA',
            labelcz: 'Zala'
        }
    ],
    CH: [
        {
            value: 'CH-AG',
            labelcz: 'Aargau (de)'
        },
        {
            value: 'CH-AR',
            labelcz: 'Appenzell Ausserrhoden (de)'
        },
        {
            value: 'CH-AI',
            labelcz: 'Appenzell Innerrhoden (de)'
        },
        {
            value: 'CH-BL',
            labelcz: 'Basel-Landschaft (de)'
        },
        {
            value: 'CH-BS',
            labelcz: 'Basel-Stadt (de)'
        },
        {
            value: 'CH-BE',
            labelcz: 'Bern (de), Berne (fr)'
        },
        {
            value: 'CH-FR',
            labelcz: 'Fribourg (fr), Freiburg (de)'
        },
        {
            value: 'CH-GE',
            labelcz: 'Genève (fr)'
        },
        {
            value: 'CH-GL',
            labelcz: 'Glarus (de)'
        },
        {
            value: 'CH-GR',
            labelcz: 'Graubünden (de), Grigioni (it), Grischun (rm)'
        },
        {
            value: 'CH-JU',
            labelcz: 'Jura (fr)'
        },
        {
            value: 'CH-LU',
            labelcz: 'Luzern (de)'
        },
        {
            value: 'CH-NE',
            labelcz: 'Neuchâtel (fr)'
        },
        {
            value: 'CH-NW',
            labelcz: 'Nidwalden (de)'
        },
        {
            value: 'CH-OW',
            labelcz: 'Obwalden (de)'
        },
        {
            value: 'CH-SG',
            labelcz: 'Sankt Gallen (de)'
        },
        {
            value: 'CH-SH',
            labelcz: 'Schaffhausen (de)'
        },
        {
            value: 'CH-SZ',
            labelcz: 'Schwyz (de)'
        },
        {
            value: 'CH-SO',
            labelcz: 'Solothurn (de)'
        },
        {
            value: 'CH-TG',
            labelcz: 'Thurgau (de)'
        },
        {
            value: 'CH-TI',
            labelcz: 'Ticino (it)'
        },
        {
            value: 'CH-UR',
            labelcz: 'Uri (de)'
        },
        {
            value: 'CH-VS',
            labelcz: 'Valais (fr), Wallis (de)'
        },
        {
            value: 'CH-VD',
            labelcz: 'Vaud (fr)'
        },
        {
            value: 'CH-ZG',
            labelcz: 'Zug (de)'
        },
        {
            value: 'CH-ZH',
            labelcz: 'Zürich (de)'
        }
    ],

    IE: [
        {
            value: 'IE-CW',
            labelcz: 'Carlow'
        },
        {
            value: 'IE-CN',
            labelcz: 'Cavan'
        },
        {
            value: 'IE-CE',
            labelcz: 'Clare'
        },
        {
            value: 'IE-CO',
            labelcz: 'Cork'
        },
        {
            value: 'IE-DL',
            labelcz: 'Donegal'
        },
        {
            value: 'IE-D',
            labelcz: 'Dublin'
        },
        {
            value: 'IE-G',
            labelcz: 'Galway'
        },
        {
            value: 'IE-KY',
            labelcz: 'Kerry'
        },
        {
            value: 'IE-KE',
            labelcz: 'Kildare'
        },
        {
            value: 'IE-KK',
            labelcz: 'Kilkenny'
        },
        {
            value: 'IE-LS',
            labelcz: 'Laois'
        },
        {
            value: 'IE-LM',
            labelcz: 'Leitrim'
        },
        {
            value: 'IE-LK',
            labelcz: 'Limerick'
        },
        {
            value: 'IE-LD',
            labelcz: 'Longford'
        },
        {
            value: 'IE-LH',
            labelcz: 'Louth'
        },
        {
            value: 'IE-MO',
            labelcz: 'Mayo'
        },
        {
            value: 'IE-MH',
            labelcz: 'Meath'
        },
        {
            value: 'IE-MN',
            labelcz: 'Monaghan'
        },
        {
            value: 'IE-OY',
            labelcz: 'Offaly'
        },
        {
            value: 'IE-RN',
            labelcz: 'Roscommon'
        },
        {
            value: 'IE-SO',
            labelcz: 'Sligo'
        },
        {
            value: 'IE-TA',
            labelcz: 'Tipperary'
        },
        {
            value: 'IE-WD',
            labelcz: 'Waterford'
        },
        {
            value: 'IE-WH',
            labelcz: 'Westmeath'
        },
        {
            value: 'IE-WX',
            labelcz: 'Wexford'
        },
        {
            value: 'IE-WW',
            labelcz: 'Wicklow'
        }
    ],
    IN: [
        {
            value: 'IN-AN',
            labelcz: 'Andaman and Nicobar Islands'
        },
        {
            value: 'IN-AP',
            labelcz: 'Andhra Pradesh'
        },
        {
            value: 'IN-AR',
            labelcz: 'Arunachal Pradesh'
        },
        {
            value: 'IN-AS',
            labelcz: 'Assam'
        },
        {
            value: 'IN-BR',
            labelcz: 'Bihar'
        },
        {
            value: 'IN-CT',
            labelcz: 'Chhattisgarh'
        },
        {
            value: 'IN-DH',
            labelcz: 'Dadra and Nagar Haveli and Daman and Diu'
        },
        {
            value: 'IN-DL',
            labelcz: 'Delhi'
        },
        {
            value: 'IN-GA',
            labelcz: 'Goa'
        },
        {
            value: 'IN-GJ',
            labelcz: 'Gujarat'
        },
        {
            value: 'IN-HP',
            labelcz: 'Himachal Pradesh'
        },
        {
            value: 'IN-HR',
            labelcz: 'Haryana'
        },
        {
            value: 'IN-CH',
            labelcz: 'Chandigarh'
        },
        {
            value: 'IN-JH',
            labelcz: 'Jharkhand'
        },
        {
            value: 'IN-JK',
            labelcz: 'Jammu and Kashmir'
        },
        {
            value: 'IN-KA',
            labelcz: 'Karnataka'
        },
        {
            value: 'IN-KL',
            labelcz: 'Kerala'
        },
        {
            value: 'IN-LA',
            labelcz: 'Ladakh'
        },
        {
            value: 'IN-LD',
            labelcz: 'Lakshadweep'
        },
        {
            value: 'IN-MH',
            labelcz: 'Maharashtra'
        },
        {
            value: 'IN-ML',
            labelcz: 'Meghalaya'
        },
        {
            value: 'IN-MN',
            labelcz: 'Manipur'
        },
        {
            value: 'IN-MP',
            labelcz: 'Madhya Pradesh'
        },
        {
            value: 'IN-MZ',
            labelcz: 'Mizoram'
        },
        {
            value: 'IN-NL',
            labelcz: 'Nagaland'
        },
        {
            value: 'IN-OR',
            labelcz: 'Odisha'
        },
        {
            value: 'IN-PB',
            labelcz: 'Punjab'
        },
        {
            value: 'IN-PY',
            labelcz: 'Puducherry'
        },
        {
            value: 'IN-RJ',
            labelcz: 'Rajasthan'
        },
        {
            value: 'IN-SK',
            labelcz: 'Sikkim'
        },
        {
            value: 'IN-TG',
            labelcz: 'Telangana'
        },
        {
            value: 'IN-TN',
            labelcz: 'Tamil Nadu'
        },
        {
            value: 'IN-TR',
            labelcz: 'Tripura'
        },
        {
            value: 'IN-UP',
            labelcz: 'Uttar Pradesh'
        },
        {
            value: 'IN-UT',
            labelcz: 'Uttarakhand'
        },
        {
            value: 'IN-WB',
            labelcz: 'West Bengal'
        }
    ],
    IT: [
        {
            value: 'IT-AG',
            labelcz: 'Agrigento'
        },
        {
            value: 'IT-AL',
            labelcz: 'Alessandria'
        },
        {
            value: 'IT-AN',
            labelcz: 'Ancona'
        },
        {
            value: 'IT-AP',
            labelcz: 'Ascoli Piceno'
        },
        {
            value: 'IT-AQ',
            labelcz: "L'Aquila"
        },
        {
            value: 'IT-AR',
            labelcz: 'Arezzo'
        },
        {
            value: 'IT-AT',
            labelcz: 'Asti'
        },
        {
            value: 'IT-AV',
            labelcz: 'Avellino'
        },
        {
            value: 'IT-BA',
            labelcz: 'Bari'
        },
        {
            value: 'IT-BG',
            labelcz: 'Bergamo'
        },
        {
            value: 'IT-BI',
            labelcz: 'Biella'
        },
        {
            value: 'IT-BL',
            labelcz: 'Belluno'
        },
        {
            value: 'IT-BN',
            labelcz: 'Benevento'
        },
        {
            value: 'IT-BO',
            labelcz: 'Bologna'
        },
        {
            value: 'IT-BR',
            labelcz: 'Brindisi'
        },
        {
            value: 'IT-BS',
            labelcz: 'Brescia'
        },
        {
            value: 'IT-BT',
            labelcz: 'Barletta-Andria-Trani'
        },
        {
            value: 'IT-BZ',
            labelcz: 'Bolzano'
        },
        {
            value: 'IT-CA',
            labelcz: 'Cagliari'
        },
        {
            value: 'IT-CB',
            labelcz: 'Campobasso'
        },
        {
            value: 'IT-CE',
            labelcz: 'Caserta'
        },
        {
            value: 'IT-CL',
            labelcz: 'Caltanissetta'
        },
        {
            value: 'IT-CN',
            labelcz: 'Cuneo'
        },
        {
            value: 'IT-CO',
            labelcz: 'Como'
        },
        {
            value: 'IT-CR',
            labelcz: 'Cremona'
        },
        {
            value: 'IT-CS',
            labelcz: 'Cosenza'
        },
        {
            value: 'IT-CT',
            labelcz: 'Catania'
        },
        {
            value: 'IT-CZ',
            labelcz: 'Catanzaro'
        },
        {
            value: 'IT-EN',
            labelcz: 'Enna'
        },
        {
            value: 'IT-FC',
            labelcz: 'Forlì-Cesena'
        },
        {
            value: 'IT-FE',
            labelcz: 'Ferrara'
        },
        {
            value: 'IT-FG',
            labelcz: 'Foggia'
        },
        {
            value: 'IT-FI',
            labelcz: 'Firenze'
        },
        {
            value: 'IT-FM',
            labelcz: 'Fermo'
        },
        {
            value: 'IT-FR',
            labelcz: 'Frosinone'
        },
        {
            value: 'IT-GE',
            labelcz: 'Genova'
        },
        {
            value: 'IT-GO',
            labelcz: 'Gorizia'
        },
        {
            value: 'IT-GR',
            labelcz: 'Grosseto'
        },
        {
            value: 'IT-CH',
            labelcz: 'Chieti'
        },
        {
            value: 'IT-IM',
            labelcz: 'Imperia'
        },
        {
            value: 'IT-IS',
            labelcz: 'Isernia'
        },
        {
            value: 'IT-KR',
            labelcz: 'Crotone'
        },
        {
            value: 'IT-LC',
            labelcz: 'Lecco'
        },
        {
            value: 'IT-LE',
            labelcz: 'Lecce'
        },
        {
            value: 'IT-LI',
            labelcz: 'Livorno'
        },
        {
            value: 'IT-LO',
            labelcz: 'Lodi'
        },
        {
            value: 'IT-LT',
            labelcz: 'Latina'
        },
        {
            value: 'IT-LU',
            labelcz: 'Lucca'
        },
        {
            value: 'IT-MB',
            labelcz: 'Monza e Brianza'
        },
        {
            value: 'IT-MC',
            labelcz: 'Macerata'
        },
        {
            value: 'IT-ME',
            labelcz: 'Messina'
        },
        {
            value: 'IT-MI',
            labelcz: 'Milano'
        },
        {
            value: 'IT-MN',
            labelcz: 'Mantova'
        },
        {
            value: 'IT-MO',
            labelcz: 'Modena'
        },
        {
            value: 'IT-MS',
            labelcz: 'Massa-Carrara'
        },
        {
            value: 'IT-MT',
            labelcz: 'Matera'
        },
        {
            value: 'IT-NA',
            labelcz: 'Napoli'
        },
        {
            value: 'IT-NO',
            labelcz: 'Novara'
        },
        {
            value: 'IT-NU',
            labelcz: 'Nuoro'
        },
        {
            value: 'IT-OR',
            labelcz: 'Oristano'
        },
        {
            value: 'IT-PA',
            labelcz: 'Palermo'
        },
        {
            value: 'IT-PC',
            labelcz: 'Piacenza'
        },
        {
            value: 'IT-PD',
            labelcz: 'Padova'
        },
        {
            value: 'IT-PE',
            labelcz: 'Pescara'
        },
        {
            value: 'IT-PG',
            labelcz: 'Perugia'
        },
        {
            value: 'IT-PI',
            labelcz: 'Pisa'
        },
        {
            value: 'IT-PN',
            labelcz: 'Pordenone'
        },
        {
            value: 'IT-PO',
            labelcz: 'Prato'
        },
        {
            value: 'IT-PR',
            labelcz: 'Parma'
        },
        {
            value: 'IT-PT',
            labelcz: 'Pistoia'
        },
        {
            value: 'IT-PU',
            labelcz: 'Pesaro e Urbino'
        },
        {
            value: 'IT-PV',
            labelcz: 'Pavia'
        },
        {
            value: 'IT-PZ',
            labelcz: 'Potenza'
        },
        {
            value: 'IT-RA',
            labelcz: 'Ravenna'
        },
        {
            value: 'IT-RC',
            labelcz: 'Reggio Calabria'
        },
        {
            value: 'IT-RE',
            labelcz: 'Reggio Emilia'
        },
        {
            value: 'IT-RG',
            labelcz: 'Ragusa'
        },
        {
            value: 'IT-RI',
            labelcz: 'Rieti'
        },
        {
            value: 'IT-RM',
            labelcz: 'Roma'
        },
        {
            value: 'IT-RN',
            labelcz: 'Rimini'
        },
        {
            value: 'IT-RO',
            labelcz: 'Rovigo'
        },
        {
            value: 'IT-SA',
            labelcz: 'Salerno'
        },
        {
            value: 'IT-SI',
            labelcz: 'Siena'
        },
        {
            value: 'IT-SO',
            labelcz: 'Sondrio'
        },
        {
            value: 'IT-SP',
            labelcz: 'La Spezia'
        },
        {
            value: 'IT-SR',
            labelcz: 'Siracusa'
        },
        {
            value: 'IT-SS',
            labelcz: 'Sassari'
        },
        {
            value: 'IT-SU',
            labelcz: 'Sud Sardegna'
        },
        {
            value: 'IT-SV',
            labelcz: 'Savona'
        },
        {
            value: 'IT-TA',
            labelcz: 'Taranto'
        },
        {
            value: 'IT-TE',
            labelcz: 'Teramo'
        },
        {
            value: 'IT-TN',
            labelcz: 'Trento'
        },
        {
            value: 'IT-TO',
            labelcz: 'Torino'
        },
        {
            value: 'IT-TP',
            labelcz: 'Trapani'
        },
        {
            value: 'IT-TR',
            labelcz: 'Terni'
        },
        {
            value: 'IT-TS',
            labelcz: 'Trieste'
        },
        {
            value: 'IT-TV',
            labelcz: 'Treviso'
        },
        {
            value: 'IT-UD',
            labelcz: 'Udine'
        },
        {
            value: 'IT-VA',
            labelcz: 'Varese'
        },
        {
            value: 'IT-VB',
            labelcz: 'Verbano-Cusio-Ossola'
        },
        {
            value: 'IT-VC',
            labelcz: 'Vercelli'
        },
        {
            value: 'IT-VE',
            labelcz: 'Venezia'
        },
        {
            value: 'IT-VI',
            labelcz: 'Vicenza'
        },
        {
            value: 'IT-VR',
            labelcz: 'Verona'
        },
        {
            value: 'IT-VT',
            labelcz: 'Viterbo'
        },
        {
            value: 'IT-VV',
            labelcz: 'Vibo Valentia'
        },
        {
            value: 'IT-21',
            labelcz: 'Piemonte'
        },
        {
            value: 'IT-23',
            labelcz: "Valle d'Aosta"
        },
        {
            value: 'IT-25',
            labelcz: 'Lombardia'
        },
        {
            value: 'IT-32',
            labelcz: 'Trentino-Alto Adige'
        },
        {
            value: 'IT-34',
            labelcz: 'Veneto'
        },
        {
            value: 'IT-36',
            labelcz: 'Friuli Venezia Giulia'
        },
        {
            value: 'IT-42',
            labelcz: 'Liguria'
        },
        {
            value: 'IT-45',
            labelcz: 'Emilia-Romagna'
        },
        {
            value: 'IT-52',
            labelcz: 'Toscana'
        },
        {
            value: 'IT-55',
            labelcz: 'Umbria'
        },
        {
            value: 'IT-57',
            labelcz: 'Marche'
        },
        {
            value: 'IT-62',
            labelcz: 'Lazio'
        },
        {
            value: 'IT-65',
            labelcz: 'Abruzzo'
        },
        {
            value: 'IT-67',
            labelcz: 'Molise'
        },
        {
            value: 'IT-72',
            labelcz: 'Campania'
        },
        {
            value: 'IT-75',
            labelcz: 'Puglia'
        },
        {
            value: 'IT-77',
            labelcz: 'Basilicata'
        },
        {
            value: 'IT-78',
            labelcz: 'Calabria'
        },
        {
            value: 'IT-82',
            labelcz: 'Sicilia'
        },
        {
            value: 'IT-88',
            labelcz: 'Sardegna'
        }
    ],
    JP: [
        {
            value: 'JP-07',
            labelcz: 'Fukushima'
        },
        {
            value: 'JP-08',
            labelcz: 'Ibaraki'
        },
        {
            value: 'JP-09',
            labelcz: 'Tochigi'
        },
        {
            value: 'JP-10',
            labelcz: 'Gunma'
        },
        {
            value: 'JP-11',
            labelcz: 'Saitama'
        },
        {
            value: 'JP-12',
            labelcz: 'Chiba'
        },
        {
            value: 'JP-13',
            labelcz: 'Tokyo'
        },
        {
            value: 'JP-14',
            labelcz: 'Kanagawa'
        },
        {
            value: 'JP-15',
            labelcz: 'Niigata'
        },
        {
            value: 'JP-16',
            labelcz: 'Toyama'
        },
        {
            value: 'JP-17',
            labelcz: 'Ishikawa'
        },
        {
            value: 'JP-18',
            labelcz: 'Fukui'
        },
        {
            value: 'JP-19',
            labelcz: 'Yamanashi'
        },
        {
            value: 'JP-20',
            labelcz: 'Nagano'
        },
        {
            value: 'JP-21',
            labelcz: 'Gifu'
        },
        {
            value: 'JP-22',
            labelcz: 'Shizuoka'
        },
        {
            value: 'JP-23',
            labelcz: 'Aichi'
        },
        {
            value: 'JP-24',
            labelcz: 'Mie'
        },
        {
            value: 'JP-25',
            labelcz: 'Shiga'
        },
        {
            value: 'JP-26',
            labelcz: 'Kyoto'
        },
        {
            value: 'JP-27',
            labelcz: 'Osaka'
        },
        {
            value: 'JP-28',
            labelcz: 'Hyogo'
        },
        {
            value: 'JP-29',
            labelcz: 'Nara'
        },
        {
            value: 'JP-30',
            labelcz: 'Wakayama'
        },
        {
            value: 'JP-31',
            labelcz: 'Tottori'
        },
        {
            value: 'JP-32',
            labelcz: 'Shimane'
        },
        {
            value: 'JP-33',
            labelcz: 'Okayama'
        },
        {
            value: 'JP-34',
            labelcz: 'Hiroshima'
        },
        {
            value: 'JP-35',
            labelcz: 'Yamaguchi'
        },
        {
            value: 'JP-36',
            labelcz: 'Tokushima'
        },
        {
            value: 'JP-37',
            labelcz: 'Kagawa'
        },
        {
            value: 'JP-38',
            labelcz: 'Ehime'
        },
        {
            value: 'JP-39',
            labelcz: 'Kochi'
        },
        {
            value: 'JP-40',
            labelcz: 'Fukuoka'
        },
        {
            value: 'JP-41',
            labelcz: 'Saga'
        },
        {
            value: 'JP-42',
            labelcz: 'Nagasaki'
        },
        {
            value: 'JP-43',
            labelcz: 'Kumamoto'
        },
        {
            value: 'JP-44',
            labelcz: 'Oita'
        },
        {
            value: 'JP-45',
            labelcz: 'Miyazaki'
        },
        {
            value: 'JP-46',
            labelcz: 'Kagoshima'
        },
        {
            value: 'JP-47',
            labelcz: 'Okinawa'
        }
    ],
    KR: [
        {
            value: 'KR-11',
            labelcz: 'Seoul'
        },
        {
            value: 'KR-26',
            labelcz: 'Busan'
        },
        {
            value: 'KR-27',
            labelcz: 'Daegu'
        },
        {
            value: 'KR-28',
            labelcz: 'Incheon'
        },
        {
            value: 'KR-29',
            labelcz: 'Gwangju'
        },
        {
            value: 'KR-30',
            labelcz: 'Daejeon'
        },
        {
            value: 'KR-31',
            labelcz: 'Ulsan'
        },
        {
            value: 'KR-41',
            labelcz: 'Gyeonggi'
        },
        {
            value: 'KR-42',
            labelcz: 'Gangwon'
        },
        {
            value: 'KR-43',
            labelcz: 'North Chungcheong'
        },
        {
            value: 'KR-44',
            labelcz: 'South Chungcheong'
        },
        {
            value: 'KR-45',
            labelcz: 'North Jeolla'
        },
        {
            value: 'KR-46',
            labelcz: 'South Jeolla'
        },
        {
            value: 'KR-47',
            labelcz: 'North Gyeongsang'
        },
        {
            value: 'KR-48',
            labelcz: 'South Gyeongsang'
        },
        {
            value: 'KR-49',
            labelcz: 'Jeju'
        },
        {
            value: 'KR-50',
            labelcz: 'Sejong'
        }
    ],
    LT: [
        {
            value: 'LT-AL',
            labelcz: 'Alytus'
        },
        {
            value: 'LT-KL',
            labelcz: 'Klaipėda'
        },
        {
            value: 'LT-KU',
            labelcz: 'Kaunas'
        },
        {
            value: 'LT-MR',
            labelcz: 'Marijampolė'
        },
        {
            value: 'LT-PN',
            labelcz: 'Panevėžys'
        },
        {
            value: 'LT-SA',
            labelcz: 'Šiauliai'
        },
        {
            value: 'LT-TA',
            labelcz: 'Tauragė'
        },
        {
            value: 'LT-TE',
            labelcz: 'Telšiai'
        },
        {
            value: 'LT-UT',
            labelcz: 'Utena'
        },
        {
            value: 'LT-VL',
            labelcz: 'Vilnius'
        },
        {
            value: 'LT-01',
            labelcz: 'Akmenė'
        },
        {
            value: 'LT-02',
            labelcz: 'Alytaus miestas'
        },
        {
            value: 'LT-03',
            labelcz: 'Alytus'
        },
        {
            value: 'LT-04',
            labelcz: 'Anykščiai'
        },
        {
            value: 'LT-05',
            labelcz: 'Birštonas'
        },
        {
            value: 'LT-06',
            labelcz: 'Biržai'
        },
        {
            value: 'LT-07',
            labelcz: 'Druskininkai'
        },
        {
            value: 'LT-08',
            labelcz: 'Elektrėnai'
        },
        {
            value: 'LT-09',
            labelcz: 'Ignalina'
        },
        {
            value: 'LT-10',
            labelcz: 'Jonava'
        },
        {
            value: 'LT-11',
            labelcz: 'Joniškis'
        },
        {
            value: 'LT-12',
            labelcz: 'Jurbarkas'
        },
        {
            value: 'LT-13',
            labelcz: 'Kaišiadorys'
        },
        {
            value: 'LT-14',
            labelcz: 'Kalvarija'
        },
        {
            value: 'LT-15',
            labelcz: 'Kauno miestas'
        },
        {
            value: 'LT-16',
            labelcz: 'Kaunas'
        },
        {
            value: 'LT-17',
            labelcz: 'Kazlų Rūda'
        },
        {
            value: 'LT-18',
            labelcz: 'Kėdainiai'
        },
        {
            value: 'LT-19',
            labelcz: 'Kelmė'
        },
        {
            value: 'LT-20',
            labelcz: 'Klaipėdos miestas'
        },
        {
            value: 'LT-21',
            labelcz: 'Klaipėda'
        },
        {
            value: 'LT-22',
            labelcz: 'Kretinga'
        },
        {
            value: 'LT-23',
            labelcz: 'Kupiškis'
        },
        {
            value: 'LT-24',
            labelcz: 'Lazdijai'
        },
        {
            value: 'LT-25',
            labelcz: 'Marijampolė'
        },
        {
            value: 'LT-26',
            labelcz: 'Mažeikiai'
        },
        {
            value: 'LT-27',
            labelcz: 'Molėtai'
        },
        {
            value: 'LT-28',
            labelcz: 'Neringa'
        },
        {
            value: 'LT-29',
            labelcz: 'Pagėgiai'
        },
        {
            value: 'LT-30',
            labelcz: 'Pakruojis'
        },
        {
            value: 'LT-31',
            labelcz: 'Palangos miestas'
        },
        {
            value: 'LT-32',
            labelcz: 'Panevėžio miestas'
        },
        {
            value: 'LT-33',
            labelcz: 'Panevėžys'
        },
        {
            value: 'LT-34',
            labelcz: 'Pasvalys'
        },
        {
            value: 'LT-35',
            labelcz: 'Plungė'
        },
        {
            value: 'LT-36',
            labelcz: 'Prienai'
        },
        {
            value: 'LT-37',
            labelcz: 'Radviliškis'
        },
        {
            value: 'LT-38',
            labelcz: 'Raseiniai'
        },
        {
            value: 'LT-39',
            labelcz: 'Rietavas'
        },
        {
            value: 'LT-40',
            labelcz: 'Rokiškis'
        },
        {
            value: 'LT-41',
            labelcz: 'Šakiai'
        },
        {
            value: 'LT-42',
            labelcz: 'Šalčininkai'
        },
        {
            value: 'LT-43',
            labelcz: 'Šiauliai'
        },
        {
            value: 'LT-44',
            labelcz: 'Šiaulių miestas'
        },
        {
            value: 'LT-45',
            labelcz: 'Šilalė'
        },
        {
            value: 'LT-46',
            labelcz: 'Šilutė'
        },
        {
            value: 'LT-47',
            labelcz: 'Širvintos'
        },
        {
            value: 'LT-48',
            labelcz: 'Skuodas'
        },
        {
            value: 'LT-49',
            labelcz: 'Švenčionys'
        },
        {
            value: 'LT-50',
            labelcz: 'Tauragė'
        },
        {
            value: 'LT-51',
            labelcz: 'Telšiai'
        },
        {
            value: 'LT-52',
            labelcz: 'Trakai'
        },
        {
            value: 'LT-53',
            labelcz: 'Ukmergė'
        },
        {
            value: 'LT-54',
            labelcz: 'Utena'
        },
        {
            value: 'LT-55',
            labelcz: 'Varėna'
        },
        {
            value: 'LT-56',
            labelcz: 'Vilkaviškis'
        },
        {
            value: 'LT-57',
            labelcz: 'Vilniaus miestas'
        },
        {
            value: 'LT-58',
            labelcz: 'Vilnius'
        },
        {
            value: 'LT-59',
            labelcz: 'Visaginas'
        },
        {
            value: 'LT-60',
            labelcz: 'Zarasai'
        }
    ],
    LU: [
        {
            value: 'LU-CA',
            labelcz: 'Capellen'
        },
        {
            value: 'LU-CL',
            labelcz: 'Clervaux'
        },
        {
            value: 'LU-DI',
            labelcz: 'Diekirch'
        },
        {
            value: 'LU-EC',
            labelcz: 'Echternach'
        },
        {
            value: 'LU-ES',
            labelcz: 'Esch-sur-Alzette'
        },
        {
            value: 'LU-GR',
            labelcz: 'Grevenmacher'
        },
        {
            value: 'LU-LU',
            labelcz: 'Luxembourg'
        },
        {
            value: 'LU-ME',
            labelcz: 'Mersch'
        },
        {
            value: 'LU-RD',
            labelcz: 'Redange'
        },
        {
            value: 'LU-RM',
            labelcz: 'Remich'
        },
        {
            value: 'LU-VD',
            labelcz: 'Vianden'
        },
        {
            value: 'LU-WI',
            labelcz: 'Wiltz'
        }
    ],
    LV: [
        {
            value: 'LV-001',
            labelcz: 'Aglonas novads'
        },
        {
            value: 'LV-002',
            labelcz: 'Aizkraukles novads'
        },
        {
            value: 'LV-003',
            labelcz: 'Aizputes novads'
        },
        {
            value: 'LV-004',
            labelcz: 'Aknīstes novads'
        },
        {
            value: 'LV-005',
            labelcz: 'Alojas novads'
        },
        {
            value: 'LV-006',
            labelcz: 'Alsungas novads'
        },
        {
            value: 'LV-007',
            labelcz: 'Alūksnes novads'
        },
        {
            value: 'LV-008',
            labelcz: 'Amatas novads'
        },
        {
            value: 'LV-009',
            labelcz: 'Apes novads'
        },
        {
            value: 'LV-010',
            labelcz: 'Auces novads'
        },
        {
            value: 'LV-011',
            labelcz: 'Ādažu novads'
        },
        {
            value: 'LV-012',
            labelcz: 'Babītes novads'
        },
        {
            value: 'LV-013',
            labelcz: 'Baldones novads'
        },
        {
            value: 'LV-014',
            labelcz: 'Baltinavas novads'
        },
        {
            value: 'LV-015',
            labelcz: 'Balvu novads'
        },
        {
            value: 'LV-016',
            labelcz: 'Bauskas novads'
        },
        {
            value: 'LV-017',
            labelcz: 'Beverīnas novads'
        },
        {
            value: 'LV-018',
            labelcz: 'Brocēnu novads'
        },
        {
            value: 'LV-019',
            labelcz: 'Burtnieku novads'
        },
        {
            value: 'LV-020',
            labelcz: 'Carnikavas novads'
        },
        {
            value: 'LV-021',
            labelcz: 'Cesvaines novads'
        },
        {
            value: 'LV-022',
            labelcz: 'Cēsu novads'
        },
        {
            value: 'LV-023',
            labelcz: 'Ciblas novads'
        },
        {
            value: 'LV-024',
            labelcz: 'Dagdas novads'
        },
        {
            value: 'LV-025',
            labelcz: 'Daugavpils novads'
        },
        {
            value: 'LV-026',
            labelcz: 'Dobeles novads'
        },
        {
            value: 'LV-027',
            labelcz: 'Dundagas novads'
        },
        {
            value: 'LV-028',
            labelcz: 'Durbes novads'
        },
        {
            value: 'LV-029',
            labelcz: 'Engures novads'
        },
        {
            value: 'LV-030',
            labelcz: 'Ērgļu novads'
        },
        {
            value: 'LV-031',
            labelcz: 'Garkalnes novads'
        },
        {
            value: 'LV-032',
            labelcz: 'Grobiņas novads'
        },
        {
            value: 'LV-033',
            labelcz: 'Gulbenes novads'
        },
        {
            value: 'LV-034',
            labelcz: 'Iecavas novads'
        },
        {
            value: 'LV-035',
            labelcz: 'Ikšķiles novads'
        },
        {
            value: 'LV-036',
            labelcz: 'Ilūkstes novads'
        },
        {
            value: 'LV-037',
            labelcz: 'Inčukalna novads'
        },
        {
            value: 'LV-038',
            labelcz: 'Jaunjelgavas novads'
        },
        {
            value: 'LV-039',
            labelcz: 'Jaunpiebalgas novads'
        },
        {
            value: 'LV-040',
            labelcz: 'Jaunpils novads'
        },
        {
            value: 'LV-041',
            labelcz: 'Jelgavas novads'
        },
        {
            value: 'LV-042',
            labelcz: 'Jēkabpils novads'
        },
        {
            value: 'LV-043',
            labelcz: 'Kandavas novads'
        },
        {
            value: 'LV-044',
            labelcz: 'Kārsavas novads'
        },
        {
            value: 'LV-045',
            labelcz: 'Kocēnu novads'
        },
        {
            value: 'LV-046',
            labelcz: 'Kokneses novads'
        },
        {
            value: 'LV-047',
            labelcz: 'Krāslavas novads'
        },
        {
            value: 'LV-048',
            labelcz: 'Krimuldas novads'
        },
        {
            value: 'LV-049',
            labelcz: 'Krustpils novads'
        },
        {
            value: 'LV-050',
            labelcz: 'Kuldīgas novads'
        },
        {
            value: 'LV-051',
            labelcz: 'Ķeguma novads'
        },
        {
            value: 'LV-052',
            labelcz: 'Ķekavas novads'
        },
        {
            value: 'LV-053',
            labelcz: 'Lielvārdes novads'
        },
        {
            value: 'LV-054',
            labelcz: 'Limbažu novads'
        },
        {
            value: 'LV-055',
            labelcz: 'Līgatnes novads'
        },
        {
            value: 'LV-056',
            labelcz: 'Līvānu novads'
        },
        {
            value: 'LV-057',
            labelcz: 'Lubānas novads'
        },
        {
            value: 'LV-058',
            labelcz: 'Ludzas novads'
        },
        {
            value: 'LV-059',
            labelcz: 'Madonas novads'
        },
        {
            value: 'LV-060',
            labelcz: 'Mazsalacas novads'
        },
        {
            value: 'LV-061',
            labelcz: 'Mālpils novads'
        },
        {
            value: 'LV-062',
            labelcz: 'Mārupes novads'
        },
        {
            value: 'LV-063',
            labelcz: 'Mērsraga novads'
        },
        {
            value: 'LV-064',
            labelcz: 'Naukšēnu novads'
        },
        {
            value: 'LV-065',
            labelcz: 'Neretas novads'
        },
        {
            value: 'LV-066',
            labelcz: 'Nīcas novads'
        },
        {
            value: 'LV-067',
            labelcz: 'Ogres novads'
        },
        {
            value: 'LV-068',
            labelcz: 'Olaines novads'
        },
        {
            value: 'LV-069',
            labelcz: 'Ozolnieku novads'
        },
        {
            value: 'LV-070',
            labelcz: 'Pārgaujas novads'
        },
        {
            value: 'LV-071',
            labelcz: 'Pāvilostas novads'
        },
        {
            value: 'LV-072',
            labelcz: 'Pļaviņu novads'
        },
        {
            value: 'LV-073',
            labelcz: 'Preiļu novads'
        },
        {
            value: 'LV-074',
            labelcz: 'Priekules novads'
        },
        {
            value: 'LV-075',
            labelcz: 'Priekuļu novads'
        },
        {
            value: 'LV-076',
            labelcz: 'Raunas novads'
        },
        {
            value: 'LV-077',
            labelcz: 'Rēzeknes novads'
        },
        {
            value: 'LV-078',
            labelcz: 'Riebiņu novads'
        },
        {
            value: 'LV-079',
            labelcz: 'Rojas novads'
        },
        {
            value: 'LV-080',
            labelcz: 'Ropažu novads'
        },
        {
            value: 'LV-081',
            labelcz: 'Rucavas novads'
        },
        {
            value: 'LV-082',
            labelcz: 'Rugāju novads'
        },
        {
            value: 'LV-083',
            labelcz: 'Rundāles novads'
        },
        {
            value: 'LV-084',
            labelcz: 'Rūjienas novads'
        },
        {
            value: 'LV-085',
            labelcz: 'Salas novads'
        },
        {
            value: 'LV-086',
            labelcz: 'Salacgrīvas novads'
        },
        {
            value: 'LV-087',
            labelcz: 'Salaspils novads'
        },
        {
            value: 'LV-088',
            labelcz: 'Saldus novads'
        },
        {
            value: 'LV-089',
            labelcz: 'Saulkrastu novads'
        },
        {
            value: 'LV-090',
            labelcz: 'Sējas novads'
        },
        {
            value: 'LV-091',
            labelcz: 'Siguldas novads'
        },
        {
            value: 'LV-092',
            labelcz: 'Skrīveru novads'
        },
        {
            value: 'LV-093',
            labelcz: 'Skrundas novads'
        },
        {
            value: 'LV-094',
            labelcz: 'Smiltenes novads'
        },
        {
            value: 'LV-095',
            labelcz: 'Stopiņu novads'
        },
        {
            value: 'LV-096',
            labelcz: 'Strenču novads'
        },
        {
            value: 'LV-097',
            labelcz: 'Talsu novads'
        },
        {
            value: 'LV-098',
            labelcz: 'Tērvetes novads'
        },
        {
            value: 'LV-099',
            labelcz: 'Tukuma novads'
        },
        {
            value: 'LV-100',
            labelcz: 'Vaiņodes novads'
        },
        {
            value: 'LV-101',
            labelcz: 'Valkas novads'
        },
        {
            value: 'LV-102',
            labelcz: 'Varakļānu novads'
        },
        {
            value: 'LV-103',
            labelcz: 'Vārkavas novads'
        },
        {
            value: 'LV-104',
            labelcz: 'Vecpiebalgas novads'
        },
        {
            value: 'LV-105',
            labelcz: 'Vecumnieku novads'
        },
        {
            value: 'LV-106',
            labelcz: 'Ventspils novads'
        },
        {
            value: 'LV-107',
            labelcz: 'Viesītes novads'
        },
        {
            value: 'LV-108',
            labelcz: 'Viļakas novads'
        },
        {
            value: 'LV-109',
            labelcz: 'Viļānu novads'
        },
        {
            value: 'LV-110',
            labelcz: 'Zilupes novads'
        },
        {
            value: 'LV-DGV',
            labelcz: 'Daugavpils'
        },
        {
            value: 'LV-JEL',
            labelcz: 'Jelgava'
        },
        {
            value: 'LV-JKB',
            labelcz: 'Jēkabpils'
        },
        {
            value: 'LV-JUR',
            labelcz: 'Jūrmala'
        },
        {
            value: 'LV-LPX',
            labelcz: 'Liepāja'
        },
        {
            value: 'LV-REZ',
            labelcz: 'Rēzekne'
        },
        {
            value: 'LV-RIX',
            labelcz: 'Rīga'
        },
        {
            value: 'LV-VMR',
            labelcz: 'Valmiera'
        },
        {
            value: 'LV-VEN',
            labelcz: 'Ventspils'
        }
    ],
    MT: [
        {
            value: 'MT-01',
            labelcz: 'Attard'
        },
        {
            value: 'MT-02',
            labelcz: 'Balzan'
        },
        {
            value: 'MT-03',
            labelcz: 'Birgu'
        },
        {
            value: 'MT-04',
            labelcz: 'Birkirkara'
        },
        {
            value: 'MT-05',
            labelcz: 'Birżebbuġa'
        },
        {
            value: 'MT-06',
            labelcz: 'Bormla'
        },
        {
            value: 'MT-07',
            labelcz: 'Dingli'
        },
        {
            value: 'MT-08',
            labelcz: 'Fgura'
        },
        {
            value: 'MT-09',
            labelcz: 'Floriana'
        },
        {
            value: 'MT-10',
            labelcz: 'Fontana'
        },
        {
            value: 'MT-11',
            labelcz: 'Gudja'
        },
        {
            value: 'MT-12',
            labelcz: 'Gżira'
        },
        {
            value: 'MT-13',
            labelcz: 'Għajnsielem'
        },
        {
            value: 'MT-14',
            labelcz: 'Għarb'
        },
        {
            value: 'MT-15',
            labelcz: 'Għargħur'
        },
        {
            value: 'MT-16',
            labelcz: 'Għasri'
        },
        {
            value: 'MT-17',
            labelcz: 'Għaxaq'
        },
        {
            value: 'MT-18',
            labelcz: 'Ħamrun'
        },
        {
            value: 'MT-19',
            labelcz: 'Iklin'
        },
        {
            value: 'MT-20',
            labelcz: 'Isla'
        },
        {
            value: 'MT-21',
            labelcz: 'Kalkara'
        },
        {
            value: 'MT-22',
            labelcz: 'Kerċem'
        },
        {
            value: 'MT-23',
            labelcz: 'Kirkop'
        },
        {
            value: 'MT-24',
            labelcz: 'Lija'
        },
        {
            value: 'MT-25',
            labelcz: 'Luqa'
        },
        {
            value: 'MT-26',
            labelcz: 'Marsa'
        },
        {
            value: 'MT-27',
            labelcz: 'Marsaskala'
        },
        {
            value: 'MT-28',
            labelcz: 'Marsaxlokk'
        },
        {
            value: 'MT-29',
            labelcz: 'Mdina'
        },
        {
            value: 'MT-30',
            labelcz: 'Mellieħa'
        },
        {
            value: 'MT-31',
            labelcz: 'Mġarr'
        },
        {
            value: 'MT-32',
            labelcz: 'Mosta'
        },
        {
            value: 'MT-33',
            labelcz: 'Mqabba'
        },
        {
            value: 'MT-34',
            labelcz: 'Msida'
        },
        {
            value: 'MT-35',
            labelcz: 'Mtarfa'
        },
        {
            value: 'MT-36',
            labelcz: 'Munxar'
        },
        {
            value: 'MT-37',
            labelcz: 'Nadur'
        },
        {
            value: 'MT-38',
            labelcz: 'Naxxar'
        },
        {
            value: 'MT-39',
            labelcz: 'Paola'
        },
        {
            value: 'MT-40',
            labelcz: 'Pembroke'
        },
        {
            value: 'MT-41',
            labelcz: 'Pietà'
        },
        {
            value: 'MT-42',
            labelcz: 'Qala'
        },
        {
            value: 'MT-43',
            labelcz: 'Qormi'
        },
        {
            value: 'MT-44',
            labelcz: 'Qrendi'
        },
        {
            value: 'MT-45',
            labelcz: 'Rabat Gozo'
        },
        {
            value: 'MT-46',
            labelcz: 'Rabat Malta'
        },
        {
            value: 'MT-47',
            labelcz: 'Safi'
        },
        {
            value: 'MT-48',
            labelcz: 'Saint Julian`s'
        },
        {
            value: 'MT-49',
            labelcz: 'Saint John'
        },
        {
            value: 'MT-50',
            labelcz: 'Saint Lawrence'
        },
        {
            value: 'MT-51',
            labelcz: 'Saint Paul`s Bay'
        },
        {
            value: 'MT-52',
            labelcz: 'Sannat'
        },
        {
            value: 'MT-53',
            labelcz: 'Saint Lucia`s'
        },
        {
            value: 'MT-54',
            labelcz: 'Santa Venera'
        },
        {
            value: 'MT-55',
            labelcz: 'Siġġiewi'
        },
        {
            value: 'MT-56',
            labelcz: 'Sliema'
        },
        {
            value: 'MT-57',
            labelcz: 'Swieqi'
        },
        {
            value: 'MT-58',
            labelcz: 'Ta` Xbiex'
        },
        {
            value: 'MT-59',
            labelcz: 'Tarxien'
        },
        {
            value: 'MT-60',
            labelcz: 'Valletta'
        },
        {
            value: 'MT-61',
            labelcz: 'Xagħra'
        },
        {
            value: 'MT-62',
            labelcz: 'Xewkija'
        },
        {
            value: 'MT-63',
            labelcz: 'Xgħajra'
        },
        {
            value: 'MT-64',
            labelcz: 'Żabbar'
        },
        {
            value: 'MT-65',
            labelcz: 'Żebbuġ Gozo'
        },
        {
            value: 'MT-66',
            labelcz: 'Żebbuġ Malta'
        },
        {
            value: 'MT-67',
            labelcz: 'Żejtun'
        },
        {
            value: 'MT-68',
            labelcz: 'Żurrieq'
        }
    ],
    NL: [
        {
            value: 'NL-DR',
            labelcz: 'Drenthe'
        },
        {
            value: 'NL-FL',
            labelcz: 'Flevoland'
        },
        {
            value: 'NL-FR',
            labelcz: 'Fryslân (fy)'
        },
        {
            value: 'NL-GE',
            labelcz: 'Gelderland'
        },
        {
            value: 'NL-GR',
            labelcz: 'Groningen'
        },
        {
            value: 'NL-LI',
            labelcz: 'Limburg'
        },
        {
            value: 'NL-NB',
            labelcz: 'Noord-Brabant'
        },
        {
            value: 'NL-NH',
            labelcz: 'Noord-Holland'
        },
        {
            value: 'NL-OV',
            labelcz: 'Overijssel'
        },
        {
            value: 'NL-UT',
            labelcz: 'Utrecht'
        },
        {
            value: 'NL-ZE',
            labelcz: 'Zeeland'
        },
        {
            value: 'NL-ZH',
            labelcz: 'Zuid-Holland'
        }
    ],
    PL: [
        {
            value: 'PL-02',
            labelcz: 'Dolnośląskie'
        },
        {
            value: 'PL-04',
            labelcz: 'Kujawsko-pomorskie'
        },
        {
            value: 'PL-06',
            labelcz: 'Lubelskie'
        },
        {
            value: 'PL-08',
            labelcz: 'Lubuskie'
        },
        {
            value: 'PL-10',
            labelcz: 'Łódzkie'
        },
        {
            value: 'PL-12',
            labelcz: 'Małopolskie'
        },
        {
            value: 'PL-14',
            labelcz: 'Mazowieckie'
        },
        {
            value: 'PL-16',
            labelcz: 'Opolskie'
        },
        {
            value: 'PL-18',
            labelcz: 'Podkarpackie'
        },
        {
            value: 'PL-20',
            labelcz: 'Podlaskie'
        },
        {
            value: 'PL-22',
            labelcz: 'Pomorskie'
        },
        {
            value: 'PL-24',
            labelcz: 'Śląskie'
        },
        {
            value: 'PL-26',
            labelcz: 'Świętokrzyskie'
        },
        {
            value: 'PL-28',
            labelcz: 'Warmińsko-mazurskie'
        },
        {
            value: 'PL-30',
            labelcz: 'Wielkopolskie'
        },
        {
            value: 'PL-32',
            labelcz: 'Zachodniopomorskie'
        }
    ],
    RO: [
        {
            value: 'RO-AB',
            labelcz: 'Alba'
        },
        {
            value: 'RO-AR',
            labelcz: 'Arad'
        },
        {
            value: 'RO-AG',
            labelcz: 'Argeș'
        },
        {
            value: 'RO-BC',
            labelcz: 'Bacău'
        },
        {
            value: 'RO-BH',
            labelcz: 'Bihor'
        },
        {
            value: 'RO-BN',
            labelcz: 'Bistrița-Năsăud'
        },
        {
            value: 'RO-BT',
            labelcz: 'Botoșani'
        },
        {
            value: 'RO-BV',
            labelcz: 'Brașov'
        },
        {
            value: 'RO-BR',
            labelcz: 'Brăila'
        },
        {
            value: 'RO-BZ',
            labelcz: 'Buzău'
        },
        {
            value: 'RO-CS',
            labelcz: 'Caraș-Severin'
        },
        {
            value: 'RO-CL',
            labelcz: 'Călărași'
        },
        {
            value: 'RO-CJ',
            labelcz: 'Cluj'
        },
        {
            value: 'RO-CT',
            labelcz: 'Constanța'
        },
        {
            value: 'RO-CV',
            labelcz: 'Covasna'
        },
        {
            value: 'RO-DB',
            labelcz: 'Dâmbovița'
        },
        {
            value: 'RO-DJ',
            labelcz: 'Dolj'
        },
        {
            value: 'RO-GL',
            labelcz: 'Galați'
        },
        {
            value: 'RO-GR',
            labelcz: 'Giurgiu'
        },
        {
            value: 'RO-GJ',
            labelcz: 'Gorj'
        },
        {
            value: 'RO-HR',
            labelcz: 'Harghita'
        },
        {
            value: 'RO-HD',
            labelcz: 'Hunedoara'
        },
        {
            value: 'RO-IL',
            labelcz: 'Ialomița'
        },
        {
            value: 'RO-IS',
            labelcz: 'Iași'
        },
        {
            value: 'RO-IF',
            labelcz: 'Ilfov'
        },
        {
            value: 'RO-MM',
            labelcz: 'Maramureș'
        },
        {
            value: 'RO-MH',
            labelcz: 'Mehedinți'
        },
        {
            value: 'RO-MS',
            labelcz: 'Mureș'
        },
        {
            value: 'RO-NT',
            labelcz: 'Neamț'
        },
        {
            value: 'RO-OT',
            labelcz: 'Olt'
        },
        {
            value: 'RO-PH',
            labelcz: 'Prahova'
        },
        {
            value: 'RO-SM',
            labelcz: 'Satu Mare'
        },
        {
            value: 'RO-SJ',
            labelcz: 'Sălaj'
        },
        {
            value: 'RO-SB',
            labelcz: 'Sibiu'
        },
        {
            value: 'RO-SV',
            labelcz: 'Suceava'
        },
        {
            value: 'RO-TR',
            labelcz: 'Teleorman'
        },
        {
            value: 'RO-TM',
            labelcz: 'Timiș'
        },
        {
            value: 'RO-TL',
            labelcz: 'Tulcea'
        },
        {
            value: 'RO-VS',
            labelcz: 'Vaslui'
        },
        {
            value: 'RO-VL',
            labelcz: 'Vâlcea'
        },
        {
            value: 'RO-VN',
            labelcz: 'Vrancea'
        },
        {
            value: 'RO-B',
            labelcz: 'București'
        }
    ],
    RS: [
        {
            value: 'RS-KM',
            labelcz: 'Kosovo-Metohija'
        },
        {
            value: 'RS-VO',
            labelcz: 'Vojvodina'
        },
        {
            value: 'RS-00',
            labelcz: 'Beograd'
        },
        {
            value: 'RS-01',
            labelcz: 'Severnobački'
        },
        {
            value: 'RS-02',
            labelcz: 'Srednjebanatski'
        },
        {
            value: 'RS-03',
            labelcz: 'Severnobanatski'
        },
        {
            value: 'RS-04',
            labelcz: 'Južnobanatski'
        },
        {
            value: 'RS-05',
            labelcz: 'Zapadnobački'
        },
        {
            value: 'RS-06',
            labelcz: 'Južnobački'
        },
        {
            value: 'RS-07',
            labelcz: 'Sremski'
        },
        {
            value: 'RS-08',
            labelcz: 'Mačvanski'
        },
        {
            value: 'RS-09',
            labelcz: 'Kolubarski'
        },
        {
            value: 'RS-10',
            labelcz: 'Podunavski'
        },
        {
            value: 'RS-11',
            labelcz: 'Braničevski'
        },
        {
            value: 'RS-12',
            labelcz: 'Šumadijski'
        },
        {
            value: 'RS-13',
            labelcz: 'Pomoravski'
        },
        {
            value: 'RS-14',
            labelcz: 'Borski'
        },
        {
            value: 'RS-15',
            labelcz: 'Zaječarski'
        },
        {
            value: 'RS-16',
            labelcz: 'Zlatiborski'
        },
        {
            value: 'RS-17',
            labelcz: 'Moravički'
        },
        {
            value: 'RS-18',
            labelcz: 'Raški'
        },
        {
            value: 'RS-19',
            labelcz: 'Rasinski'
        },
        {
            value: 'RS-20',
            labelcz: 'Nišavski'
        },
        {
            value: 'RS-21',
            labelcz: 'Toplički'
        },
        {
            value: 'RS-22',
            labelcz: 'Pirotski'
        },
        {
            value: 'RS-23',
            labelcz: 'Jablanički'
        },
        {
            value: 'RS-24',
            labelcz: 'Pčinjski'
        },
        {
            value: 'RS-25',
            labelcz: 'Kosovski'
        },
        {
            value: 'RS-26',
            labelcz: 'Pećki'
        },
        {
            value: 'RS-27',
            labelcz: 'Prizrenski'
        },
        {
            value: 'RS-28',
            labelcz: 'Kosovsko-Mitrovački'
        },
        {
            value: 'RS-29',
            labelcz: 'Kosovsko-Pomoravski'
        }
    ],
    SE: [
        {
            value: 'SE-K',
            labelcz: 'Blekinge län'
        },
        {
            value: 'SE-W',
            labelcz: 'Dalarnas län'
        },
        {
            value: 'SE-I',
            labelcz: 'Gotlands län'
        },
        {
            value: 'SE-X',
            labelcz: 'Gävleborgs län'
        },
        {
            value: 'SE-N',
            labelcz: 'Hallands län'
        },
        {
            value: 'SE-Z',
            labelcz: 'Jämtlands län'
        },
        {
            value: 'SE-F',
            labelcz: 'Jönköpings län'
        },
        {
            value: 'SE-H',
            labelcz: 'Kalmar län'
        },
        {
            value: 'SE-G',
            labelcz: 'Kronobergs län'
        },
        {
            value: 'SE-BD',
            labelcz: 'Norrbottens län'
        },
        {
            value: 'SE-M',
            labelcz: 'Skåne län'
        },
        {
            value: 'SE-AB',
            labelcz: 'Stockholms län'
        },
        {
            value: 'SE-D',
            labelcz: 'Södermanlands län'
        },
        {
            value: 'SE-C',
            labelcz: 'Uppsala län'
        },
        {
            value: 'SE-S',
            labelcz: 'Värmlands län'
        },
        {
            value: 'SE-AC',
            labelcz: 'Västerbottens län'
        },
        {
            value: 'SE-Y',
            labelcz: 'Västernorrlands län'
        },
        {
            value: 'SE-U',
            labelcz: 'Västmanlands län'
        },
        {
            value: 'SE-O',
            labelcz: 'Västra Götalands län'
        },
        {
            value: 'SE-T',
            labelcz: 'Örebro län'
        },
        {
            value: 'SE-E',
            labelcz: 'Östergötlands län'
        }
    ],
    SI: [
        {
            value: 'SI-001',
            labelcz: 'Ajdovščina'
        },
        {
            value: 'SI-213',
            labelcz: 'Ankaran'
        },
        {
            value: 'SI-195',
            labelcz: 'Apače'
        },
        {
            value: 'SI-002',
            labelcz: 'Beltinci'
        },
        {
            value: 'SI-148',
            labelcz: 'Benedikt'
        },
        {
            value: 'SI-149',
            labelcz: 'Bistrica ob Sotli'
        },
        {
            value: 'SI-003',
            labelcz: 'Bled'
        },
        {
            value: 'SI-150',
            labelcz: 'Bloke'
        },
        {
            value: 'SI-004',
            labelcz: 'Bohinj'
        },
        {
            value: 'SI-005',
            labelcz: 'Borovnica'
        },
        {
            value: 'SI-006',
            labelcz: 'Bovec'
        },
        {
            value: 'SI-151',
            labelcz: 'Braslovče'
        },
        {
            value: 'SI-007',
            labelcz: 'Brda'
        },
        {
            value: 'SI-008',
            labelcz: 'Brezovica'
        },
        {
            value: 'SI-009',
            labelcz: 'Brežice'
        },
        {
            value: 'SI-152',
            labelcz: 'Cankova'
        },
        {
            value: 'SI-011',
            labelcz: 'Celje'
        },
        {
            value: 'SI-012',
            labelcz: 'Cerklje na Gorenjskem'
        },
        {
            value: 'SI-013',
            labelcz: 'Cerknica'
        },
        {
            value: 'SI-014',
            labelcz: 'Cerkno'
        },
        {
            value: 'SI-153',
            labelcz: 'Cerkvenjak'
        },
        {
            value: 'SI-196',
            labelcz: 'Cirkulane'
        },
        {
            value: 'SI-015',
            labelcz: 'Črenšovci'
        },
        {
            value: 'SI-016',
            labelcz: 'Črna na Koroškem'
        },
        {
            value: 'SI-017',
            labelcz: 'Črnomelj'
        },
        {
            value: 'SI-018',
            labelcz: 'Destrnik'
        },
        {
            value: 'SI-019',
            labelcz: 'Divača'
        },
        {
            value: 'SI-154',
            labelcz: 'Dobje'
        },
        {
            value: 'SI-020',
            labelcz: 'Dobrepolje'
        },
        {
            value: 'SI-155',
            labelcz: 'Dobrna'
        },
        {
            value: 'SI-021',
            labelcz: 'Dobrova-Polhov Gradec'
        },
        {
            value: 'SI-156',
            labelcz: 'Dobrovnik'
        },
        {
            value: 'SI-022',
            labelcz: 'Dol pri Ljubljani'
        },
        {
            value: 'SI-157',
            labelcz: 'Dolenjske Toplice'
        },
        {
            value: 'SI-023',
            labelcz: 'Domžale'
        },
        {
            value: 'SI-024',
            labelcz: 'Dornava'
        },
        {
            value: 'SI-025',
            labelcz: 'Dravograd'
        },
        {
            value: 'SI-026',
            labelcz: 'Duplek'
        },
        {
            value: 'SI-027',
            labelcz: 'Gorenja vas-Poljane'
        },
        {
            value: 'SI-028',
            labelcz: 'Gorišnica'
        },
        {
            value: 'SI-207',
            labelcz: 'Gorje'
        },
        {
            value: 'SI-029',
            labelcz: 'Gornja Radgona'
        },
        {
            value: 'SI-030',
            labelcz: 'Gornji Grad'
        },
        {
            value: 'SI-031',
            labelcz: 'Gornji Petrovci'
        },
        {
            value: 'SI-158',
            labelcz: 'Grad'
        },
        {
            value: 'SI-032',
            labelcz: 'Grosuplje'
        },
        {
            value: 'SI-159',
            labelcz: 'Hajdina'
        },
        {
            value: 'SI-160',
            labelcz: 'Hoče-Slivnica'
        },
        {
            value: 'SI-161',
            labelcz: 'Hodoš'
        },
        {
            value: 'SI-162',
            labelcz: 'Horjul'
        },
        {
            value: 'SI-034',
            labelcz: 'Hrastnik'
        },
        {
            value: 'SI-035',
            labelcz: 'Hrpelje-Kozina'
        },
        {
            value: 'SI-036',
            labelcz: 'Idrija'
        },
        {
            value: 'SI-037',
            labelcz: 'Ig'
        },
        {
            value: 'SI-038',
            labelcz: 'Ilirska Bistrica'
        },
        {
            value: 'SI-039',
            labelcz: 'Ivančna Gorica'
        },
        {
            value: 'SI-040',
            labelcz: 'Izola'
        },
        {
            value: 'SI-041',
            labelcz: 'Jesenice'
        },
        {
            value: 'SI-163',
            labelcz: 'Jezersko'
        },
        {
            value: 'SI-042',
            labelcz: 'Juršinci'
        },
        {
            value: 'SI-043',
            labelcz: 'Kamnik'
        },
        {
            value: 'SI-044',
            labelcz: 'Kanal'
        },
        {
            value: 'SI-045',
            labelcz: 'Kidričevo'
        },
        {
            value: 'SI-046',
            labelcz: 'Kobarid'
        },
        {
            value: 'SI-047',
            labelcz: 'Kobilje'
        },
        {
            value: 'SI-048',
            labelcz: 'Kočevje'
        },
        {
            value: 'SI-049',
            labelcz: 'Komen'
        },
        {
            value: 'SI-164',
            labelcz: 'Komenda'
        },
        {
            value: 'SI-050',
            labelcz: 'Koper'
        },
        {
            value: 'SI-197',
            labelcz: 'Kosanjevica na Krki'
        },
        {
            value: 'SI-165',
            labelcz: 'Kostel'
        },
        {
            value: 'SI-051',
            labelcz: 'Kozje'
        },
        {
            value: 'SI-052',
            labelcz: 'Kranj'
        },
        {
            value: 'SI-053',
            labelcz: 'Kranjska Gora'
        },
        {
            value: 'SI-166',
            labelcz: 'Križevci'
        },
        {
            value: 'SI-054',
            labelcz: 'Krško'
        },
        {
            value: 'SI-055',
            labelcz: 'Kungota'
        },
        {
            value: 'SI-056',
            labelcz: 'Kuzma'
        },
        {
            value: 'SI-057',
            labelcz: 'Laško'
        },
        {
            value: 'SI-058',
            labelcz: 'Lenart'
        },
        {
            value: 'SI-059',
            labelcz: 'Lendava'
        },
        {
            value: 'SI-060',
            labelcz: 'Litija'
        },
        {
            value: 'SI-061',
            labelcz: 'Ljubljana'
        },
        {
            value: 'SI-062',
            labelcz: 'Ljubno'
        },
        {
            value: 'SI-063',
            labelcz: 'Ljutomer'
        },
        {
            value: 'SI-208',
            labelcz: 'Log-Dragomer'
        },
        {
            value: 'SI-064',
            labelcz: 'Logatec'
        },
        {
            value: 'SI-065',
            labelcz: 'Loška dolina'
        },
        {
            value: 'SI-066',
            labelcz: 'Loški Potok'
        },
        {
            value: 'SI-167',
            labelcz: 'Lovrenc na Pohorju'
        },
        {
            value: 'SI-067',
            labelcz: 'Luče'
        },
        {
            value: 'SI-068',
            labelcz: 'Lukovica'
        },
        {
            value: 'SI-069',
            labelcz: 'Majšperk'
        },
        {
            value: 'SI-198',
            labelcz: 'Makole'
        },
        {
            value: 'SI-070',
            labelcz: 'Maribor'
        },
        {
            value: 'SI-168',
            labelcz: 'Markovci'
        },
        {
            value: 'SI-071',
            labelcz: 'Medvode'
        },
        {
            value: 'SI-072',
            labelcz: 'Mengeš'
        },
        {
            value: 'SI-073',
            labelcz: 'Metlika'
        },
        {
            value: 'SI-074',
            labelcz: 'Mežica'
        },
        {
            value: 'SI-169',
            labelcz: 'Miklavž na Dravskem polju'
        },
        {
            value: 'SI-075',
            labelcz: 'Miren-Kostanjevica'
        },
        {
            value: 'SI-212',
            labelcz: 'Mirna'
        },
        {
            value: 'SI-170',
            labelcz: 'Mirna Peč'
        },
        {
            value: 'SI-076',
            labelcz: 'Mislinja'
        },
        {
            value: 'SI-199',
            labelcz: 'Mokronog-Trebelno'
        },
        {
            value: 'SI-077',
            labelcz: 'Moravče'
        },
        {
            value: 'SI-078',
            labelcz: 'Moravske Toplice'
        },
        {
            value: 'SI-079',
            labelcz: 'Mozirje'
        },
        {
            value: 'SI-080',
            labelcz: 'Murska Sobota'
        },
        {
            value: 'SI-081',
            labelcz: 'Muta'
        },
        {
            value: 'SI-082',
            labelcz: 'Naklo'
        },
        {
            value: 'SI-083',
            labelcz: 'Nazarje'
        },
        {
            value: 'SI-084',
            labelcz: 'Nova Gorica'
        },
        {
            value: 'SI-085',
            labelcz: 'Novo Mesto'
        },
        {
            value: 'SI-086',
            labelcz: 'Odranci'
        },
        {
            value: 'SI-171',
            labelcz: 'Oplotnica'
        },
        {
            value: 'SI-087',
            labelcz: 'Ormož'
        },
        {
            value: 'SI-088',
            labelcz: 'Osilnica'
        },
        {
            value: 'SI-089',
            labelcz: 'Pesnica'
        },
        {
            value: 'SI-090',
            labelcz: 'Piran'
        },
        {
            value: 'SI-091',
            labelcz: 'Pivka'
        },
        {
            value: 'SI-092',
            labelcz: 'Podčetrtek'
        },
        {
            value: 'SI-172',
            labelcz: 'Podlehnik'
        },
        {
            value: 'SI-093',
            labelcz: 'Podvelka'
        },
        {
            value: 'SI-200',
            labelcz: 'Poljčane'
        },
        {
            value: 'SI-173',
            labelcz: 'Polzela'
        },
        {
            value: 'SI-094',
            labelcz: 'Postojna'
        },
        {
            value: 'SI-174',
            labelcz: 'Prebold'
        },
        {
            value: 'SI-095',
            labelcz: 'Preddvor'
        },
        {
            value: 'SI-175',
            labelcz: 'Prevalje'
        },
        {
            value: 'SI-096',
            labelcz: 'Ptuj'
        },
        {
            value: 'SI-097',
            labelcz: 'Puconci'
        },
        {
            value: 'SI-098',
            labelcz: 'Rače-Fram'
        },
        {
            value: 'SI-099',
            labelcz: 'Radeče'
        },
        {
            value: 'SI-100',
            labelcz: 'Radenci'
        },
        {
            value: 'SI-101',
            labelcz: 'Radlje ob Dravi'
        },
        {
            value: 'SI-102',
            labelcz: 'Radovljica'
        },
        {
            value: 'SI-103',
            labelcz: 'Ravne na Koroškem'
        },
        {
            value: 'SI-176',
            labelcz: 'Razkrižje'
        },
        {
            value: 'SI-209',
            labelcz: 'Rečica ob Savinji'
        },
        {
            value: 'SI-201',
            labelcz: 'Renče-Vogrsko'
        },
        {
            value: 'SI-104',
            labelcz: 'Ribnica'
        },
        {
            value: 'SI-177',
            labelcz: 'Ribnica na Pohorju'
        },
        {
            value: 'SI-106',
            labelcz: 'Rogaška Slatina'
        },
        {
            value: 'SI-105',
            labelcz: 'Rogašovci'
        },
        {
            value: 'SI-107',
            labelcz: 'Rogatec'
        },
        {
            value: 'SI-108',
            labelcz: 'Ruše'
        },
        {
            value: 'SI-178',
            labelcz: 'Selnica ob Dravi'
        },
        {
            value: 'SI-109',
            labelcz: 'Semič'
        },
        {
            value: 'SI-110',
            labelcz: 'Sevnica'
        },
        {
            value: 'SI-111',
            labelcz: 'Sežana'
        },
        {
            value: 'SI-112',
            labelcz: 'Slovenj Gradec'
        },
        {
            value: 'SI-113',
            labelcz: 'Slovenska Bistrica'
        },
        {
            value: 'SI-114',
            labelcz: 'Slovenske Konjice'
        },
        {
            value: 'SI-179',
            labelcz: 'Sodražica'
        },
        {
            value: 'SI-180',
            labelcz: 'Solčava'
        },
        {
            value: 'SI-202',
            labelcz: 'Središče ob Dravi'
        },
        {
            value: 'SI-115',
            labelcz: 'Starše'
        },
        {
            value: 'SI-203',
            labelcz: 'Straža'
        },
        {
            value: 'SI-181',
            labelcz: 'Sveta Ana'
        },
        {
            value: 'SI-204',
            labelcz: 'Sveta Trojica v Slovenskih goricah'
        },
        {
            value: 'SI-182',
            labelcz: 'Sveti Andraž v Slovenskih goricah'
        },
        {
            value: 'SI-116',
            labelcz: 'Sveti Jurij ob Ščavnici'
        },
        {
            value: 'SI-210',
            labelcz: 'Sveti Jurij v Slovenskih goricah'
        },
        {
            value: 'SI-205',
            labelcz: 'Sveti Tomaž'
        },
        {
            value: 'SI-033',
            labelcz: 'Šalovci'
        },
        {
            value: 'SI-183',
            labelcz: 'Šempeter-Vrtojba'
        },
        {
            value: 'SI-117',
            labelcz: 'Šenčur'
        },
        {
            value: 'SI-118',
            labelcz: 'Šentilj'
        },
        {
            value: 'SI-119',
            labelcz: 'Šentjernej'
        },
        {
            value: 'SI-120',
            labelcz: 'Šentjur'
        },
        {
            value: 'SI-211',
            labelcz: 'Šentrupert'
        },
        {
            value: 'SI-121',
            labelcz: 'Škocjan'
        },
        {
            value: 'SI-122',
            labelcz: 'Škofja Loka'
        },
        {
            value: 'SI-123',
            labelcz: 'Škofljica'
        },
        {
            value: 'SI-124',
            labelcz: 'Šmarje pri Jelšah'
        },
        {
            value: 'SI-206',
            labelcz: 'Šmarješke Toplice'
        },
        {
            value: 'SI-125',
            labelcz: 'Šmartno ob Paki'
        },
        {
            value: 'SI-194',
            labelcz: 'Šmartno pri Litiji'
        },
        {
            value: 'SI-126',
            labelcz: 'Šoštanj'
        },
        {
            value: 'SI-127',
            labelcz: 'Štore'
        },
        {
            value: 'SI-184',
            labelcz: 'Tabor'
        },
        {
            value: 'SI-010',
            labelcz: 'Tišina'
        },
        {
            value: 'SI-128',
            labelcz: 'Tolmin'
        },
        {
            value: 'SI-129',
            labelcz: 'Trbovlje'
        },
        {
            value: 'SI-130',
            labelcz: 'Trebnje'
        },
        {
            value: 'SI-185',
            labelcz: 'Trnovska Vas'
        },
        {
            value: 'SI-186',
            labelcz: 'Trzin'
        },
        {
            value: 'SI-131',
            labelcz: 'Tržič'
        },
        {
            value: 'SI-132',
            labelcz: 'Turnišče'
        },
        {
            value: 'SI-133',
            labelcz: 'Velenje'
        },
        {
            value: 'SI-187',
            labelcz: 'Velika Polana'
        },
        {
            value: 'SI-134',
            labelcz: 'Velike Lašče'
        },
        {
            value: 'SI-188',
            labelcz: 'Veržej'
        },
        {
            value: 'SI-135',
            labelcz: 'Videm'
        },
        {
            value: 'SI-136',
            labelcz: 'Vipava'
        },
        {
            value: 'SI-137',
            labelcz: 'Vitanje'
        },
        {
            value: 'SI-138',
            labelcz: 'Vodice'
        },
        {
            value: 'SI-139',
            labelcz: 'Vojnik'
        },
        {
            value: 'SI-189',
            labelcz: 'Vransko'
        },
        {
            value: 'SI-140',
            labelcz: 'Vrhnika'
        },
        {
            value: 'SI-141',
            labelcz: 'Vuzenica'
        },
        {
            value: 'SI-142',
            labelcz: 'Zagorje ob Savi'
        },
        {
            value: 'SI-143',
            labelcz: 'Zavrč'
        },
        {
            value: 'SI-144',
            labelcz: 'Zreče'
        },
        {
            value: 'SI-190',
            labelcz: 'Žalec'
        },
        {
            value: 'SI-146',
            labelcz: 'Železniki'
        },
        {
            value: 'SI-191',
            labelcz: 'Žetale'
        },
        {
            value: 'SI-147',
            labelcz: 'Žiri'
        },
        {
            value: 'SI-192',
            labelcz: 'Žirovnica'
        },
        {
            value: 'SI-193',
            labelcz: 'Žužemberk'
        }
    ],
    SK: [
        {
            value: 'SK-BC',
            labelcz: 'Banskobystrický kraj'
        },
        {
            value: 'SK-BL',
            labelcz: 'Bratislavský kraj'
        },
        {
            value: 'SK-KI',
            labelcz: 'Košický kraj'
        },
        {
            value: 'SK-NI',
            labelcz: 'Nitriansky kraj'
        },
        {
            value: 'SK-PV',
            labelcz: 'Prešovský kraj'
        },
        {
            value: 'SK-TC',
            labelcz: 'Trenčiansky kraj'
        },
        {
            value: 'SK-TA',
            labelcz: 'Trnavský kraj'
        },
        {
            value: 'SK-ZI',
            labelcz: 'Žilinský kraj'
        }
    ],
    TW: [
        {
            value: 'TW-CYI',
            labelcz: 'Chiayi City'
        },
        {
            value: 'TW-CYQ',
            labelcz: 'Chiayi County'
        },
        {
            value: 'TW-HSQ',
            labelcz: 'Hsinchu County'
        },
        {
            value: 'TW-HSZ',
            labelcz: 'Hsinchu City'
        },
        {
            value: 'TW-HUA',
            labelcz: 'Hualien'
        },
        {
            value: 'TW-CHA',
            labelcz: 'Changhua'
        },
        {
            value: 'TW-ILA',
            labelcz: 'Yilan'
        },
        {
            value: 'TW-KEE',
            labelcz: 'Keelung'
        },
        {
            value: 'TW-KHH',
            labelcz: 'Kaohsiung'
        },
        {
            value: 'TW-KIN',
            labelcz: 'Kinmen'
        },
        {
            value: 'TW-LIE',
            labelcz: 'Lienchiang'
        },
        {
            value: 'TW-MIA',
            labelcz: 'Miaoli'
        },
        {
            value: 'TW-NAN',
            labelcz: 'Nantou'
        },
        {
            value: 'TW-NWT',
            labelcz: 'New Taipei'
        },
        {
            value: 'TW-PEN',
            labelcz: 'Penghu'
        },
        {
            value: 'TW-PIF',
            labelcz: 'Pingtung'
        },
        {
            value: 'TW-TAO',
            labelcz: 'Taoyuan'
        },
        {
            value: 'TW-TNN',
            labelcz: 'Tainan'
        },
        {
            value: 'TW-TPE',
            labelcz: 'Taipei'
        },
        {
            value: 'TW-TTT',
            labelcz: 'Taitung'
        },
        {
            value: 'TW-TXG',
            labelcz: 'Taichung'
        },
        {
            value: 'TW-YUN',
            labelcz: 'Yunlin'
        }
    ],
    US: [
        {
            value: 'US-AK',
            labelcz: 'Alaska'
        },
        {
            value: 'US-AL',
            labelcz: 'Alabama'
        },
        {
            value: 'US-AR',
            labelcz: 'Arkansas'
        },
        {
            value: 'US-AS',
            labelcz: 'American Samoa'
        },
        {
            value: 'US-AZ',
            labelcz: 'Arizona'
        },
        {
            value: 'US-CA',
            labelcz: 'California'
        },
        {
            value: 'US-CO',
            labelcz: 'Colorado'
        },
        {
            value: 'US-CT',
            labelcz: 'Connecticut'
        },
        {
            value: 'US-DC',
            labelcz: 'District of Columbia'
        },
        {
            value: 'US-DE',
            labelcz: 'Delaware'
        },
        {
            value: 'US-FL',
            labelcz: 'Florida'
        },
        {
            value: 'US-GA',
            labelcz: 'Georgia'
        },
        {
            value: 'US-GU',
            labelcz: 'Guam'
        },
        {
            value: 'US-HI',
            labelcz: 'Hawaii'
        },
        {
            value: 'US-IA',
            labelcz: 'Iowa'
        },
        {
            value: 'US-ID',
            labelcz: 'Idaho'
        },
        {
            value: 'US-IL',
            labelcz: 'Illinois'
        },
        {
            value: 'US-IN',
            labelcz: 'Indiana'
        },
        {
            value: 'US-KS',
            labelcz: 'Kansas'
        },
        {
            value: 'US-KY',
            labelcz: 'Kentucky'
        },
        {
            value: 'US-LA',
            labelcz: 'Louisiana'
        },
        {
            value: 'US-MA',
            labelcz: 'Massachusetts'
        },
        {
            value: 'US-MD',
            labelcz: 'Maryland'
        },
        {
            value: 'US-ME',
            labelcz: 'Maine'
        },
        {
            value: 'US-MI',
            labelcz: 'Michigan'
        },
        {
            value: 'US-MN',
            labelcz: 'Minnesota'
        },
        {
            value: 'US-MO',
            labelcz: 'Missouri'
        },
        {
            value: 'US-MP',
            labelcz: 'Northern Mariana Islands'
        },
        {
            value: 'US-MS',
            labelcz: 'Mississippi'
        },
        {
            value: 'US-MT',
            labelcz: 'Montana'
        },
        {
            value: 'US-NC',
            labelcz: 'North Carolina'
        },
        {
            value: 'US-ND',
            labelcz: 'North Dakota'
        },
        {
            value: 'US-NE',
            labelcz: 'Nebraska'
        },
        {
            value: 'US-NH',
            labelcz: 'New Hampshire'
        },
        {
            value: 'US-NJ',
            labelcz: 'New Jersey'
        },
        {
            value: 'US-NM',
            labelcz: 'New Mexico'
        },
        {
            value: 'US-NV',
            labelcz: 'Nevada'
        },
        {
            value: 'US-NY',
            labelcz: 'New York'
        },
        {
            value: 'US-OH',
            labelcz: 'Ohio'
        },
        {
            value: 'US-OK',
            labelcz: 'Oklahoma'
        },
        {
            value: 'US-OR',
            labelcz: 'Oregon'
        },
        {
            value: 'US-PA',
            labelcz: 'Pennsylvania'
        },
        {
            value: 'US-PR',
            labelcz: 'Puerto Rico'
        },
        {
            value: 'US-RI',
            labelcz: 'Rhode Island'
        },
        {
            value: 'US-SC',
            labelcz: 'South Carolina'
        },
        {
            value: 'US-SD',
            labelcz: 'South Dakota'
        },
        {
            value: 'US-TN',
            labelcz: 'Tennessee'
        },
        {
            value: 'US-TX',
            labelcz: 'Texas'
        },
        {
            value: 'US-UM',
            labelcz: 'United States Minor Outlying Islands'
        },
        {
            value: 'US-UT',
            labelcz: 'Utah'
        },
        {
            value: 'US-VA',
            labelcz: 'Virginia'
        },
        {
            value: 'US-VI',
            labelcz: 'Virgin Islands, U.S.'
        },
        {
            value: 'US-VT',
            labelcz: 'Vermont'
        },
        {
            value: 'US-WA',
            labelcz: 'Washington'
        },
        {
            value: 'US-WI',
            labelcz: 'Wisconsin'
        },
        {
            value: 'US-WV',
            labelcz: 'West Virginia'
        },
        {
            value: 'US-WY',
            labelcz: 'Wyoming'
        }
    ],

    // https://github.com/eclipse-tractusx/bpdm/blob/main/bpdm-pool/src/main/resources/regions/IP2LOCATION-ISO3166-2.CSV
    AD: [
        {
            value: 'AD-07',
            labelcz: 'Andorra la Vella'
        },
        {
            value: 'AD-02',
            labelcz: 'Canillo'
        },
        {
            value: 'AD-03',
            labelcz: 'Encamp'
        },
        {
            value: 'AD-08',
            labelcz: 'Escaldes-Engordany'
        },
        {
            value: 'AD-04',
            labelcz: 'La Massana'
        },
        {
            value: 'AD-05',
            labelcz: 'Ordino'
        },
        {
            value: 'AD-06',
            labelcz: 'Sant Julia de Loria'
        }
    ],
    AF: [
        {
            value: 'AF-BDG',
            labelcz: 'Badghis'
        },
        {
            value: 'AF-BGL',
            labelcz: 'Baghlan'
        },
        {
            value: 'AF-BAL',
            labelcz: 'Balkh'
        },
        {
            value: 'AF-BAM',
            labelcz: 'Bamyan'
        },
        {
            value: 'AF-DAY',
            labelcz: 'Daykundi'
        },
        {
            value: 'AF-FRA',
            labelcz: 'Farah'
        },
        {
            value: 'AF-FYB',
            labelcz: 'Faryab'
        },
        {
            value: 'AF-GHA',
            labelcz: 'Ghazni'
        },
        {
            value: 'AF-GHO',
            labelcz: 'Ghor'
        },
        {
            value: 'AF-HEL',
            labelcz: 'Helmand'
        },
        {
            value: 'AF-HER',
            labelcz: 'Herat'
        },
        {
            value: 'AF-JOW',
            labelcz: 'Jowzjan'
        },
        {
            value: 'AF-KAB',
            labelcz: 'Kabul'
        },
        {
            value: 'AF-KAN',
            labelcz: 'Kandahar'
        },
        {
            value: 'AF-KHO',
            labelcz: 'Khost'
        },
        {
            value: 'AF-KDZ',
            labelcz: 'Kunduz'
        },
        {
            value: 'AF-LAG',
            labelcz: 'Laghman'
        },
        {
            value: 'AF-LOG',
            labelcz: 'Logar'
        },
        {
            value: 'AF-NAN',
            labelcz: 'Nangarhar'
        },
        {
            value: 'AF-NIM',
            labelcz: 'Nimroz'
        },
        {
            value: 'AF-PKA',
            labelcz: 'Paktika'
        },
        {
            value: 'AF-PIA',
            labelcz: 'Paktiya'
        },
        {
            value: 'AF-PAR',
            labelcz: 'Parwan'
        },
        {
            value: 'AF-SAM',
            labelcz: 'Samangan'
        },
        {
            value: 'AF-SAR',
            labelcz: 'Sar-e Pul'
        },
        {
            value: 'AF-TAK',
            labelcz: 'Takhar'
        },
        {
            value: 'AF-URU',
            labelcz: 'Uruzgan'
        },
        {
            value: 'AF-WAR',
            labelcz: 'Wardak'
        }
    ],
    AG: [
        {
            value: 'AG-10',
            labelcz: 'Barbuda'
        },
        {
            value: 'AG-11',
            labelcz: 'Redonda'
        },
        {
            value: 'AG-03',
            labelcz: 'Saint George'
        },
        {
            value: 'AG-04',
            labelcz: 'Saint John'
        },
        {
            value: 'AG-05',
            labelcz: 'Saint Mary'
        },
        {
            value: 'AG-07',
            labelcz: 'Saint Peter'
        },
        {
            value: 'AG-08',
            labelcz: 'Saint Philip'
        }
    ],
    AI: [
        {
            value: '-',
            labelcz: 'Anguilla'
        }
    ],
    AL: [
        {
            value: 'AL-01',
            labelcz: 'Berat'
        },
        {
            value: 'AL-09',
            labelcz: 'Diber'
        },
        {
            value: 'AL-02',
            labelcz: 'Durres'
        },
        {
            value: 'AL-03',
            labelcz: 'Elbasan'
        },
        {
            value: 'AL-04',
            labelcz: 'Fier'
        },
        {
            value: 'AL-05',
            labelcz: 'Gjirokaster'
        },
        {
            value: 'AL-06',
            labelcz: 'Korce'
        },
        {
            value: 'AL-07',
            labelcz: 'Kukes'
        },
        {
            value: 'AL-08',
            labelcz: 'Lezhe'
        },
        {
            value: 'AL-10',
            labelcz: 'Shkoder'
        },
        {
            value: 'AL-11',
            labelcz: 'Tirane'
        },
        {
            value: 'AL-12',
            labelcz: 'Vlore'
        }
    ],
    AM: [
        {
            value: 'AM-AG',
            labelcz: 'Aragacotn'
        },
        {
            value: 'AM-AR',
            labelcz: 'Ararat'
        },
        {
            value: 'AM-AV',
            labelcz: 'Armavir'
        },
        {
            value: 'AM-ER',
            labelcz: 'Erevan'
        },
        {
            value: 'AM-GR',
            labelcz: "Gegark'unik'"
        },
        {
            value: 'AM-KT',
            labelcz: "Kotayk'"
        },
        {
            value: 'AM-LO',
            labelcz: 'Lori'
        },
        {
            value: 'AM-SH',
            labelcz: 'Sirak'
        },
        {
            value: 'AM-SU',
            labelcz: "Syunik'"
        },
        {
            value: 'AM-TV',
            labelcz: 'Tavus'
        },
        {
            value: 'AM-VD',
            labelcz: 'Vayoc Jor'
        }
    ],
    AO: [
        {
            value: 'AO-BGO',
            labelcz: 'Bengo'
        },
        {
            value: 'AO-BGU',
            labelcz: 'Benguela'
        },
        {
            value: 'AO-BIE',
            labelcz: 'Bie'
        },
        {
            value: 'AO-CAB',
            labelcz: 'Cabinda'
        },
        {
            value: 'AO-CCU',
            labelcz: 'Cuando Cubango'
        },
        {
            value: 'AO-CNO',
            labelcz: 'Cuanza-Norte'
        },
        {
            value: 'AO-CUS',
            labelcz: 'Cuanza-Sul'
        },
        {
            value: 'AO-CNN',
            labelcz: 'Cunene'
        },
        {
            value: 'AO-HUA',
            labelcz: 'Huambo'
        },
        {
            value: 'AO-HUI',
            labelcz: 'Huila'
        },
        {
            value: 'AO-LUA',
            labelcz: 'Luanda'
        },
        {
            value: 'AO-LNO',
            labelcz: 'Lunda-Norte'
        },
        {
            value: 'AO-LSU',
            labelcz: 'Lunda-Sul'
        },
        {
            value: 'AO-MAL',
            labelcz: 'Malange'
        },
        {
            value: 'AO-MOX',
            labelcz: 'Moxico'
        },
        {
            value: 'AO-NAM',
            labelcz: 'Namibe'
        },
        {
            value: 'AO-UIG',
            labelcz: 'Uige'
        },
        {
            value: 'AO-ZAI',
            labelcz: 'Zaire'
        }
    ],
    AQ: [
        {
            value: '-',
            labelcz: 'Antarctica'
        }
    ],
    AR: [
        {
            value: 'AR-B',
            labelcz: 'Buenos Aires'
        },
        {
            value: 'AR-K',
            labelcz: 'Catamarca'
        },
        {
            value: 'AR-H',
            labelcz: 'Chaco'
        },
        {
            value: 'AR-U',
            labelcz: 'Chubut'
        },
        {
            value: 'AR-C',
            labelcz: 'Ciudad Autonoma de Buenos Aires'
        },
        {
            value: 'AR-X',
            labelcz: 'Cordoba'
        },
        {
            value: 'AR-W',
            labelcz: 'Corrientes'
        },
        {
            value: 'AR-E',
            labelcz: 'Entre Rios'
        },
        {
            value: 'AR-P',
            labelcz: 'Formosa'
        },
        {
            value: 'AR-Y',
            labelcz: 'Jujuy'
        },
        {
            value: 'AR-L',
            labelcz: 'La Pampa'
        },
        {
            value: 'AR-F',
            labelcz: 'La Rioja'
        },
        {
            value: 'AR-M',
            labelcz: 'Mendoza'
        },
        {
            value: 'AR-N',
            labelcz: 'Misiones'
        },
        {
            value: 'AR-Q',
            labelcz: 'Neuquen'
        },
        {
            value: 'AR-R',
            labelcz: 'Rio Negro'
        },
        {
            value: 'AR-A',
            labelcz: 'Salta'
        },
        {
            value: 'AR-J',
            labelcz: 'San Juan'
        },
        {
            value: 'AR-D',
            labelcz: 'San Luis'
        },
        {
            value: 'AR-Z',
            labelcz: 'Santa Cruz'
        },
        {
            value: 'AR-S',
            labelcz: 'Santa Fe'
        },
        {
            value: 'AR-G',
            labelcz: 'Santiago del Estero'
        },
        {
            value: 'AR-V',
            labelcz: 'Tierra del Fuego'
        },
        {
            value: 'AR-T',
            labelcz: 'Tucuman'
        }
    ],
    AS: [
        {
            value: '-',
            labelcz: 'Eastern District'
        },
        {
            value: '-',
            labelcz: 'Western District'
        }
    ],
    AU: [
        {
            value: 'AU-ACT',
            labelcz: 'Australian Capital Territory'
        },
        {
            value: 'AU-NSW',
            labelcz: 'New South Wales'
        },
        {
            value: 'AU-NT',
            labelcz: 'Northern Territory'
        },
        {
            value: 'AU-QLD',
            labelcz: 'Queensland'
        },
        {
            value: 'AU-SA',
            labelcz: 'South Australia'
        },
        {
            value: 'AU-TAS',
            labelcz: 'Tasmania'
        },
        {
            value: 'AU-VIC',
            labelcz: 'Victoria'
        },
        {
            value: 'AU-WA',
            labelcz: 'Western Australia'
        }
    ],
    AW: [
        {
            value: '-',
            labelcz: 'Aruba'
        }
    ],
    AX: [
        {
            value: '-',
            labelcz: 'Eckeroe'
        },
        {
            value: '-',
            labelcz: 'Finstroem'
        },
        {
            value: '-',
            labelcz: 'Hammarland'
        },
        {
            value: '-',
            labelcz: 'Jomala'
        },
        {
            value: '-',
            labelcz: 'Lemland'
        },
        {
            value: '-',
            labelcz: 'Mariehamn'
        },
        {
            value: '-',
            labelcz: 'Saltvik'
        }
    ],
    AZ: [
        {
            value: 'AZ-ABS',
            labelcz: 'Abseron'
        },
        {
            value: 'AZ-AGC',
            labelcz: 'Agcabadi'
        },
        {
            value: 'AZ-AGS',
            labelcz: 'Agdas'
        },
        {
            value: 'AZ-AGA',
            labelcz: 'Agstafa'
        },
        {
            value: 'AZ-AGU',
            labelcz: 'Agsu'
        },
        {
            value: 'AZ-AST',
            labelcz: 'Astara'
        },
        {
            value: 'AZ-BA',
            labelcz: 'Baki'
        },
        {
            value: 'AZ-BAL',
            labelcz: 'Balakan'
        },
        {
            value: 'AZ-BAR',
            labelcz: 'Barda'
        },
        {
            value: 'AZ-BEY',
            labelcz: 'Beylaqan'
        },
        {
            value: 'AZ-BIL',
            labelcz: 'Bilasuvar'
        },
        {
            value: 'AZ-CAL',
            labelcz: 'Calilabad'
        },
        {
            value: 'AZ-DAS',
            labelcz: 'Daskasan'
        },
        {
            value: 'AZ-FUZ',
            labelcz: 'Fuzuli'
        },
        {
            value: 'AZ-GAD',
            labelcz: 'Gadabay'
        },
        {
            value: 'AZ-GA',
            labelcz: 'Ganca'
        },
        {
            value: 'AZ-GOY',
            labelcz: 'Goycay'
        },
        {
            value: 'AZ-GYG',
            labelcz: 'Goygol'
        },
        {
            value: 'AZ-IMI',
            labelcz: 'Imisli'
        },
        {
            value: 'AZ-ISM',
            labelcz: 'Ismayilli'
        },
        {
            value: 'AZ-KUR',
            labelcz: 'Kurdamir'
        },
        {
            value: 'AZ-LA',
            labelcz: 'Lankaran'
        },
        {
            value: 'AZ-MAS',
            labelcz: 'Masalli'
        },
        {
            value: 'AZ-MI',
            labelcz: 'Mingacevir'
        },
        {
            value: 'AZ-NA',
            labelcz: 'Naftalan'
        },
        {
            value: 'AZ-NX',
            labelcz: 'Naxcivan'
        },
        {
            value: 'AZ-NEF',
            labelcz: 'Neftcala'
        },
        {
            value: 'AZ-OGU',
            labelcz: 'Oguz'
        },
        {
            value: 'AZ-QAB',
            labelcz: 'Qabala'
        },
        {
            value: 'AZ-QAX',
            labelcz: 'Qax'
        },
        {
            value: 'AZ-QAZ',
            labelcz: 'Qazax'
        },
        {
            value: 'AZ-QBA',
            labelcz: 'Quba'
        },
        {
            value: 'AZ-QUS',
            labelcz: 'Qusar'
        },
        {
            value: 'AZ-SAT',
            labelcz: 'Saatli'
        },
        {
            value: 'AZ-SAB',
            labelcz: 'Sabirabad'
        },
        {
            value: 'AZ-SAK',
            labelcz: 'Saki'
        },
        {
            value: 'AZ-SAL',
            labelcz: 'Salyan'
        },
        {
            value: 'AZ-SMI',
            labelcz: 'Samaxi'
        },
        {
            value: 'AZ-SKR',
            labelcz: 'Samkir'
        },
        {
            value: 'AZ-SMX',
            labelcz: 'Samux'
        },
        {
            value: 'AZ-SR',
            labelcz: 'Sirvan'
        },
        {
            value: 'AZ-SIY',
            labelcz: 'Siyazan'
        },
        {
            value: 'AZ-SM',
            labelcz: 'Sumqayit'
        },
        {
            value: 'AZ-TAR',
            labelcz: 'Tartar'
        },
        {
            value: 'AZ-TOV',
            labelcz: 'Tovuz'
        },
        {
            value: 'AZ-UCA',
            labelcz: 'Ucar'
        },
        {
            value: 'AZ-XAC',
            labelcz: 'Xacmaz'
        },
        {
            value: 'AZ-XIZ',
            labelcz: 'Xizi'
        },
        {
            value: 'AZ-YAR',
            labelcz: 'Yardimli'
        },
        {
            value: 'AZ-YEV',
            labelcz: 'Yevlax'
        },
        {
            value: 'AZ-ZAQ',
            labelcz: 'Zaqatala'
        },
        {
            value: 'AZ-ZAR',
            labelcz: 'Zardab'
        }
    ],
    BA: [
        {
            value: 'BA-BRC',
            labelcz: 'Brcko distrikt'
        },
        {
            value: 'BA-BIH',
            labelcz: 'Federacija Bosne i Hercegovine'
        },
        {
            value: 'BA-SRP',
            labelcz: 'Republika Srpska'
        }
    ],
    BB: [
        {
            value: 'BB-01',
            labelcz: 'Christ Church'
        },
        {
            value: 'BB-02',
            labelcz: 'Saint Andrew'
        },
        {
            value: 'BB-03',
            labelcz: 'Saint George'
        },
        {
            value: 'BB-04',
            labelcz: 'Saint James'
        },
        {
            value: 'BB-05',
            labelcz: 'Saint John'
        },
        {
            value: 'BB-07',
            labelcz: 'Saint Lucy'
        },
        {
            value: 'BB-08',
            labelcz: 'Saint Michael'
        },
        {
            value: 'BB-09',
            labelcz: 'Saint Peter'
        },
        {
            value: 'BB-10',
            labelcz: 'Saint Philip'
        },
        {
            value: 'BB-11',
            labelcz: 'Saint Thomas'
        }
    ],
    BD: [
        {
            value: 'BD-A',
            labelcz: 'Barishal'
        },
        {
            value: 'BD-B',
            labelcz: 'Chattogram'
        },
        {
            value: 'BD-C',
            labelcz: 'Dhaka'
        },
        {
            value: 'BD-D',
            labelcz: 'Khulna'
        },
        {
            value: 'BD-E',
            labelcz: 'Rajshahi'
        },
        {
            value: 'BD-F',
            labelcz: 'Rangpur'
        },
        {
            value: 'BD-G',
            labelcz: 'Sylhet'
        }
    ],
    BF: [
        {
            value: 'BF-BAL',
            labelcz: 'Bale'
        },
        {
            value: 'BF-BAM',
            labelcz: 'Bam'
        },
        {
            value: 'BF-BAN',
            labelcz: 'Banwa'
        },
        {
            value: 'BF-BAZ',
            labelcz: 'Bazega'
        },
        {
            value: 'BF-BGR',
            labelcz: 'Bougouriba'
        },
        {
            value: 'BF-BLG',
            labelcz: 'Boulgou'
        },
        {
            value: 'BF-BLK',
            labelcz: 'Boulkiemde'
        },
        {
            value: 'BF-COM',
            labelcz: 'Comoe'
        },
        {
            value: 'BF-GAN',
            labelcz: 'Ganzourgou'
        },
        {
            value: 'BF-GNA',
            labelcz: 'Gnagna'
        },
        {
            value: 'BF-GOU',
            labelcz: 'Gourma'
        },
        {
            value: 'BF-HOU',
            labelcz: 'Houet'
        },
        {
            value: 'BF-IOB',
            labelcz: 'Ioba'
        },
        {
            value: 'BF-KAD',
            labelcz: 'Kadiogo'
        },
        {
            value: 'BF-KEN',
            labelcz: 'Kenedougou'
        },
        {
            value: 'BF-KMP',
            labelcz: 'Kompienga'
        },
        {
            value: 'BF-KOS',
            labelcz: 'Kossi'
        },
        {
            value: 'BF-KOT',
            labelcz: 'Kouritenga'
        },
        {
            value: 'BF-KOW',
            labelcz: 'Kourweogo'
        },
        {
            value: 'BF-LER',
            labelcz: 'Leraba'
        },
        {
            value: 'BF-LOR',
            labelcz: 'Loroum'
        },
        {
            value: 'BF-MOU',
            labelcz: 'Mouhoun'
        },
        {
            value: 'BF-NAO',
            labelcz: 'Nahouri'
        },
        {
            value: 'BF-NAM',
            labelcz: 'Namentenga'
        },
        {
            value: 'BF-NAY',
            labelcz: 'Nayala'
        },
        {
            value: 'BF-OUB',
            labelcz: 'Oubritenga'
        },
        {
            value: 'BF-OUD',
            labelcz: 'Oudalan'
        },
        {
            value: 'BF-PAS',
            labelcz: 'Passore'
        },
        {
            value: 'BF-SMT',
            labelcz: 'Sanmatenga'
        },
        {
            value: 'BF-SEN',
            labelcz: 'Seno'
        },
        {
            value: 'BF-SIS',
            labelcz: 'Sissili'
        },
        {
            value: 'BF-SOM',
            labelcz: 'Soum'
        },
        {
            value: 'BF-SOR',
            labelcz: 'Sourou'
        },
        {
            value: 'BF-TAP',
            labelcz: 'Tapoa'
        },
        {
            value: 'BF-TUI',
            labelcz: 'Tuy'
        },
        {
            value: 'BF-YAT',
            labelcz: 'Yatenga'
        },
        {
            value: 'BF-ZIR',
            labelcz: 'Ziro'
        },
        {
            value: 'BF-ZON',
            labelcz: 'Zondoma'
        },
        {
            value: 'BF-ZOU',
            labelcz: 'Zoundweogo'
        }
    ],
    BH: [
        {
            value: 'BH-13',
            labelcz: "Al 'Asimah"
        },
        {
            value: 'BH-14',
            labelcz: 'Al Janubiyah'
        },
        {
            value: 'BH-15',
            labelcz: 'Al Muharraq'
        },
        {
            value: 'BH-17',
            labelcz: 'Ash Shamaliyah'
        }
    ],
    BI: [
        {
            value: 'BI-BM',
            labelcz: 'Bujumbura Mairie'
        },
        {
            value: 'BI-BR',
            labelcz: 'Bururi'
        },
        {
            value: 'BI-CI',
            labelcz: 'Cibitoke'
        },
        {
            value: 'BI-GI',
            labelcz: 'Gitega'
        },
        {
            value: 'BI-KI',
            labelcz: 'Kirundo'
        },
        {
            value: 'BI-MW',
            labelcz: 'Mwaro'
        },
        {
            value: 'BI-NG',
            labelcz: 'Ngozi'
        },
        {
            value: 'BI-RM',
            labelcz: 'Rumonge'
        },
        {
            value: 'BI-RT',
            labelcz: 'Rutana'
        },
        {
            value: 'BI-RY',
            labelcz: 'Ruyigi'
        }
    ],
    BJ: [
        {
            value: 'BJ-AK',
            labelcz: 'Atacora'
        },
        {
            value: 'BJ-AQ',
            labelcz: 'Atlantique'
        },
        {
            value: 'BJ-BO',
            labelcz: 'Borgou'
        },
        {
            value: 'BJ-CO',
            labelcz: 'Collines'
        },
        {
            value: 'BJ-DO',
            labelcz: 'Donga'
        },
        {
            value: 'BJ-LI',
            labelcz: 'Littoral'
        },
        {
            value: 'BJ-MO',
            labelcz: 'Mono'
        },
        {
            value: 'BJ-OU',
            labelcz: 'Oueme'
        },
        {
            value: 'BJ-PL',
            labelcz: 'Plateau'
        },
        {
            value: 'BJ-ZO',
            labelcz: 'Zou'
        }
    ],
    BL: [
        {
            value: '-',
            labelcz: 'Saint Barthelemy'
        }
    ],
    BM: [
        {
            value: '-',
            labelcz: 'Hamilton'
        },
        {
            value: '-',
            labelcz: 'Saint George'
        }
    ],
    BN: [
        {
            value: 'BN-BE',
            labelcz: 'Belait'
        },
        {
            value: 'BN-BM',
            labelcz: 'Brunei-Muara'
        },
        {
            value: 'BN-TE',
            labelcz: 'Temburong'
        },
        {
            value: 'BN-TU',
            labelcz: 'Tutong'
        }
    ],
    BO: [
        {
            value: 'BO-H',
            labelcz: 'Chuquisaca'
        },
        {
            value: 'BO-C',
            labelcz: 'Cochabamba'
        },
        {
            value: 'BO-B',
            labelcz: 'El Beni'
        },
        {
            value: 'BO-L',
            labelcz: 'La Paz'
        },
        {
            value: 'BO-O',
            labelcz: 'Oruro'
        },
        {
            value: 'BO-N',
            labelcz: 'Pando'
        },
        {
            value: 'BO-P',
            labelcz: 'Potosi'
        },
        {
            value: 'BO-S',
            labelcz: 'Santa Cruz'
        },
        {
            value: 'BO-T',
            labelcz: 'Tarija'
        }
    ],
    BQ: [
        {
            value: 'BQ-BO',
            labelcz: 'Bonaire'
        },
        {
            value: 'BQ-SA',
            labelcz: 'Saba'
        },
        {
            value: 'BQ-SE',
            labelcz: 'Sint Eustatius'
        }
    ],
    BR: [
        {
            value: 'BR-AC',
            labelcz: 'Acre'
        },
        {
            value: 'BR-AL',
            labelcz: 'Alagoas'
        },
        {
            value: 'BR-AP',
            labelcz: 'Amapa'
        },
        {
            value: 'BR-AM',
            labelcz: 'Amazonas'
        },
        {
            value: 'BR-BA',
            labelcz: 'Bahia'
        },
        {
            value: 'BR-CE',
            labelcz: 'Ceara'
        },
        {
            value: 'BR-DF',
            labelcz: 'Distrito Federal'
        },
        {
            value: 'BR-ES',
            labelcz: 'Espirito Santo'
        },
        {
            value: 'BR-GO',
            labelcz: 'Goias'
        },
        {
            value: 'BR-MA',
            labelcz: 'Maranhao'
        },
        {
            value: 'BR-MT',
            labelcz: 'Mato Grosso'
        },
        {
            value: 'BR-MS',
            labelcz: 'Mato Grosso do Sul'
        },
        {
            value: 'BR-MG',
            labelcz: 'Minas Gerais'
        },
        {
            value: 'BR-PA',
            labelcz: 'Para'
        },
        {
            value: 'BR-PB',
            labelcz: 'Paraiba'
        },
        {
            value: 'BR-PR',
            labelcz: 'Parana'
        },
        {
            value: 'BR-PE',
            labelcz: 'Pernambuco'
        },
        {
            value: 'BR-PI',
            labelcz: 'Piaui'
        },
        {
            value: 'BR-RN',
            labelcz: 'Rio Grande do Norte'
        },
        {
            value: 'BR-RS',
            labelcz: 'Rio Grande do Sul'
        },
        {
            value: 'BR-RJ',
            labelcz: 'Rio de Janeiro'
        },
        {
            value: 'BR-RO',
            labelcz: 'Rondonia'
        },
        {
            value: 'BR-RR',
            labelcz: 'Roraima'
        },
        {
            value: 'BR-SC',
            labelcz: 'Santa Catarina'
        },
        {
            value: 'BR-SP',
            labelcz: 'Sao Paulo'
        },
        {
            value: 'BR-SE',
            labelcz: 'Sergipe'
        },
        {
            value: 'BR-TO',
            labelcz: 'Tocantins'
        }
    ],
    BS: [
        {
            value: 'BS-BP',
            labelcz: 'Black Point'
        },
        {
            value: 'BS-CO',
            labelcz: 'Central Abaco'
        },
        {
            value: 'BS-FP',
            labelcz: 'City of Freeport'
        },
        {
            value: 'BS-EG',
            labelcz: 'East Grand Bahama'
        },
        {
            value: 'BS-HI',
            labelcz: 'Harbour Island'
        },
        {
            value: 'BS-LI',
            labelcz: 'Long Island'
        },
        {
            value: 'BS-NP',
            labelcz: 'New Providence'
        },
        {
            value: 'BS-NS',
            labelcz: 'North Andros'
        },
        {
            value: 'BS-NE',
            labelcz: 'North Eleuthera'
        },
        {
            value: 'BS-SS',
            labelcz: 'San Salvador'
        },
        {
            value: 'BS-SE',
            labelcz: 'South Eleuthera'
        },
        {
            value: 'BS-WG',
            labelcz: 'West Grand Bahama'
        }
    ],
    BT: [
        {
            value: 'BT-33',
            labelcz: 'Bumthang'
        },
        {
            value: 'BT-12',
            labelcz: 'Chhukha'
        },
        {
            value: 'BT-22',
            labelcz: 'Dagana'
        },
        {
            value: 'BT-GA',
            labelcz: 'Gasa'
        },
        {
            value: 'BT-44',
            labelcz: 'Lhuentse'
        },
        {
            value: 'BT-42',
            labelcz: 'Monggar'
        },
        {
            value: 'BT-11',
            labelcz: 'Paro'
        },
        {
            value: 'BT-43',
            labelcz: 'Pema Gatshel'
        },
        {
            value: 'BT-23',
            labelcz: 'Punakha'
        },
        {
            value: 'BT-45',
            labelcz: 'Samdrup Jongkhar'
        },
        {
            value: 'BT-14',
            labelcz: 'Samtse'
        },
        {
            value: 'BT-31',
            labelcz: 'Sarpang'
        },
        {
            value: 'BT-15',
            labelcz: 'Thimphu'
        },
        {
            value: 'BT-41',
            labelcz: 'Trashigang'
        },
        {
            value: 'BT-32',
            labelcz: 'Trongsa'
        },
        {
            value: 'BT-21',
            labelcz: 'Tsirang'
        },
        {
            value: 'BT-24',
            labelcz: 'Wangdue Phodrang'
        },
        {
            value: 'BT-34',
            labelcz: 'Zhemgang'
        }
    ],
    BV: [
        {
            value: '-',
            labelcz: 'Bouvet Island'
        }
    ],
    BW: [
        {
            value: 'BW-CE',
            labelcz: 'Central'
        },
        {
            value: 'BW-CH',
            labelcz: 'Chobe'
        },
        {
            value: 'BW-GH',
            labelcz: 'Ghanzi'
        },
        {
            value: 'BW-KG',
            labelcz: 'Kgalagadi'
        },
        {
            value: 'BW-KL',
            labelcz: 'Kgatleng'
        },
        {
            value: 'BW-KW',
            labelcz: 'Kweneng'
        },
        {
            value: 'BW-NE',
            labelcz: 'North East'
        },
        {
            value: 'BW-NW',
            labelcz: 'North West'
        },
        {
            value: 'BW-SE',
            labelcz: 'South East'
        },
        {
            value: 'BW-SO',
            labelcz: 'Southern'
        }
    ],
    BY: [
        {
            value: 'BY-BR',
            labelcz: "Brestskaya voblasts'"
        },
        {
            value: 'BY-HO',
            labelcz: "Homyel'skaya voblasts'"
        },
        {
            value: 'BY-HM',
            labelcz: 'Horad Minsk'
        },
        {
            value: 'BY-HR',
            labelcz: "Hrodzyenskaya voblasts'"
        },
        {
            value: 'BY-MA',
            labelcz: "Mahilyowskaya voblasts'"
        },
        {
            value: 'BY-MI',
            labelcz: "Minskaya voblasts'"
        },
        {
            value: 'BY-VI',
            labelcz: "Vitsyebskaya voblasts'"
        }
    ],
    CC: [
        {
            value: '-',
            labelcz: 'Cocos (Keeling) Islands'
        }
    ],
    CD: [
        {
            value: 'CD-EQ',
            labelcz: 'Equateur'
        },
        {
            value: 'CD-HK',
            labelcz: 'Haut-Katanga'
        },
        {
            value: 'CD-HL',
            labelcz: 'Haut-Lomami'
        },
        {
            value: 'CD-IT',
            labelcz: 'Ituri'
        },
        {
            value: 'CD-KS',
            labelcz: 'Kasai'
        },
        {
            value: 'CD-KC',
            labelcz: 'Kasai Central'
        },
        {
            value: 'CD-KE',
            labelcz: 'Kasai Oriental'
        },
        {
            value: 'CD-KN',
            labelcz: 'Kinshasa'
        },
        {
            value: 'CD-LU',
            labelcz: 'Lualaba'
        },
        {
            value: 'CD-MA',
            labelcz: 'Maniema'
        },
        {
            value: 'CD-NK',
            labelcz: 'Nord-Kivu'
        },
        {
            value: 'CD-SA',
            labelcz: 'Sankuru'
        },
        {
            value: 'CD-SK',
            labelcz: 'Sud-Kivu'
        },
        {
            value: 'CD-TA',
            labelcz: 'Tanganyika'
        },
        {
            value: 'CD-TO',
            labelcz: 'Tshopo'
        }
    ],
    CF: [
        {
            value: 'CF-BB',
            labelcz: 'Bamingui-Bangoran'
        },
        {
            value: 'CF-BGF',
            labelcz: 'Bangui'
        },
        {
            value: 'CF-KB',
            labelcz: 'Gribingui'
        },
        {
            value: 'CF-KG',
            labelcz: 'Kemo-Gribingui'
        },
        {
            value: 'CF-HS',
            labelcz: 'Mambere-Kadei'
        },
        {
            value: 'CF-NM',
            labelcz: 'Nana-Mambere'
        },
        {
            value: 'CF-UK',
            labelcz: 'Ouaka'
        },
        {
            value: 'CF-AC',
            labelcz: 'Ouham'
        },
        {
            value: 'CF-OP',
            labelcz: 'Ouham-Pende'
        },
        {
            value: 'CF-VK',
            labelcz: 'Vakaga'
        }
    ],
    CG: [
        {
            value: 'CG-11',
            labelcz: 'Bouenza'
        },
        {
            value: 'CG-BZV',
            labelcz: 'Brazzaville'
        },
        {
            value: 'CG-8',
            labelcz: 'Cuvette'
        },
        {
            value: 'CG-9',
            labelcz: 'Niari'
        },
        {
            value: 'CG-14',
            labelcz: 'Plateaux'
        },
        {
            value: 'CG-16',
            labelcz: 'Pointe-Noire'
        },
        {
            value: 'CG-13',
            labelcz: 'Sangha'
        }
    ],
    CI: [
        {
            value: 'CI-AB',
            labelcz: 'Abidjan'
        },
        {
            value: 'CI-BS',
            labelcz: 'Bas-Sassandra'
        },
        {
            value: 'CI-CM',
            labelcz: 'Comoe'
        },
        {
            value: 'CI-DN',
            labelcz: 'Denguele'
        },
        {
            value: 'CI-GD',
            labelcz: 'Goh-Djiboua'
        },
        {
            value: 'CI-LC',
            labelcz: 'Lacs'
        },
        {
            value: 'CI-LG',
            labelcz: 'Lagunes'
        },
        {
            value: 'CI-MG',
            labelcz: 'Montagnes'
        },
        {
            value: 'CI-SM',
            labelcz: 'Sassandra-Marahoue'
        },
        {
            value: 'CI-SV',
            labelcz: 'Savanes'
        },
        {
            value: 'CI-VB',
            labelcz: 'Vallee du Bandama'
        },
        {
            value: 'CI-WR',
            labelcz: 'Woroba'
        },
        {
            value: 'CI-YM',
            labelcz: 'Yamoussoukro'
        },
        {
            value: 'CI-ZZ',
            labelcz: 'Zanzan'
        }
    ],
    CK: [
        {
            value: '-',
            labelcz: 'Cook Islands'
        }
    ],
    CL: [
        {
            value: 'CL-AI',
            labelcz: 'Aisen del General Carlos Ibanez del Campo'
        },
        {
            value: 'CL-AN',
            labelcz: 'Antofagasta'
        },
        {
            value: 'CL-AP',
            labelcz: 'Arica y Parinacota'
        },
        {
            value: 'CL-AT',
            labelcz: 'Atacama'
        },
        {
            value: 'CL-BI',
            labelcz: 'Biobio'
        },
        {
            value: 'CL-CO',
            labelcz: 'Coquimbo'
        },
        {
            value: 'CL-AR',
            labelcz: 'La Araucania'
        },
        {
            value: 'CL-LI',
            labelcz: "Libertador General Bernardo O'Higgins"
        },
        {
            value: 'CL-LL',
            labelcz: 'Los Lagos'
        },
        {
            value: 'CL-LR',
            labelcz: 'Los Rios'
        },
        {
            value: 'CL-MA',
            labelcz: 'Magallanes'
        },
        {
            value: 'CL-ML',
            labelcz: 'Maule'
        },
        {
            value: 'CL-NB',
            labelcz: 'Nuble'
        },
        {
            value: 'CL-RM',
            labelcz: 'Region Metropolitana de Santiago'
        },
        {
            value: 'CL-TA',
            labelcz: 'Tarapaca'
        },
        {
            value: 'CL-VS',
            labelcz: 'Valparaiso'
        }
    ],
    CM: [
        {
            value: 'CM-AD',
            labelcz: 'Adamaoua'
        },
        {
            value: 'CM-CE',
            labelcz: 'Centre'
        },
        {
            value: 'CM-ES',
            labelcz: 'Est'
        },
        {
            value: 'CM-EN',
            labelcz: 'Extreme-Nord'
        },
        {
            value: 'CM-LT',
            labelcz: 'Littoral'
        },
        {
            value: 'CM-NO',
            labelcz: 'Nord'
        },
        {
            value: 'CM-NW',
            labelcz: 'Nord-Ouest'
        },
        {
            value: 'CM-OU',
            labelcz: 'Ouest'
        },
        {
            value: 'CM-SU',
            labelcz: 'Sud'
        },
        {
            value: 'CM-SW',
            labelcz: 'Sud-Ouest'
        }
    ],
    CO: [
        {
            value: 'CO-AMA',
            labelcz: 'Amazonas'
        },
        {
            value: 'CO-ANT',
            labelcz: 'Antioquia'
        },
        {
            value: 'CO-ARA',
            labelcz: 'Arauca'
        },
        {
            value: 'CO-ATL',
            labelcz: 'Atlantico'
        },
        {
            value: 'CO-BOL',
            labelcz: 'Bolivar'
        },
        {
            value: 'CO-BOY',
            labelcz: 'Boyaca'
        },
        {
            value: 'CO-CAL',
            labelcz: 'Caldas'
        },
        {
            value: 'CO-CAQ',
            labelcz: 'Caqueta'
        },
        {
            value: 'CO-CAS',
            labelcz: 'Casanare'
        },
        {
            value: 'CO-CAU',
            labelcz: 'Cauca'
        },
        {
            value: 'CO-CES',
            labelcz: 'Cesar'
        },
        {
            value: 'CO-CHO',
            labelcz: 'Choco'
        },
        {
            value: 'CO-COR',
            labelcz: 'Cordoba'
        },
        {
            value: 'CO-CUN',
            labelcz: 'Cundinamarca'
        },
        {
            value: 'CO-DC',
            labelcz: 'Distrito Capital de Bogota'
        },
        {
            value: 'CO-GUA',
            labelcz: 'Guainia'
        },
        {
            value: 'CO-GUV',
            labelcz: 'Guaviare'
        },
        {
            value: 'CO-HUI',
            labelcz: 'Huila'
        },
        {
            value: 'CO-LAG',
            labelcz: 'La Guajira'
        },
        {
            value: 'CO-MAG',
            labelcz: 'Magdalena'
        },
        {
            value: 'CO-MET',
            labelcz: 'Meta'
        },
        {
            value: 'CO-NAR',
            labelcz: 'Narino'
        },
        {
            value: 'CO-NSA',
            labelcz: 'Norte de Santander'
        },
        {
            value: 'CO-PUT',
            labelcz: 'Putumayo'
        },
        {
            value: 'CO-QUI',
            labelcz: 'Quindio'
        },
        {
            value: 'CO-RIS',
            labelcz: 'Risaralda'
        },
        {
            value: 'CO-SAP',
            labelcz: 'San Andres, Providencia y Santa Catalina'
        },
        {
            value: 'CO-SAN',
            labelcz: 'Santander'
        },
        {
            value: 'CO-SUC',
            labelcz: 'Sucre'
        },
        {
            value: 'CO-TOL',
            labelcz: 'Tolima'
        },
        {
            value: 'CO-VAC',
            labelcz: 'Valle del Cauca'
        },
        {
            value: 'CO-VID',
            labelcz: 'Vichada'
        }
    ],
    CR: [
        {
            value: 'CR-A',
            labelcz: 'Alajuela'
        },
        {
            value: 'CR-C',
            labelcz: 'Cartago'
        },
        {
            value: 'CR-G',
            labelcz: 'Guanacaste'
        },
        {
            value: 'CR-H',
            labelcz: 'Heredia'
        },
        {
            value: 'CR-L',
            labelcz: 'Limon'
        },
        {
            value: 'CR-P',
            labelcz: 'Puntarenas'
        },
        {
            value: 'CR-SJ',
            labelcz: 'San Jose'
        }
    ],
    CU: [
        {
            value: 'CU-15',
            labelcz: 'Artemisa'
        },
        {
            value: 'CU-09',
            labelcz: 'Camaguey'
        },
        {
            value: 'CU-08',
            labelcz: 'Ciego de Avila'
        },
        {
            value: 'CU-06',
            labelcz: 'Cienfuegos'
        },
        {
            value: 'CU-12',
            labelcz: 'Granma'
        },
        {
            value: 'CU-14',
            labelcz: 'Guantanamo'
        },
        {
            value: 'CU-11',
            labelcz: 'Holguin'
        },
        {
            value: 'CU-99',
            labelcz: 'Isla de la Juventud'
        },
        {
            value: 'CU-03',
            labelcz: 'La Habana'
        },
        {
            value: 'CU-10',
            labelcz: 'Las Tunas'
        },
        {
            value: 'CU-04',
            labelcz: 'Matanzas'
        },
        {
            value: 'CU-16',
            labelcz: 'Mayabeque'
        },
        {
            value: 'CU-01',
            labelcz: 'Pinar del Rio'
        },
        {
            value: 'CU-07',
            labelcz: 'Sancti Spiritus'
        },
        {
            value: 'CU-13',
            labelcz: 'Santiago de Cuba'
        },
        {
            value: 'CU-05',
            labelcz: 'Villa Clara'
        }
    ],
    CV: [
        {
            value: 'CV-BV',
            labelcz: 'Boa Vista'
        },
        {
            value: 'CV-BR',
            labelcz: 'Brava'
        },
        {
            value: 'CV-MO',
            labelcz: 'Mosteiros'
        },
        {
            value: 'CV-PN',
            labelcz: 'Porto Novo'
        },
        {
            value: 'CV-PR',
            labelcz: 'Praia'
        },
        {
            value: 'CV-RS',
            labelcz: 'Ribeira Grande de Santiago'
        },
        {
            value: 'CV-SL',
            labelcz: 'Sal'
        },
        {
            value: 'CV-SV',
            labelcz: 'Sao Vicente'
        },
        {
            value: 'CV-TA',
            labelcz: 'Tarrafal'
        }
    ],
    CW: [
        {
            value: '-',
            labelcz: 'Curacao'
        }
    ],
    CX: [
        {
            value: '-',
            labelcz: 'Christmas Island'
        }
    ],
    DJ: [
        {
            value: 'DJ-AR',
            labelcz: 'Arta'
        },
        {
            value: 'DJ-DI',
            labelcz: 'Dikhil'
        },
        {
            value: 'DJ-DJ',
            labelcz: 'Djibouti'
        }
    ],
    DM: [
        {
            value: 'DM-02',
            labelcz: 'Saint Andrew'
        },
        {
            value: 'DM-04',
            labelcz: 'Saint George'
        },
        {
            value: 'DM-05',
            labelcz: 'Saint John'
        },
        {
            value: 'DM-06',
            labelcz: 'Saint Joseph'
        },
        {
            value: 'DM-07',
            labelcz: 'Saint Luke'
        },
        {
            value: 'DM-09',
            labelcz: 'Saint Patrick'
        },
        {
            value: 'DM-10',
            labelcz: 'Saint Paul'
        }
    ],
    DO: [
        {
            value: 'DO-02',
            labelcz: 'Azua'
        },
        {
            value: 'DO-03',
            labelcz: 'Baoruco'
        },
        {
            value: 'DO-04',
            labelcz: 'Barahona'
        },
        {
            value: 'DO-05',
            labelcz: 'Dajabon'
        },
        {
            value: 'DO-01',
            labelcz: 'Distrito Nacional (Santo Domingo)'
        },
        {
            value: 'DO-06',
            labelcz: 'Duarte'
        },
        {
            value: 'DO-08',
            labelcz: 'El Seibo'
        },
        {
            value: 'DO-07',
            labelcz: 'Elias Pina'
        },
        {
            value: 'DO-09',
            labelcz: 'Espaillat'
        },
        {
            value: 'DO-30',
            labelcz: 'Hato Mayor'
        },
        {
            value: 'DO-19',
            labelcz: 'Hermanas Mirabal'
        },
        {
            value: 'DO-10',
            labelcz: 'Independencia'
        },
        {
            value: 'DO-11',
            labelcz: 'La Altagracia'
        },
        {
            value: 'DO-12',
            labelcz: 'La Romana'
        },
        {
            value: 'DO-13',
            labelcz: 'La Vega'
        },
        {
            value: 'DO-14',
            labelcz: 'Maria Trinidad Sanchez'
        },
        {
            value: 'DO-28',
            labelcz: 'Monsenor Nouel'
        },
        {
            value: 'DO-15',
            labelcz: 'Monte Cristi'
        },
        {
            value: 'DO-29',
            labelcz: 'Monte Plata'
        },
        {
            value: 'DO-16',
            labelcz: 'Pedernales'
        },
        {
            value: 'DO-17',
            labelcz: 'Peravia'
        },
        {
            value: 'DO-18',
            labelcz: 'Puerto Plata'
        },
        {
            value: 'DO-20',
            labelcz: 'Samana'
        },
        {
            value: 'DO-21',
            labelcz: 'San Cristobal'
        },
        {
            value: 'DO-31',
            labelcz: 'San Jose de Ocoa'
        },
        {
            value: 'DO-22',
            labelcz: 'San Juan'
        },
        {
            value: 'DO-23',
            labelcz: 'San Pedro de Macoris'
        },
        {
            value: 'DO-24',
            labelcz: 'Sanchez Ramirez'
        },
        {
            value: 'DO-25',
            labelcz: 'Santiago'
        },
        {
            value: 'DO-26',
            labelcz: 'Santiago Rodriguez'
        },
        {
            value: 'DO-27',
            labelcz: 'Valverde'
        }
    ],
    DZ: [
        {
            value: 'DZ-01',
            labelcz: 'Adrar'
        },
        {
            value: 'DZ-44',
            labelcz: 'Ain Defla'
        },
        {
            value: 'DZ-46',
            labelcz: 'Ain Temouchent'
        },
        {
            value: 'DZ-16',
            labelcz: 'Alger'
        },
        {
            value: 'DZ-23',
            labelcz: 'Annaba'
        },
        {
            value: 'DZ-05',
            labelcz: 'Batna'
        },
        {
            value: 'DZ-08',
            labelcz: 'Bechar'
        },
        {
            value: 'DZ-06',
            labelcz: 'Bejaia'
        },
        {
            value: 'DZ-07',
            labelcz: 'Biskra'
        },
        {
            value: 'DZ-09',
            labelcz: 'Blida'
        },
        {
            value: 'DZ-34',
            labelcz: 'Bordj Bou Arreridj'
        },
        {
            value: 'DZ-10',
            labelcz: 'Bouira'
        },
        {
            value: 'DZ-35',
            labelcz: 'Boumerdes'
        },
        {
            value: 'DZ-02',
            labelcz: 'Chlef'
        },
        {
            value: 'DZ-25',
            labelcz: 'Constantine'
        },
        {
            value: 'DZ-56',
            labelcz: 'Djanet'
        },
        {
            value: 'DZ-17',
            labelcz: 'Djelfa'
        },
        {
            value: 'DZ-32',
            labelcz: 'El Bayadh'
        },
        {
            value: 'DZ-57',
            labelcz: 'El Meghaier'
        },
        {
            value: 'DZ-39',
            labelcz: 'El Oued'
        },
        {
            value: 'DZ-36',
            labelcz: 'El Tarf'
        },
        {
            value: 'DZ-47',
            labelcz: 'Ghardaia'
        },
        {
            value: 'DZ-24',
            labelcz: 'Guelma'
        },
        {
            value: 'DZ-33',
            labelcz: 'Illizi'
        },
        {
            value: 'DZ-53',
            labelcz: 'In Salah'
        },
        {
            value: 'DZ-18',
            labelcz: 'Jijel'
        },
        {
            value: 'DZ-40',
            labelcz: 'Khenchela'
        },
        {
            value: 'DZ-03',
            labelcz: 'Laghouat'
        },
        {
            value: 'DZ-28',
            labelcz: "M'sila"
        },
        {
            value: 'DZ-29',
            labelcz: 'Mascara'
        },
        {
            value: 'DZ-26',
            labelcz: 'Medea'
        },
        {
            value: 'DZ-43',
            labelcz: 'Mila'
        },
        {
            value: 'DZ-27',
            labelcz: 'Mostaganem'
        },
        {
            value: 'DZ-45',
            labelcz: 'Naama'
        },
        {
            value: 'DZ-31',
            labelcz: 'Oran'
        },
        {
            value: 'DZ-30',
            labelcz: 'Ouargla'
        },
        {
            value: 'DZ-51',
            labelcz: 'Ouled Djellal'
        },
        {
            value: 'DZ-04',
            labelcz: 'Oum el Bouaghi'
        },
        {
            value: 'DZ-48',
            labelcz: 'Relizane'
        },
        {
            value: 'DZ-20',
            labelcz: 'Saida'
        },
        {
            value: 'DZ-19',
            labelcz: 'Setif'
        },
        {
            value: 'DZ-22',
            labelcz: 'Sidi Bel Abbes'
        },
        {
            value: 'DZ-21',
            labelcz: 'Skikda'
        },
        {
            value: 'DZ-41',
            labelcz: 'Souk Ahras'
        },
        {
            value: 'DZ-11',
            labelcz: 'Tamanrasset'
        },
        {
            value: 'DZ-12',
            labelcz: 'Tebessa'
        },
        {
            value: 'DZ-14',
            labelcz: 'Tiaret'
        },
        {
            value: 'DZ-49',
            labelcz: 'Timimoun'
        },
        {
            value: 'DZ-37',
            labelcz: 'Tindouf'
        },
        {
            value: 'DZ-42',
            labelcz: 'Tipaza'
        },
        {
            value: 'DZ-38',
            labelcz: 'Tissemsilt'
        },
        {
            value: 'DZ-15',
            labelcz: 'Tizi Ouzou'
        },
        {
            value: 'DZ-13',
            labelcz: 'Tlemcen'
        },
        {
            value: 'DZ-55',
            labelcz: 'Touggourt'
        }
    ],
    EC: [
        {
            value: 'EC-A',
            labelcz: 'Azuay'
        },
        {
            value: 'EC-B',
            labelcz: 'Bolivar'
        },
        {
            value: 'EC-F',
            labelcz: 'Canar'
        },
        {
            value: 'EC-C',
            labelcz: 'Carchi'
        },
        {
            value: 'EC-H',
            labelcz: 'Chimborazo'
        },
        {
            value: 'EC-X',
            labelcz: 'Cotopaxi'
        },
        {
            value: 'EC-O',
            labelcz: 'El Oro'
        },
        {
            value: 'EC-E',
            labelcz: 'Esmeraldas'
        },
        {
            value: 'EC-W',
            labelcz: 'Galapagos'
        },
        {
            value: 'EC-G',
            labelcz: 'Guayas'
        },
        {
            value: 'EC-I',
            labelcz: 'Imbabura'
        },
        {
            value: 'EC-L',
            labelcz: 'Loja'
        },
        {
            value: 'EC-R',
            labelcz: 'Los Rios'
        },
        {
            value: 'EC-M',
            labelcz: 'Manabi'
        },
        {
            value: 'EC-S',
            labelcz: 'Morona Santiago'
        },
        {
            value: 'EC-N',
            labelcz: 'Napo'
        },
        {
            value: 'EC-D',
            labelcz: 'Orellana'
        },
        {
            value: 'EC-Y',
            labelcz: 'Pastaza'
        },
        {
            value: 'EC-P',
            labelcz: 'Pichincha'
        },
        {
            value: 'EC-SE',
            labelcz: 'Santa Elena'
        },
        {
            value: 'EC-SD',
            labelcz: 'Santo Domingo de los Tsachilas'
        },
        {
            value: 'EC-U',
            labelcz: 'Sucumbios'
        },
        {
            value: 'EC-T',
            labelcz: 'Tungurahua'
        },
        {
            value: 'EC-Z',
            labelcz: 'Zamora Chinchipe'
        }
    ],
    EG: [
        {
            value: 'EG-DK',
            labelcz: 'Ad Daqahliyah'
        },
        {
            value: 'EG-BA',
            labelcz: 'Al Bahr al Ahmar'
        },
        {
            value: 'EG-BH',
            labelcz: 'Al Buhayrah'
        },
        {
            value: 'EG-FYM',
            labelcz: 'Al Fayyum'
        },
        {
            value: 'EG-GH',
            labelcz: 'Al Gharbiyah'
        },
        {
            value: 'EG-ALX',
            labelcz: 'Al Iskandariyah'
        },
        {
            value: 'EG-IS',
            labelcz: "Al Isma'iliyah"
        },
        {
            value: 'EG-GZ',
            labelcz: 'Al Jizah'
        },
        {
            value: 'EG-MNF',
            labelcz: 'Al Minufiyah'
        },
        {
            value: 'EG-MN',
            labelcz: 'Al Minya'
        },
        {
            value: 'EG-C',
            labelcz: 'Al Qahirah'
        },
        {
            value: 'EG-KB',
            labelcz: 'Al Qalyubiyah'
        },
        {
            value: 'EG-LX',
            labelcz: 'Al Uqsur'
        },
        {
            value: 'EG-WAD',
            labelcz: 'Al Wadi al Jadid'
        },
        {
            value: 'EG-SUZ',
            labelcz: 'As Suways'
        },
        {
            value: 'EG-SHR',
            labelcz: 'Ash Sharqiyah'
        },
        {
            value: 'EG-ASN',
            labelcz: 'Aswan'
        },
        {
            value: 'EG-AST',
            labelcz: 'Asyut'
        },
        {
            value: 'EG-BNS',
            labelcz: 'Bani Suwayf'
        },
        {
            value: 'EG-PTS',
            labelcz: "Bur Sa'id"
        },
        {
            value: 'EG-DT',
            labelcz: 'Dumyat'
        },
        {
            value: 'EG-JS',
            labelcz: "Janub Sina'"
        },
        {
            value: 'EG-KFS',
            labelcz: 'Kafr ash Shaykh'
        },
        {
            value: 'EG-MT',
            labelcz: 'Matruh'
        },
        {
            value: 'EG-KN',
            labelcz: 'Qina'
        },
        {
            value: 'EG-SIN',
            labelcz: "Shamal Sina'"
        },
        {
            value: 'EG-SHG',
            labelcz: 'Suhaj'
        }
    ],
    EH: [
        {
            value: '-',
            labelcz: 'Western Sahara'
        }
    ],
    ER: [
        {
            value: 'ER-MA',
            labelcz: 'Al Awsat'
        },
        {
            value: 'ER-GB',
            labelcz: 'Qash-Barkah'
        }
    ],
    ET: [
        {
            value: 'ET-AA',
            labelcz: 'Addis Ababa'
        },
        {
            value: 'ET-AF',
            labelcz: 'Afar'
        },
        {
            value: 'ET-AM',
            labelcz: 'Amara'
        },
        {
            value: 'ET-BE',
            labelcz: 'Benshangul-Gumaz'
        },
        {
            value: 'ET-DD',
            labelcz: 'Dire Dawa'
        },
        {
            value: 'ET-HA',
            labelcz: 'Harari People'
        },
        {
            value: 'ET-OR',
            labelcz: 'Oromia'
        },
        {
            value: 'ET-SO',
            labelcz: 'Somali'
        },
        {
            value: 'ET-SN',
            labelcz: 'Southern Nations, Nationalities and Peoples'
        },
        {
            value: 'ET-TI',
            labelcz: 'Tigrai'
        }
    ],
    FJ: [
        {
            value: 'FJ-C',
            labelcz: 'Central'
        },
        {
            value: 'FJ-E',
            labelcz: 'Eastern'
        },
        {
            value: 'FJ-N',
            labelcz: 'Northern'
        },
        {
            value: 'FJ-R',
            labelcz: 'Rotuma'
        },
        {
            value: 'FJ-W',
            labelcz: 'Western'
        }
    ],
    FK: [
        {
            value: '-',
            labelcz: 'Falkland Islands (Malvinas)'
        }
    ],
    FM: [
        {
            value: 'FM-TRK',
            labelcz: 'Chuuk'
        },
        {
            value: 'FM-KSA',
            labelcz: 'Kosrae'
        },
        {
            value: 'FM-PNI',
            labelcz: 'Pohnpei'
        },
        {
            value: 'FM-YAP',
            labelcz: 'Yap'
        }
    ],
    FO: [
        {
            value: '-',
            labelcz: 'Eysturoy'
        },
        {
            value: '-',
            labelcz: 'Nordoyar'
        },
        {
            value: '-',
            labelcz: 'Streymoy'
        },
        {
            value: '-',
            labelcz: 'Suduroy'
        },
        {
            value: '-',
            labelcz: 'Vagar'
        }
    ],
    GA: [
        {
            value: 'GA-1',
            labelcz: 'Estuaire'
        },
        {
            value: 'GA-2',
            labelcz: 'Haut-Ogooue'
        },
        {
            value: 'GA-3',
            labelcz: 'Moyen-Ogooue'
        },
        {
            value: 'GA-4',
            labelcz: 'Ngounie'
        },
        {
            value: 'GA-5',
            labelcz: 'Nyanga'
        },
        {
            value: 'GA-8',
            labelcz: 'Ogooue-Maritime'
        },
        {
            value: 'GA-9',
            labelcz: 'Woleu-Ntem'
        }
    ],
    GD: [
        {
            value: 'GD-01',
            labelcz: 'Saint Andrew'
        },
        {
            value: 'GD-02',
            labelcz: 'Saint David'
        },
        {
            value: 'GD-03',
            labelcz: 'Saint George'
        },
        {
            value: 'GD-04',
            labelcz: 'Saint John'
        },
        {
            value: 'GD-05',
            labelcz: 'Saint Mark'
        },
        {
            value: 'GD-06',
            labelcz: 'Saint Patrick'
        },
        {
            value: 'GD-10',
            labelcz: 'Southern Grenadine Islands'
        }
    ],
    GE: [
        {
            value: 'GE-AB',
            labelcz: 'Abkhazia'
        },
        {
            value: 'GE-AJ',
            labelcz: 'Ajaria'
        },
        {
            value: 'GE-GU',
            labelcz: 'Guria'
        },
        {
            value: 'GE-IM',
            labelcz: 'Imereti'
        },
        {
            value: 'GE-KA',
            labelcz: "K'akheti"
        },
        {
            value: 'GE-KK',
            labelcz: 'Kvemo Kartli'
        },
        {
            value: 'GE-MM',
            labelcz: 'Mtskheta-Mtianeti'
        },
        {
            value: 'GE-RL',
            labelcz: "Rach'a-Lechkhumi-Kvemo Svaneti"
        },
        {
            value: 'GE-SZ',
            labelcz: 'Samegrelo-Zemo Svaneti'
        },
        {
            value: 'GE-SJ',
            labelcz: 'Samtskhe-Javakheti'
        },
        {
            value: 'GE-SK',
            labelcz: 'Shida Kartli'
        },
        {
            value: 'GE-TB',
            labelcz: 'Tbilisi'
        }
    ],
    GF: [
        {
            value: '-',
            labelcz: 'Guyane'
        }
    ],
    GG: [
        {
            value: '-',
            labelcz: 'Guernsey'
        }
    ],
    GH: [
        {
            value: 'GH-AF',
            labelcz: 'Ahafo'
        },
        {
            value: 'GH-AH',
            labelcz: 'Ashanti'
        },
        {
            value: 'GH-BO',
            labelcz: 'Bono'
        },
        {
            value: 'GH-BE',
            labelcz: 'Bono East'
        },
        {
            value: 'GH-CP',
            labelcz: 'Central'
        },
        {
            value: 'GH-EP',
            labelcz: 'Eastern'
        },
        {
            value: 'GH-AA',
            labelcz: 'Greater Accra'
        },
        {
            value: 'GH-NP',
            labelcz: 'Northern'
        },
        {
            value: 'GH-UE',
            labelcz: 'Upper East'
        },
        {
            value: 'GH-UW',
            labelcz: 'Upper West'
        },
        {
            value: 'GH-TV',
            labelcz: 'Volta'
        },
        {
            value: 'GH-WP',
            labelcz: 'Western'
        }
    ],
    GI: [
        {
            value: '-',
            labelcz: 'Gibraltar'
        }
    ],
    GL: [
        {
            value: 'GL-AV',
            labelcz: 'Avannaata Kommunia'
        },
        {
            value: 'GL-KU',
            labelcz: 'Kommune Kujalleq'
        },
        {
            value: 'GL-QT',
            labelcz: 'Kommune Qeqertalik'
        },
        {
            value: 'GL-SM',
            labelcz: 'Kommuneqarfik Sermersooq'
        },
        {
            value: 'GL-QE',
            labelcz: 'Qeqqata Kommunia'
        }
    ],
    GM: [
        {
            value: 'GM-B',
            labelcz: 'Banjul'
        },
        {
            value: 'GM-M',
            labelcz: 'Central River'
        },
        {
            value: 'GM-L',
            labelcz: 'Lower River'
        },
        {
            value: 'GM-N',
            labelcz: 'North Bank'
        },
        {
            value: 'GM-U',
            labelcz: 'Upper River'
        },
        {
            value: 'GM-W',
            labelcz: 'Western'
        }
    ],
    GN: [
        {
            value: 'GN-BF',
            labelcz: 'Boffa'
        },
        {
            value: 'GN-BK',
            labelcz: 'Boke'
        },
        {
            value: 'GN-C',
            labelcz: 'Conakry'
        },
        {
            value: 'GN-DB',
            labelcz: 'Dabola'
        },
        {
            value: 'GN-DL',
            labelcz: 'Dalaba'
        },
        {
            value: 'GN-DI',
            labelcz: 'Dinguiraye'
        },
        {
            value: 'GN-FR',
            labelcz: 'Fria'
        },
        {
            value: 'GN-KA',
            labelcz: 'Kankan'
        },
        {
            value: 'GN-KO',
            labelcz: 'Kouroussa'
        },
        {
            value: 'GN-LA',
            labelcz: 'Labe'
        },
        {
            value: 'GN-SI',
            labelcz: 'Siguiri'
        }
    ],
    GP: [
        {
            value: '-',
            labelcz: 'Guadeloupe'
        }
    ],
    GQ: [
        {
            value: 'GQ-AN',
            labelcz: 'Annobon'
        },
        {
            value: 'GQ-BN',
            labelcz: 'Bioko Norte'
        },
        {
            value: 'GQ-CS',
            labelcz: 'Centro Sur'
        },
        {
            value: 'GQ-KN',
            labelcz: 'Kie-Ntem'
        },
        {
            value: 'GQ-LI',
            labelcz: 'Litoral'
        },
        {
            value: 'GQ-WN',
            labelcz: 'Wele-Nzas'
        }
    ],
    GS: [
        {
            value: '-',
            labelcz: 'South Georgia and the South Sandwich Islands'
        }
    ],
    GT: [
        {
            value: 'GT-16',
            labelcz: 'Alta Verapaz'
        },
        {
            value: 'GT-15',
            labelcz: 'Baja Verapaz'
        },
        {
            value: 'GT-04',
            labelcz: 'Chimaltenango'
        },
        {
            value: 'GT-20',
            labelcz: 'Chiquimula'
        },
        {
            value: 'GT-02',
            labelcz: 'El Progreso'
        },
        {
            value: 'GT-05',
            labelcz: 'Escuintla'
        },
        {
            value: 'GT-01',
            labelcz: 'Guatemala'
        },
        {
            value: 'GT-13',
            labelcz: 'Huehuetenango'
        },
        {
            value: 'GT-18',
            labelcz: 'Izabal'
        },
        {
            value: 'GT-21',
            labelcz: 'Jalapa'
        },
        {
            value: 'GT-22',
            labelcz: 'Jutiapa'
        },
        {
            value: 'GT-17',
            labelcz: 'Peten'
        },
        {
            value: 'GT-09',
            labelcz: 'Quetzaltenango'
        },
        {
            value: 'GT-14',
            labelcz: 'Quiche'
        },
        {
            value: 'GT-11',
            labelcz: 'Retalhuleu'
        },
        {
            value: 'GT-03',
            labelcz: 'Sacatepequez'
        },
        {
            value: 'GT-12',
            labelcz: 'San Marcos'
        },
        {
            value: 'GT-06',
            labelcz: 'Santa Rosa'
        },
        {
            value: 'GT-07',
            labelcz: 'Solola'
        },
        {
            value: 'GT-10',
            labelcz: 'Suchitepequez'
        },
        {
            value: 'GT-08',
            labelcz: 'Totonicapan'
        },
        {
            value: 'GT-19',
            labelcz: 'Zacapa'
        }
    ],
    GU: [
        {
            value: '-',
            labelcz: 'Agana Heights'
        },
        {
            value: '-',
            labelcz: 'Agat'
        },
        {
            value: '-',
            labelcz: 'Barrigada'
        },
        {
            value: '-',
            labelcz: 'Chalan Pago-Ordot'
        },
        {
            value: '-',
            labelcz: 'Dededo'
        },
        {
            value: '-',
            labelcz: 'Hagatna'
        },
        {
            value: '-',
            labelcz: 'Inarajan'
        },
        {
            value: '-',
            labelcz: 'Mangilao'
        },
        {
            value: '-',
            labelcz: 'Mongmong-Toto-Maite'
        },
        {
            value: '-',
            labelcz: 'Piti'
        },
        {
            value: '-',
            labelcz: 'Santa Rita'
        },
        {
            value: '-',
            labelcz: 'Sinajana'
        },
        {
            value: '-',
            labelcz: 'Talofofo'
        },
        {
            value: '-',
            labelcz: 'Tamuning-Tumon-Harmon'
        },
        {
            value: '-',
            labelcz: 'Yigo'
        },
        {
            value: '-',
            labelcz: 'Yona'
        }
    ],
    GW: [
        {
            value: 'GW-BA',
            labelcz: 'Bafata'
        },
        {
            value: 'GW-BS',
            labelcz: 'Bissau'
        },
        {
            value: 'GW-CA',
            labelcz: 'Cacheu'
        },
        {
            value: 'GW-GA',
            labelcz: 'Gabu'
        },
        {
            value: 'GW-OI',
            labelcz: 'Oio'
        }
    ],
    GY: [
        {
            value: 'GY-BA',
            labelcz: 'Barima-Waini'
        },
        {
            value: 'GY-CU',
            labelcz: 'Cuyuni-Mazaruni'
        },
        {
            value: 'GY-DE',
            labelcz: 'Demerara-Mahaica'
        },
        {
            value: 'GY-EB',
            labelcz: 'East Berbice-Corentyne'
        },
        {
            value: 'GY-ES',
            labelcz: 'Essequibo Islands-West Demerara'
        },
        {
            value: 'GY-MA',
            labelcz: 'Mahaica-Berbice'
        },
        {
            value: 'GY-PM',
            labelcz: 'Pomeroon-Supenaam'
        },
        {
            value: 'GY-PT',
            labelcz: 'Potaro-Siparuni'
        },
        {
            value: 'GY-UD',
            labelcz: 'Upper Demerara-Berbice'
        }
    ],
    HK: [
        {
            value: '-',
            labelcz: 'Hong Kong'
        }
    ],
    HM: [
        {
            value: '-',
            labelcz: 'Heard Island and McDonald Islands'
        }
    ],
    HN: [
        {
            value: 'HN-AT',
            labelcz: 'Atlantida'
        },
        {
            value: 'HN-CH',
            labelcz: 'Choluteca'
        },
        {
            value: 'HN-CL',
            labelcz: 'Colon'
        },
        {
            value: 'HN-CM',
            labelcz: 'Comayagua'
        },
        {
            value: 'HN-CP',
            labelcz: 'Copan'
        },
        {
            value: 'HN-CR',
            labelcz: 'Cortes'
        },
        {
            value: 'HN-EP',
            labelcz: 'El Paraiso'
        },
        {
            value: 'HN-FM',
            labelcz: 'Francisco Morazan'
        },
        {
            value: 'HN-GD',
            labelcz: 'Gracias a Dios'
        },
        {
            value: 'HN-IN',
            labelcz: 'Intibuca'
        },
        {
            value: 'HN-IB',
            labelcz: 'Islas de la Bahia'
        },
        {
            value: 'HN-LP',
            labelcz: 'La Paz'
        },
        {
            value: 'HN-LE',
            labelcz: 'Lempira'
        },
        {
            value: 'HN-OC',
            labelcz: 'Ocotepeque'
        },
        {
            value: 'HN-OL',
            labelcz: 'Olancho'
        },
        {
            value: 'HN-SB',
            labelcz: 'Santa Barbara'
        },
        {
            value: 'HN-VA',
            labelcz: 'Valle'
        },
        {
            value: 'HN-YO',
            labelcz: 'Yoro'
        }
    ],
    HT: [
        {
            value: 'HT-AR',
            labelcz: 'Artibonite'
        },
        {
            value: 'HT-CE',
            labelcz: 'Centre'
        },
        {
            value: 'HT-GA',
            labelcz: "Grande'Anse"
        },
        {
            value: 'HT-NI',
            labelcz: 'Nippes'
        },
        {
            value: 'HT-ND',
            labelcz: 'Nord'
        },
        {
            value: 'HT-NO',
            labelcz: 'Nord-Ouest'
        },
        {
            value: 'HT-OU',
            labelcz: 'Ouest'
        },
        {
            value: 'HT-SD',
            labelcz: 'Sud'
        },
        {
            value: 'HT-SE',
            labelcz: 'Sud-Est'
        }
    ],
    ID: [
        {
            value: 'ID-AC',
            labelcz: 'Aceh'
        },
        {
            value: 'ID-BA',
            labelcz: 'Bali'
        },
        {
            value: 'ID-BT',
            labelcz: 'Banten'
        },
        {
            value: 'ID-BE',
            labelcz: 'Bengkulu'
        },
        {
            value: 'ID-GO',
            labelcz: 'Gorontalo'
        },
        {
            value: 'ID-JK',
            labelcz: 'Jakarta Raya'
        },
        {
            value: 'ID-JA',
            labelcz: 'Jambi'
        },
        {
            value: 'ID-JB',
            labelcz: 'Jawa Barat'
        },
        {
            value: 'ID-JT',
            labelcz: 'Jawa Tengah'
        },
        {
            value: 'ID-JI',
            labelcz: 'Jawa Timur'
        },
        {
            value: 'ID-KB',
            labelcz: 'Kalimantan Barat'
        },
        {
            value: 'ID-KS',
            labelcz: 'Kalimantan Selatan'
        },
        {
            value: 'ID-KT',
            labelcz: 'Kalimantan Tengah'
        },
        {
            value: 'ID-KI',
            labelcz: 'Kalimantan Timur'
        },
        {
            value: 'ID-KU',
            labelcz: 'Kalimantan Utara'
        },
        {
            value: 'ID-BB',
            labelcz: 'Kepulauan Bangka Belitung'
        },
        {
            value: 'ID-KR',
            labelcz: 'Kepulauan Riau'
        },
        {
            value: 'ID-LA',
            labelcz: 'Lampung'
        },
        {
            value: 'ID-ML',
            labelcz: 'Maluku'
        },
        {
            value: 'ID-MU',
            labelcz: 'Maluku Utara'
        },
        {
            value: 'ID-NB',
            labelcz: 'Nusa Tenggara Barat'
        },
        {
            value: 'ID-NT',
            labelcz: 'Nusa Tenggara Timur'
        },
        {
            value: 'ID-PP',
            labelcz: 'Papua'
        },
        {
            value: 'ID-PB',
            labelcz: 'Papua Barat'
        },
        {
            value: 'ID-PE',
            labelcz: 'Papua Pengunungan'
        },
        {
            value: 'ID-PS',
            labelcz: 'Papua Selatan'
        },
        {
            value: 'ID-PT',
            labelcz: 'Papua Tengah'
        },
        {
            value: 'ID-RI',
            labelcz: 'Riau'
        },
        {
            value: 'ID-SR',
            labelcz: 'Sulawesi Barat'
        },
        {
            value: 'ID-SN',
            labelcz: 'Sulawesi Selatan'
        },
        {
            value: 'ID-ST',
            labelcz: 'Sulawesi Tengah'
        },
        {
            value: 'ID-SG',
            labelcz: 'Sulawesi Tenggara'
        },
        {
            value: 'ID-SA',
            labelcz: 'Sulawesi Utara'
        },
        {
            value: 'ID-SB',
            labelcz: 'Sumatera Barat'
        },
        {
            value: 'ID-SS',
            labelcz: 'Sumatera Selatan'
        },
        {
            value: 'ID-SU',
            labelcz: 'Sumatera Utara'
        },
        {
            value: 'ID-YO',
            labelcz: 'Yogyakarta'
        }
    ],

    IL: [
        {
            value: 'IL-D',
            labelcz: 'HaDarom'
        },
        {
            value: 'IL-M',
            labelcz: 'HaMerkaz'
        },
        {
            value: 'IL-Z',
            labelcz: 'HaTsafon'
        },
        {
            value: 'IL-HA',
            labelcz: 'Hefa'
        },
        {
            value: 'IL-TA',
            labelcz: 'Tel Aviv'
        },
        {
            value: 'IL-JM',
            labelcz: 'Yerushalayim'
        }
    ],
    IM: [
        {
            value: '-',
            labelcz: 'Isle of Man'
        }
    ],

    IO: [
        {
            value: '-',
            labelcz: 'British Indian Ocean Territory'
        }
    ],
    IQ: [
        {
            value: 'IQ-AN',
            labelcz: 'Al Anbar'
        },
        {
            value: 'IQ-BA',
            labelcz: 'Al Basrah'
        },
        {
            value: 'IQ-MU',
            labelcz: 'Al Muthanna'
        },
        {
            value: 'IQ-QA',
            labelcz: 'Al Qadisiyah'
        },
        {
            value: 'IQ-NA',
            labelcz: 'An Najaf'
        },
        {
            value: 'IQ-AR',
            labelcz: 'Arbil'
        },
        {
            value: 'IQ-SU',
            labelcz: 'As Sulaymaniyah'
        },
        {
            value: 'IQ-BB',
            labelcz: 'Babil'
        },
        {
            value: 'IQ-BG',
            labelcz: 'Baghdad'
        },
        {
            value: 'IQ-DA',
            labelcz: 'Dahuk'
        },
        {
            value: 'IQ-DQ',
            labelcz: 'Dhi Qar'
        },
        {
            value: 'IQ-DI',
            labelcz: 'Diyala'
        },
        {
            value: 'IQ-KA',
            labelcz: "Karbala'"
        },
        {
            value: 'IQ-KI',
            labelcz: 'Kirkuk'
        },
        {
            value: 'IQ-MA',
            labelcz: 'Maysan'
        },
        {
            value: 'IQ-NI',
            labelcz: 'Ninawa'
        },
        {
            value: 'IQ-SD',
            labelcz: 'Salah ad Din'
        },
        {
            value: 'IQ-WA',
            labelcz: 'Wasit'
        }
    ],
    IR: [
        {
            value: 'IR-30',
            labelcz: 'Alborz'
        },
        {
            value: 'IR-24',
            labelcz: 'Ardabil'
        },
        {
            value: 'IR-04',
            labelcz: 'Azarbayjan-e Gharbi'
        },
        {
            value: 'IR-03',
            labelcz: 'Azarbayjan-e Sharqi'
        },
        {
            value: 'IR-18',
            labelcz: 'Bushehr'
        },
        {
            value: 'IR-14',
            labelcz: 'Chahar Mahal va Bakhtiari'
        },
        {
            value: 'IR-10',
            labelcz: 'Esfahan'
        },
        {
            value: 'IR-07',
            labelcz: 'Fars'
        },
        {
            value: 'IR-01',
            labelcz: 'Gilan'
        },
        {
            value: 'IR-27',
            labelcz: 'Golestan'
        },
        {
            value: 'IR-13',
            labelcz: 'Hamadan'
        },
        {
            value: 'IR-22',
            labelcz: 'Hormozgan'
        },
        {
            value: 'IR-16',
            labelcz: 'Ilam'
        },
        {
            value: 'IR-08',
            labelcz: 'Kerman'
        },
        {
            value: 'IR-05',
            labelcz: 'Kermanshah'
        },
        {
            value: 'IR-29',
            labelcz: 'Khorasan-e Jonubi'
        },
        {
            value: 'IR-09',
            labelcz: 'Khorasan-e Razavi'
        },
        {
            value: 'IR-28',
            labelcz: 'Khorasan-e Shomali'
        },
        {
            value: 'IR-06',
            labelcz: 'Khuzestan'
        },
        {
            value: 'IR-17',
            labelcz: 'Kohgiluyeh va Bowyer Ahmad'
        },
        {
            value: 'IR-12',
            labelcz: 'Kordestan'
        },
        {
            value: 'IR-15',
            labelcz: 'Lorestan'
        },
        {
            value: 'IR-00',
            labelcz: 'Markazi'
        },
        {
            value: 'IR-02',
            labelcz: 'Mazandaran'
        },
        {
            value: 'IR-26',
            labelcz: 'Qazvin'
        },
        {
            value: 'IR-25',
            labelcz: 'Qom'
        },
        {
            value: 'IR-20',
            labelcz: 'Semnan'
        },
        {
            value: 'IR-11',
            labelcz: 'Sistan va Baluchestan'
        },
        {
            value: 'IR-23',
            labelcz: 'Tehran'
        },
        {
            value: 'IR-21',
            labelcz: 'Yazd'
        },
        {
            value: 'IR-19',
            labelcz: 'Zanjan'
        }
    ],
    IS: [
        {
            value: 'IS-7',
            labelcz: 'Austurland'
        },
        {
            value: 'IS-1',
            labelcz: 'Hofudborgarsvaedi'
        },
        {
            value: 'IS-6',
            labelcz: 'Nordurland eystra'
        },
        {
            value: 'IS-5',
            labelcz: 'Nordurland vestra'
        },
        {
            value: 'IS-8',
            labelcz: 'Sudurland'
        },
        {
            value: 'IS-2',
            labelcz: 'Sudurnes'
        },
        {
            value: 'IS-4',
            labelcz: 'Vestfirdir'
        },
        {
            value: 'IS-3',
            labelcz: 'Vesturland'
        }
    ],
    JE: [
        {
            value: '-',
            labelcz: 'Jersey'
        }
    ],
    JM: [
        {
            value: 'JM-13',
            labelcz: 'Clarendon'
        },
        {
            value: 'JM-09',
            labelcz: 'Hanover'
        },
        {
            value: 'JM-01',
            labelcz: 'Kingston'
        },
        {
            value: 'JM-12',
            labelcz: 'Manchester'
        },
        {
            value: 'JM-04',
            labelcz: 'Portland'
        },
        {
            value: 'JM-02',
            labelcz: 'Saint Andrew'
        },
        {
            value: 'JM-06',
            labelcz: 'Saint Ann'
        },
        {
            value: 'JM-14',
            labelcz: 'Saint Catherine'
        },
        {
            value: 'JM-11',
            labelcz: 'Saint Elizabeth'
        },
        {
            value: 'JM-08',
            labelcz: 'Saint James'
        },
        {
            value: 'JM-05',
            labelcz: 'Saint Mary'
        },
        {
            value: 'JM-03',
            labelcz: 'Saint Thomas'
        },
        {
            value: 'JM-07',
            labelcz: 'Trelawny'
        },
        {
            value: 'JM-10',
            labelcz: 'Westmoreland'
        }
    ],
    JO: [
        {
            value: 'JO-AJ',
            labelcz: "'Ajlun"
        },
        {
            value: 'JO-AQ',
            labelcz: "Al 'Aqabah"
        },
        {
            value: 'JO-AM',
            labelcz: "Al 'Asimah"
        },
        {
            value: 'JO-BA',
            labelcz: "Al Balqa'"
        },
        {
            value: 'JO-KA',
            labelcz: 'Al Karak'
        },
        {
            value: 'JO-MA',
            labelcz: 'Al Mafraq'
        },
        {
            value: 'JO-AT',
            labelcz: 'At Tafilah'
        },
        {
            value: 'JO-AZ',
            labelcz: "Az Zarqa'"
        },
        {
            value: 'JO-IR',
            labelcz: 'Irbid'
        },
        {
            value: 'JO-JA',
            labelcz: 'Jarash'
        },
        {
            value: 'JO-MN',
            labelcz: "Ma'an"
        },
        {
            value: 'JO-MD',
            labelcz: 'Madaba'
        }
    ],
    KE: [
        {
            value: 'KE-01',
            labelcz: 'Baringo'
        },
        {
            value: 'KE-02',
            labelcz: 'Bomet'
        },
        {
            value: 'KE-03',
            labelcz: 'Bungoma'
        },
        {
            value: 'KE-04',
            labelcz: 'Busia'
        },
        {
            value: 'KE-05',
            labelcz: 'Elgeyo/Marakwet'
        },
        {
            value: 'KE-06',
            labelcz: 'Embu'
        },
        {
            value: 'KE-07',
            labelcz: 'Garissa'
        },
        {
            value: 'KE-08',
            labelcz: 'Homa Bay'
        },
        {
            value: 'KE-09',
            labelcz: 'Isiolo'
        },
        {
            value: 'KE-10',
            labelcz: 'Kajiado'
        },
        {
            value: 'KE-11',
            labelcz: 'Kakamega'
        },
        {
            value: 'KE-12',
            labelcz: 'Kericho'
        },
        {
            value: 'KE-13',
            labelcz: 'Kiambu'
        },
        {
            value: 'KE-14',
            labelcz: 'Kilifi'
        },
        {
            value: 'KE-15',
            labelcz: 'Kirinyaga'
        },
        {
            value: 'KE-16',
            labelcz: 'Kisii'
        },
        {
            value: 'KE-17',
            labelcz: 'Kisumu'
        },
        {
            value: 'KE-18',
            labelcz: 'Kitui'
        },
        {
            value: 'KE-19',
            labelcz: 'Kwale'
        },
        {
            value: 'KE-20',
            labelcz: 'Laikipia'
        },
        {
            value: 'KE-21',
            labelcz: 'Lamu'
        },
        {
            value: 'KE-22',
            labelcz: 'Machakos'
        },
        {
            value: 'KE-23',
            labelcz: 'Makueni'
        },
        {
            value: 'KE-24',
            labelcz: 'Mandera'
        },
        {
            value: 'KE-25',
            labelcz: 'Marsabit'
        },
        {
            value: 'KE-26',
            labelcz: 'Meru'
        },
        {
            value: 'KE-27',
            labelcz: 'Migori'
        },
        {
            value: 'KE-28',
            labelcz: 'Mombasa'
        },
        {
            value: 'KE-29',
            labelcz: "Murang'a"
        },
        {
            value: 'KE-30',
            labelcz: 'Nairobi City'
        },
        {
            value: 'KE-31',
            labelcz: 'Nakuru'
        },
        {
            value: 'KE-32',
            labelcz: 'Nandi'
        },
        {
            value: 'KE-33',
            labelcz: 'Narok'
        },
        {
            value: 'KE-34',
            labelcz: 'Nyamira'
        },
        {
            value: 'KE-35',
            labelcz: 'Nyandarua'
        },
        {
            value: 'KE-36',
            labelcz: 'Nyeri'
        },
        {
            value: 'KE-37',
            labelcz: 'Samburu'
        },
        {
            value: 'KE-38',
            labelcz: 'Siaya'
        },
        {
            value: 'KE-39',
            labelcz: 'Taita/Taveta'
        },
        {
            value: 'KE-40',
            labelcz: 'Tana River'
        },
        {
            value: 'KE-41',
            labelcz: 'Tharaka-Nithi'
        },
        {
            value: 'KE-42',
            labelcz: 'Trans Nzoia'
        },
        {
            value: 'KE-43',
            labelcz: 'Turkana'
        },
        {
            value: 'KE-44',
            labelcz: 'Uasin Gishu'
        },
        {
            value: 'KE-45',
            labelcz: 'Vihiga'
        },
        {
            value: 'KE-46',
            labelcz: 'Wajir'
        },
        {
            value: 'KE-47',
            labelcz: 'West Pokot'
        }
    ],
    KG: [
        {
            value: 'KG-B',
            labelcz: 'Batken'
        },
        {
            value: 'KG-GB',
            labelcz: 'Bishkek Shaary'
        },
        {
            value: 'KG-C',
            labelcz: 'Chuy'
        },
        {
            value: 'KG-J',
            labelcz: 'Jalal-Abad'
        },
        {
            value: 'KG-N',
            labelcz: 'Naryn'
        },
        {
            value: 'KG-GO',
            labelcz: 'Osh Shaary'
        },
        {
            value: 'KG-T',
            labelcz: 'Talas'
        },
        {
            value: 'KG-Y',
            labelcz: 'Ysyk-Kol'
        }
    ],
    KH: [
        {
            value: 'KH-2',
            labelcz: 'Baat Dambang'
        },
        {
            value: 'KH-1',
            labelcz: 'Banteay Mean Choay'
        },
        {
            value: 'KH-23',
            labelcz: 'Kaeb'
        },
        {
            value: 'KH-3',
            labelcz: 'Kampong Chaam'
        },
        {
            value: 'KH-4',
            labelcz: 'Kampong Chhnang'
        },
        {
            value: 'KH-5',
            labelcz: 'Kampong Spueu'
        },
        {
            value: 'KH-6',
            labelcz: 'Kampong Thum'
        },
        {
            value: 'KH-7',
            labelcz: 'Kampot'
        },
        {
            value: 'KH-8',
            labelcz: 'Kandaal'
        },
        {
            value: 'KH-10',
            labelcz: 'Kracheh'
        },
        {
            value: 'KH-11',
            labelcz: 'Mondol Kiri'
        },
        {
            value: 'KH-24',
            labelcz: 'Pailin'
        },
        {
            value: 'KH-12',
            labelcz: 'Phnom Penh'
        },
        {
            value: 'KH-15',
            labelcz: 'Pousaat'
        },
        {
            value: 'KH-18',
            labelcz: 'Preah Sihanouk'
        },
        {
            value: 'KH-13',
            labelcz: 'Preah Vihear'
        },
        {
            value: 'KH-14',
            labelcz: 'Prey Veaeng'
        },
        {
            value: 'KH-17',
            labelcz: 'Siem Reab'
        },
        {
            value: 'KH-19',
            labelcz: 'Stueng Traeng'
        },
        {
            value: 'KH-20',
            labelcz: 'Svaay Rieng'
        },
        {
            value: 'KH-21',
            labelcz: 'Taakaev'
        }
    ],
    KI: [
        {
            value: 'KI-G',
            labelcz: 'Gilbert Islands'
        },
        {
            value: 'KI-L',
            labelcz: 'Line Islands'
        }
    ],
    KM: [
        {
            value: 'KM-G',
            labelcz: 'Grande Comore'
        },
        {
            value: 'KM-M',
            labelcz: 'Moheli'
        }
    ],
    KN: [
        {
            value: 'KN-01',
            labelcz: 'Christ Church Nichola Town'
        },
        {
            value: 'KN-02',
            labelcz: 'Saint Anne Sandy Point'
        },
        {
            value: 'KN-03',
            labelcz: 'Saint George Basseterre'
        },
        {
            value: 'KN-05',
            labelcz: 'Saint James Windward'
        },
        {
            value: 'KN-06',
            labelcz: 'Saint John Capisterre'
        },
        {
            value: 'KN-07',
            labelcz: 'Saint John Figtree'
        },
        {
            value: 'KN-08',
            labelcz: 'Saint Mary Cayon'
        },
        {
            value: 'KN-09',
            labelcz: 'Saint Paul Capisterre'
        },
        {
            value: 'KN-10',
            labelcz: 'Saint Paul Charlestown'
        },
        {
            value: 'KN-11',
            labelcz: 'Saint Peter Basseterre'
        },
        {
            value: 'KN-12',
            labelcz: 'Saint Thomas Lowland'
        },
        {
            value: 'KN-13',
            labelcz: 'Saint Thomas Middle Island'
        },
        {
            value: 'KN-15',
            labelcz: 'Trinity Palmetto Point'
        }
    ],
    KP: [
        {
            value: 'KP-01',
            labelcz: "P'yongyang"
        }
    ],
    KW: [
        {
            value: 'KW-KU',
            labelcz: "Al 'Asimah"
        },
        {
            value: 'KW-AH',
            labelcz: 'Al Ahmadi'
        },
        {
            value: 'KW-FA',
            labelcz: 'Al Farwaniyah'
        },
        {
            value: 'KW-JA',
            labelcz: "Al Jahra'"
        },
        {
            value: 'KW-HA',
            labelcz: 'Hawalli'
        },
        {
            value: 'KW-MU',
            labelcz: 'Mubarak al Kabir'
        }
    ],
    KY: [
        {
            value: '-',
            labelcz: 'Cayman Islands'
        }
    ],
    KZ: [
        {
            value: 'KZ-10',
            labelcz: 'Abay oblysy'
        },
        {
            value: 'KZ-75',
            labelcz: 'Almaty'
        },
        {
            value: 'KZ-19',
            labelcz: 'Almaty oblysy'
        },
        {
            value: 'KZ-11',
            labelcz: 'Aqmola oblysy'
        },
        {
            value: 'KZ-15',
            labelcz: 'Aqtobe oblysy'
        },
        {
            value: 'KZ-71',
            labelcz: 'Astana'
        },
        {
            value: 'KZ-23',
            labelcz: 'Atyrau oblysy'
        },
        {
            value: 'KZ-27',
            labelcz: 'Batys Qazaqstan oblysy'
        },
        {
            value: 'KZ-47',
            labelcz: 'Mangghystau oblysy'
        },
        {
            value: 'KZ-55',
            labelcz: 'Pavlodar oblysy'
        },
        {
            value: 'KZ-35',
            labelcz: 'Qaraghandy oblysy'
        },
        {
            value: 'KZ-39',
            labelcz: 'Qostanay oblysy'
        },
        {
            value: 'KZ-43',
            labelcz: 'Qyzylorda oblysy'
        },
        {
            value: 'KZ-63',
            labelcz: 'Shyghys Qazaqstan oblysy'
        },
        {
            value: 'KZ-79',
            labelcz: 'Shymkent'
        },
        {
            value: 'KZ-59',
            labelcz: 'Soltustik Qazaqstan oblysy'
        },
        {
            value: 'KZ-61',
            labelcz: 'Turkistan oblysy'
        },
        {
            value: 'KZ-62',
            labelcz: 'Ulytau oblysy'
        },
        {
            value: 'KZ-31',
            labelcz: 'Zhambyl oblysy'
        },
        {
            value: 'KZ-33',
            labelcz: 'Zhetisu oblysy'
        }
    ],
    LA: [
        {
            value: 'LA-AT',
            labelcz: 'Attapu'
        },
        {
            value: 'LA-BK',
            labelcz: 'Bokeo'
        },
        {
            value: 'LA-BL',
            labelcz: 'Bolikhamxai'
        },
        {
            value: 'LA-CH',
            labelcz: 'Champasak'
        },
        {
            value: 'LA-KH',
            labelcz: 'Khammouan'
        },
        {
            value: 'LA-LP',
            labelcz: 'Louangphabang'
        },
        {
            value: 'LA-OU',
            labelcz: 'Oudomxai'
        },
        {
            value: 'LA-PH',
            labelcz: 'Phongsali'
        },
        {
            value: 'LA-SV',
            labelcz: 'Savannakhet'
        },
        {
            value: 'LA-VI',
            labelcz: 'Viangchan'
        },
        {
            value: 'LA-XA',
            labelcz: 'Xaignabouli'
        },
        {
            value: 'LA-XE',
            labelcz: 'Xekong'
        },
        {
            value: 'LA-XI',
            labelcz: 'Xiangkhouang'
        }
    ],
    LB: [
        {
            value: 'LB-AK',
            labelcz: 'Aakkar'
        },
        {
            value: 'LB-BH',
            labelcz: 'Baalbek-Hermel'
        },
        {
            value: 'LB-BI',
            labelcz: 'Beqaa'
        },
        {
            value: 'LB-BA',
            labelcz: 'Beyrouth'
        },
        {
            value: 'LB-AS',
            labelcz: 'Liban-Nord'
        },
        {
            value: 'LB-JA',
            labelcz: 'Liban-Sud'
        },
        {
            value: 'LB-JL',
            labelcz: 'Mont-Liban'
        },
        {
            value: 'LB-NA',
            labelcz: 'Nabatiye'
        }
    ],
    LC: [
        {
            value: 'LC-01',
            labelcz: 'Anse la Raye'
        },
        {
            value: 'LC-02',
            labelcz: 'Castries'
        },
        {
            value: 'LC-03',
            labelcz: 'Choiseul'
        },
        {
            value: 'LC-05',
            labelcz: 'Dennery'
        },
        {
            value: 'LC-06',
            labelcz: 'Gros Islet'
        },
        {
            value: 'LC-07',
            labelcz: 'Laborie'
        },
        {
            value: 'LC-08',
            labelcz: 'Micoud'
        },
        {
            value: 'LC-10',
            labelcz: 'Soufriere'
        },
        {
            value: 'LC-11',
            labelcz: 'Vieux Fort'
        }
    ],
    LI: [
        {
            value: 'LI-01',
            labelcz: 'Balzers'
        },
        {
            value: 'LI-02',
            labelcz: 'Eschen'
        },
        {
            value: 'LI-03',
            labelcz: 'Gamprin'
        },
        {
            value: 'LI-04',
            labelcz: 'Mauren'
        },
        {
            value: 'LI-06',
            labelcz: 'Ruggell'
        },
        {
            value: 'LI-07',
            labelcz: 'Schaan'
        },
        {
            value: 'LI-09',
            labelcz: 'Triesen'
        },
        {
            value: 'LI-10',
            labelcz: 'Triesenberg'
        },
        {
            value: 'LI-11',
            labelcz: 'Vaduz'
        }
    ],
    LK: [
        {
            value: 'LK-2',
            labelcz: 'Central Province'
        },
        {
            value: 'LK-5',
            labelcz: 'Eastern Province'
        },
        {
            value: 'LK-7',
            labelcz: 'North Central Province'
        },
        {
            value: 'LK-6',
            labelcz: 'North Western Province'
        },
        {
            value: 'LK-4',
            labelcz: 'Northern Province'
        },
        {
            value: 'LK-9',
            labelcz: 'Sabaragamuwa Province'
        },
        {
            value: 'LK-3',
            labelcz: 'Southern Province'
        },
        {
            value: 'LK-8',
            labelcz: 'Uva Province'
        },
        {
            value: 'LK-1',
            labelcz: 'Western Province'
        }
    ],
    LR: [
        {
            value: 'LR-BM',
            labelcz: 'Bomi'
        },
        {
            value: 'LR-BG',
            labelcz: 'Bong'
        },
        {
            value: 'LR-CM',
            labelcz: 'Grand Cape Mount'
        },
        {
            value: 'LR-GG',
            labelcz: 'Grand Gedeh'
        },
        {
            value: 'LR-MG',
            labelcz: 'Margibi'
        },
        {
            value: 'LR-MO',
            labelcz: 'Montserrado'
        },
        {
            value: 'LR-RI',
            labelcz: 'River Cess'
        },
        {
            value: 'LR-SI',
            labelcz: 'Sinoe'
        }
    ],
    LS: [
        {
            value: 'LS-D',
            labelcz: 'Berea'
        },
        {
            value: 'LS-B',
            labelcz: 'Botha-Bothe'
        },
        {
            value: 'LS-C',
            labelcz: 'Leribe'
        },
        {
            value: 'LS-E',
            labelcz: 'Mafeteng'
        },
        {
            value: 'LS-A',
            labelcz: 'Maseru'
        },
        {
            value: 'LS-F',
            labelcz: "Mohale's Hoek"
        },
        {
            value: 'LS-J',
            labelcz: 'Mokhotlong'
        },
        {
            value: 'LS-H',
            labelcz: "Qacha's Nek"
        },
        {
            value: 'LS-G',
            labelcz: 'Quthing'
        },
        {
            value: 'LS-K',
            labelcz: 'Thaba-Tseka'
        }
    ],

    LY: [
        {
            value: 'LY-BU',
            labelcz: 'Al Butnan'
        },
        {
            value: 'LY-JA',
            labelcz: 'Al Jabal al Akhdar'
        },
        {
            value: 'LY-JG',
            labelcz: 'Al Jabal al Gharbi'
        },
        {
            value: 'LY-JI',
            labelcz: 'Al Jafarah'
        },
        {
            value: 'LY-JU',
            labelcz: 'Al Jufrah'
        },
        {
            value: 'LY-KF',
            labelcz: 'Al Kufrah'
        },
        {
            value: 'LY-MJ',
            labelcz: 'Al Marj'
        },
        {
            value: 'LY-MB',
            labelcz: 'Al Marqab'
        },
        {
            value: 'LY-WA',
            labelcz: 'Al Wahat'
        },
        {
            value: 'LY-NQ',
            labelcz: 'An Nuqat al Khams'
        },
        {
            value: 'LY-ZA',
            labelcz: 'Az Zawiyah'
        },
        {
            value: 'LY-BA',
            labelcz: 'Banghazi'
        },
        {
            value: 'LY-DR',
            labelcz: 'Darnah'
        },
        {
            value: 'LY-MI',
            labelcz: 'Misratah'
        },
        {
            value: 'LY-MQ',
            labelcz: 'Murzuq'
        },
        {
            value: 'LY-NL',
            labelcz: 'Nalut'
        },
        {
            value: 'LY-SB',
            labelcz: 'Sabha'
        },
        {
            value: 'LY-SR',
            labelcz: 'Surt'
        },
        {
            value: 'LY-TB',
            labelcz: 'Tarabulus'
        },
        {
            value: 'LY-WS',
            labelcz: "Wadi ash Shati'"
        }
    ],
    MA: [
        {
            value: 'MA-05',
            labelcz: 'Beni-Mellal-Khenifra'
        },
        {
            value: 'MA-06',
            labelcz: 'Casablanca-Settat'
        },
        {
            value: 'MA-08',
            labelcz: 'Draa-Tafilalet'
        },
        {
            value: 'MA-03',
            labelcz: 'Fes- Meknes'
        },
        {
            value: 'MA-10',
            labelcz: 'Guelmim-Oued Noun (EH-partial)'
        },
        {
            value: 'MA-02',
            labelcz: "L'Oriental"
        },
        {
            value: 'MA-11',
            labelcz: 'Laayoune-Sakia El Hamra (EH-partial)'
        },
        {
            value: 'MA-07',
            labelcz: 'Marrakech-Safi'
        },
        {
            value: 'MA-04',
            labelcz: 'Rabat-Sale-Kenitra'
        },
        {
            value: 'MA-09',
            labelcz: 'Souss-Massa'
        },
        {
            value: 'MA-01',
            labelcz: 'Tanger-Tetouan-Al Hoceima'
        }
    ],
    MC: [
        {
            value: 'MC-FO',
            labelcz: 'Fontvieille'
        },
        {
            value: 'MC-CO',
            labelcz: 'La Condamine'
        },
        {
            value: 'MC-MO',
            labelcz: 'Monaco-Ville'
        },
        {
            value: 'MC-MG',
            labelcz: 'Moneghetti'
        },
        {
            value: 'MC-MC',
            labelcz: 'Monte-Carlo'
        },
        {
            value: 'MC-SR',
            labelcz: 'Saint-Roman'
        }
    ],
    MD: [
        {
            value: 'MD-AN',
            labelcz: 'Anenii Noi'
        },
        {
            value: 'MD-BA',
            labelcz: 'Balti'
        },
        {
            value: 'MD-BS',
            labelcz: 'Basarabeasca'
        },
        {
            value: 'MD-BD',
            labelcz: 'Bender'
        },
        {
            value: 'MD-BR',
            labelcz: 'Briceni'
        },
        {
            value: 'MD-CA',
            labelcz: 'Cahul'
        },
        {
            value: 'MD-CL',
            labelcz: 'Calarasi'
        },
        {
            value: 'MD-CT',
            labelcz: 'Cantemir'
        },
        {
            value: 'MD-CS',
            labelcz: 'Causeni'
        },
        {
            value: 'MD-CU',
            labelcz: 'Chisinau'
        },
        {
            value: 'MD-CM',
            labelcz: 'Cimislia'
        },
        {
            value: 'MD-CR',
            labelcz: 'Criuleni'
        },
        {
            value: 'MD-DO',
            labelcz: 'Donduseni'
        },
        {
            value: 'MD-DR',
            labelcz: 'Drochia'
        },
        {
            value: 'MD-DU',
            labelcz: 'Dubasari'
        },
        {
            value: 'MD-ED',
            labelcz: 'Edinet'
        },
        {
            value: 'MD-FA',
            labelcz: 'Falesti'
        },
        {
            value: 'MD-FL',
            labelcz: 'Floresti'
        },
        {
            value: 'MD-GA',
            labelcz: 'Gagauzia, Unitatea teritoriala autonoma'
        },
        {
            value: 'MD-GL',
            labelcz: 'Glodeni'
        },
        {
            value: 'MD-HI',
            labelcz: 'Hincesti'
        },
        {
            value: 'MD-IA',
            labelcz: 'Ialoveni'
        },
        {
            value: 'MD-LE',
            labelcz: 'Leova'
        },
        {
            value: 'MD-NI',
            labelcz: 'Nisporeni'
        },
        {
            value: 'MD-OC',
            labelcz: 'Ocnita'
        },
        {
            value: 'MD-OR',
            labelcz: 'Orhei'
        },
        {
            value: 'MD-RE',
            labelcz: 'Rezina'
        },
        {
            value: 'MD-RI',
            labelcz: 'Riscani'
        },
        {
            value: 'MD-SI',
            labelcz: 'Singerei'
        },
        {
            value: 'MD-SD',
            labelcz: 'Soldanesti'
        },
        {
            value: 'MD-SO',
            labelcz: 'Soroca'
        },
        {
            value: 'MD-SV',
            labelcz: 'Stefan Voda'
        },
        {
            value: 'MD-SN',
            labelcz: 'Stinga Nistrului, unitatea teritoriala din'
        },
        {
            value: 'MD-ST',
            labelcz: 'Straseni'
        },
        {
            value: 'MD-TA',
            labelcz: 'Taraclia'
        },
        {
            value: 'MD-TE',
            labelcz: 'Telenesti'
        },
        {
            value: 'MD-UN',
            labelcz: 'Ungheni'
        }
    ],
    ME: [
        {
            value: 'ME-01',
            labelcz: 'Andrijevica'
        },
        {
            value: 'ME-02',
            labelcz: 'Bar'
        },
        {
            value: 'ME-03',
            labelcz: 'Berane'
        },
        {
            value: 'ME-04',
            labelcz: 'Bijelo Polje'
        },
        {
            value: 'ME-05',
            labelcz: 'Budva'
        },
        {
            value: 'ME-06',
            labelcz: 'Cetinje'
        },
        {
            value: 'ME-07',
            labelcz: 'Danilovgrad'
        },
        {
            value: 'ME-08',
            labelcz: 'Herceg-Novi'
        },
        {
            value: 'ME-09',
            labelcz: 'Kolasin'
        },
        {
            value: 'ME-10',
            labelcz: 'Kotor'
        },
        {
            value: 'ME-12',
            labelcz: 'Niksic'
        },
        {
            value: 'ME-13',
            labelcz: 'Plav'
        },
        {
            value: 'ME-14',
            labelcz: 'Pljevlja'
        },
        {
            value: 'ME-15',
            labelcz: 'Pluzine'
        },
        {
            value: 'ME-16',
            labelcz: 'Podgorica'
        },
        {
            value: 'ME-17',
            labelcz: 'Rozaje'
        },
        {
            value: 'ME-19',
            labelcz: 'Tivat'
        },
        {
            value: 'ME-24',
            labelcz: 'Tuzi'
        },
        {
            value: 'ME-20',
            labelcz: 'Ulcinj'
        },
        {
            value: 'ME-21',
            labelcz: 'Zabljak'
        }
    ],
    MF: [
        {
            value: '-',
            labelcz: 'Saint Martin (French Part)'
        }
    ],
    MG: [
        {
            value: 'MG-T',
            labelcz: 'Antananarivo'
        },
        {
            value: 'MG-D',
            labelcz: 'Antsiranana'
        },
        {
            value: 'MG-F',
            labelcz: 'Fianarantsoa'
        },
        {
            value: 'MG-M',
            labelcz: 'Mahajanga'
        },
        {
            value: 'MG-A',
            labelcz: 'Toamasina'
        },
        {
            value: 'MG-U',
            labelcz: 'Toliara'
        }
    ],
    MH: [
        {
            value: 'MH-KWA',
            labelcz: 'Kwajalein'
        },
        {
            value: 'MH-MAJ',
            labelcz: 'Majuro'
        }
    ],
    MK: [
        {
            value: 'MK-201',
            labelcz: 'Berovo'
        },
        {
            value: 'MK-501',
            labelcz: 'Bitola'
        },
        {
            value: 'MK-401',
            labelcz: 'Bogdanci'
        },
        {
            value: 'MK-601',
            labelcz: 'Bogovinje'
        },
        {
            value: 'MK-402',
            labelcz: 'Bosilovo'
        },
        {
            value: 'MK-602',
            labelcz: 'Brvenica'
        },
        {
            value: 'MK-803',
            labelcz: 'Butel'
        },
        {
            value: 'MK-109',
            labelcz: 'Caska'
        },
        {
            value: 'MK-814',
            labelcz: 'Centar'
        },
        {
            value: 'MK-210',
            labelcz: 'Cesinovo-Oblesevo'
        },
        {
            value: 'MK-816',
            labelcz: 'Cucer Sandevo'
        },
        {
            value: 'MK-303',
            labelcz: 'Debar'
        },
        {
            value: 'MK-502',
            labelcz: 'Demir Hisar'
        },
        {
            value: 'MK-103',
            labelcz: 'Demir Kapija'
        },
        {
            value: 'MK-406',
            labelcz: 'Dojran'
        },
        {
            value: 'MK-503',
            labelcz: 'Dolneni'
        },
        {
            value: 'MK-804',
            labelcz: 'Gazi Baba'
        },
        {
            value: 'MK-405',
            labelcz: 'Gevgelija'
        },
        {
            value: 'MK-604',
            labelcz: 'Gostivar'
        },
        {
            value: 'MK-102',
            labelcz: 'Gradsko'
        },
        {
            value: 'MK-807',
            labelcz: 'Ilinden'
        },
        {
            value: 'MK-606',
            labelcz: 'Jegunovce'
        },
        {
            value: 'MK-205',
            labelcz: 'Karbinci'
        },
        {
            value: 'MK-104',
            labelcz: 'Kavadarci'
        },
        {
            value: 'MK-307',
            labelcz: 'Kicevo'
        },
        {
            value: 'MK-809',
            labelcz: 'Kisela Voda'
        },
        {
            value: 'MK-206',
            labelcz: 'Kocani'
        },
        {
            value: 'MK-701',
            labelcz: 'Kratovo'
        },
        {
            value: 'MK-702',
            labelcz: 'Kriva Palanka'
        },
        {
            value: 'MK-504',
            labelcz: 'Krivogastani'
        },
        {
            value: 'MK-505',
            labelcz: 'Krusevo'
        },
        {
            value: 'MK-703',
            labelcz: 'Kumanovo'
        },
        {
            value: 'MK-704',
            labelcz: 'Lipkovo'
        },
        {
            value: 'MK-105',
            labelcz: 'Lozovo'
        },
        {
            value: 'MK-207',
            labelcz: 'Makedonska Kamenica'
        },
        {
            value: 'MK-308',
            labelcz: 'Makedonski Brod'
        },
        {
            value: 'MK-607',
            labelcz: 'Mavrovo i Rostusa'
        },
        {
            value: 'MK-506',
            labelcz: 'Mogila'
        },
        {
            value: 'MK-106',
            labelcz: 'Negotino'
        },
        {
            value: 'MK-507',
            labelcz: 'Novaci'
        },
        {
            value: 'MK-408',
            labelcz: 'Novo Selo'
        },
        {
            value: 'MK-310',
            labelcz: 'Ohrid'
        },
        {
            value: 'MK-208',
            labelcz: 'Pehcevo'
        },
        {
            value: 'MK-810',
            labelcz: 'Petrovec'
        },
        {
            value: 'MK-311',
            labelcz: 'Plasnica'
        },
        {
            value: 'MK-508',
            labelcz: 'Prilep'
        },
        {
            value: 'MK-209',
            labelcz: 'Probistip'
        },
        {
            value: 'MK-409',
            labelcz: 'Radovis'
        },
        {
            value: 'MK-705',
            labelcz: 'Rankovce'
        },
        {
            value: 'MK-509',
            labelcz: 'Resen'
        },
        {
            value: 'MK-107',
            labelcz: 'Rosoman'
        },
        {
            value: 'MK-811',
            labelcz: 'Saraj'
        },
        {
            value: 'MK-812',
            labelcz: 'Sopiste'
        },
        {
            value: 'MK-211',
            labelcz: 'Stip'
        },
        {
            value: 'MK-312',
            labelcz: 'Struga'
        },
        {
            value: 'MK-410',
            labelcz: 'Strumica'
        },
        {
            value: 'MK-813',
            labelcz: 'Studenicani'
        },
        {
            value: 'MK-108',
            labelcz: 'Sveti Nikole'
        },
        {
            value: 'MK-608',
            labelcz: 'Tearce'
        },
        {
            value: 'MK-609',
            labelcz: 'Tetovo'
        },
        {
            value: 'MK-403',
            labelcz: 'Valandovo'
        },
        {
            value: 'MK-404',
            labelcz: 'Vasilevo'
        },
        {
            value: 'MK-101',
            labelcz: 'Veles'
        },
        {
            value: 'MK-301',
            labelcz: 'Vevcani'
        },
        {
            value: 'MK-202',
            labelcz: 'Vinica'
        },
        {
            value: 'MK-806',
            labelcz: 'Zelenikovo'
        },
        {
            value: 'MK-605',
            labelcz: 'Zelino'
        }
    ],
    ML: [
        {
            value: 'ML-BKO',
            labelcz: 'Bamako'
        },
        {
            value: 'ML-7',
            labelcz: 'Gao'
        },
        {
            value: 'ML-1',
            labelcz: 'Kayes'
        },
        {
            value: 'ML-8',
            labelcz: 'Kidal'
        },
        {
            value: 'ML-2',
            labelcz: 'Koulikoro'
        },
        {
            value: 'ML-5',
            labelcz: 'Mopti'
        },
        {
            value: 'ML-4',
            labelcz: 'Segou'
        },
        {
            value: 'ML-3',
            labelcz: 'Sikasso'
        },
        {
            value: 'ML-6',
            labelcz: 'Tombouctou'
        }
    ],
    MM: [
        {
            value: 'MM-07',
            labelcz: 'Ayeyarwady'
        },
        {
            value: 'MM-02',
            labelcz: 'Bago'
        },
        {
            value: 'MM-14',
            labelcz: 'Chin'
        },
        {
            value: 'MM-11',
            labelcz: 'Kachin'
        },
        {
            value: 'MM-12',
            labelcz: 'Kayah'
        },
        {
            value: 'MM-13',
            labelcz: 'Kayin'
        },
        {
            value: 'MM-03',
            labelcz: 'Magway'
        },
        {
            value: 'MM-04',
            labelcz: 'Mandalay'
        },
        {
            value: 'MM-15',
            labelcz: 'Mon'
        },
        {
            value: 'MM-18',
            labelcz: 'Nay Pyi Taw'
        },
        {
            value: 'MM-16',
            labelcz: 'Rakhine'
        },
        {
            value: 'MM-01',
            labelcz: 'Sagaing'
        },
        {
            value: 'MM-17',
            labelcz: 'Shan'
        },
        {
            value: 'MM-05',
            labelcz: 'Tanintharyi'
        },
        {
            value: 'MM-06',
            labelcz: 'Yangon'
        }
    ],
    MN: [
        {
            value: 'MN-069',
            labelcz: 'Bayanhongor'
        },
        {
            value: 'MN-037',
            labelcz: 'Darhan uul'
        },
        {
            value: 'MN-061',
            labelcz: 'Dornod'
        },
        {
            value: 'MN-065',
            labelcz: 'Govi-Altay'
        },
        {
            value: 'MN-039',
            labelcz: 'Hentiy'
        },
        {
            value: 'MN-043',
            labelcz: 'Hovd'
        },
        {
            value: 'MN-053',
            labelcz: 'Omnogovi'
        },
        {
            value: 'MN-055',
            labelcz: 'Ovorhangay'
        },
        {
            value: 'MN-049',
            labelcz: 'Selenge'
        },
        {
            value: 'MN-047',
            labelcz: 'Tov'
        },
        {
            value: 'MN-1',
            labelcz: 'Ulaanbaatar'
        }
    ],
    MO: [
        {
            value: '-',
            labelcz: 'Macao'
        }
    ],
    MP: [
        {
            value: '-',
            labelcz: 'Northern Mariana Islands'
        }
    ],
    MQ: [
        {
            value: '-',
            labelcz: 'Martinique'
        }
    ],
    MR: [
        {
            value: 'MR-07',
            labelcz: 'Adrar'
        },
        {
            value: 'MR-03',
            labelcz: 'Assaba'
        },
        {
            value: 'MR-05',
            labelcz: 'Brakna'
        },
        {
            value: 'MR-08',
            labelcz: 'Dakhlet Nouadhibou'
        },
        {
            value: 'MR-04',
            labelcz: 'Gorgol'
        },
        {
            value: 'MR-02',
            labelcz: 'Hodh el Gharbi'
        },
        {
            value: 'MR-12',
            labelcz: 'Inchiri'
        },
        {
            value: 'MR-13',
            labelcz: 'Nouakchott Ouest'
        },
        {
            value: 'MR-09',
            labelcz: 'Tagant'
        },
        {
            value: 'MR-11',
            labelcz: 'Tiris Zemmour'
        },
        {
            value: 'MR-06',
            labelcz: 'Trarza'
        }
    ],
    MS: [
        {
            value: '-',
            labelcz: 'Saint Anthony'
        },
        {
            value: '-',
            labelcz: 'Saint Peter'
        }
    ],

    MU: [
        {
            value: 'MU-BL',
            labelcz: 'Black River'
        },
        {
            value: 'MU-FL',
            labelcz: 'Flacq'
        },
        {
            value: 'MU-GP',
            labelcz: 'Grand Port'
        },
        {
            value: 'MU-MO',
            labelcz: 'Moka'
        },
        {
            value: 'MU-PA',
            labelcz: 'Pamplemousses'
        },
        {
            value: 'MU-PW',
            labelcz: 'Plaines Wilhems'
        },
        {
            value: 'MU-PL',
            labelcz: 'Port Louis'
        },
        {
            value: 'MU-RR',
            labelcz: 'Riviere du Rempart'
        },
        {
            value: 'MU-RO',
            labelcz: 'Rodrigues Islands'
        },
        {
            value: 'MU-SA',
            labelcz: 'Savanne'
        }
    ],
    MV: [
        {
            value: 'MV-01',
            labelcz: 'Addu City'
        },
        {
            value: 'MV-03',
            labelcz: 'Faadhippolhu'
        },
        {
            value: 'MV-04',
            labelcz: 'Felidhu Atoll'
        },
        {
            value: 'MV-05',
            labelcz: 'Hahdhunmathi'
        },
        {
            value: 'MV-MLE',
            labelcz: 'Male'
        },
        {
            value: 'MV-12',
            labelcz: 'Mulaku Atoll'
        },
        {
            value: 'MV-02',
            labelcz: 'North Ari Atoll'
        },
        {
            value: 'MV-27',
            labelcz: 'North Huvadhu Atoll'
        },
        {
            value: 'MV-13',
            labelcz: 'North Maalhosmadulu'
        },
        {
            value: 'MV-07',
            labelcz: 'North Thiladhunmathi'
        },
        {
            value: 'MV-00',
            labelcz: 'South Ari Atoll'
        },
        {
            value: 'MV-28',
            labelcz: 'South Huvadhu Atoll'
        },
        {
            value: 'MV-20',
            labelcz: 'South Maalhosmadulu'
        },
        {
            value: 'MV-25',
            labelcz: 'South Miladhunmadulu'
        },
        {
            value: 'MV-23',
            labelcz: 'South Thiladhunmathi'
        }
    ],
    MW: [
        {
            value: 'MW-BA',
            labelcz: 'Balaka'
        },
        {
            value: 'MW-BL',
            labelcz: 'Blantyre'
        },
        {
            value: 'MW-CK',
            labelcz: 'Chikwawa'
        },
        {
            value: 'MW-CR',
            labelcz: 'Chiradzulu'
        },
        {
            value: 'MW-DE',
            labelcz: 'Dedza'
        },
        {
            value: 'MW-DO',
            labelcz: 'Dowa'
        },
        {
            value: 'MW-KR',
            labelcz: 'Karonga'
        },
        {
            value: 'MW-LI',
            labelcz: 'Lilongwe'
        },
        {
            value: 'MW-MH',
            labelcz: 'Machinga'
        },
        {
            value: 'MW-MG',
            labelcz: 'Mangochi'
        },
        {
            value: 'MW-MW',
            labelcz: 'Mwanza'
        },
        {
            value: 'MW-MZ',
            labelcz: 'Mzimba'
        },
        {
            value: 'MW-NE',
            labelcz: 'Neno'
        },
        {
            value: 'MW-NK',
            labelcz: 'Nkhotakota'
        },
        {
            value: 'MW-NI',
            labelcz: 'Ntchisi'
        },
        {
            value: 'MW-SA',
            labelcz: 'Salima'
        },
        {
            value: 'MW-TH',
            labelcz: 'Thyolo'
        },
        {
            value: 'MW-ZO',
            labelcz: 'Zomba'
        }
    ],
    MX: [
        {
            value: 'MX-AGU',
            labelcz: 'Aguascalientes'
        },
        {
            value: 'MX-BCN',
            labelcz: 'Baja California'
        },
        {
            value: 'MX-BCS',
            labelcz: 'Baja California Sur'
        },
        {
            value: 'MX-CAM',
            labelcz: 'Campeche'
        },
        {
            value: 'MX-CHP',
            labelcz: 'Chiapas'
        },
        {
            value: 'MX-CHH',
            labelcz: 'Chihuahua'
        },
        {
            value: 'MX-CMX',
            labelcz: 'Ciudad de Mexico'
        },
        {
            value: 'MX-COA',
            labelcz: 'Coahuila de Zaragoza'
        },
        {
            value: 'MX-COL',
            labelcz: 'Colima'
        },
        {
            value: 'MX-DUR',
            labelcz: 'Durango'
        },
        {
            value: 'MX-GUA',
            labelcz: 'Guanajuato'
        },
        {
            value: 'MX-GRO',
            labelcz: 'Guerrero'
        },
        {
            value: 'MX-HID',
            labelcz: 'Hidalgo'
        },
        {
            value: 'MX-JAL',
            labelcz: 'Jalisco'
        },
        {
            value: 'MX-MEX',
            labelcz: 'Mexico'
        },
        {
            value: 'MX-MIC',
            labelcz: 'Michoacan de Ocampo'
        },
        {
            value: 'MX-MOR',
            labelcz: 'Morelos'
        },
        {
            value: 'MX-NAY',
            labelcz: 'Nayarit'
        },
        {
            value: 'MX-NLE',
            labelcz: 'Nuevo Leon'
        },
        {
            value: 'MX-OAX',
            labelcz: 'Oaxaca'
        },
        {
            value: 'MX-PUE',
            labelcz: 'Puebla'
        },
        {
            value: 'MX-QUE',
            labelcz: 'Queretaro'
        },
        {
            value: 'MX-ROO',
            labelcz: 'Quintana Roo'
        },
        {
            value: 'MX-SLP',
            labelcz: 'San Luis Potosi'
        },
        {
            value: 'MX-SIN',
            labelcz: 'Sinaloa'
        },
        {
            value: 'MX-SON',
            labelcz: 'Sonora'
        },
        {
            value: 'MX-TAB',
            labelcz: 'Tabasco'
        },
        {
            value: 'MX-TAM',
            labelcz: 'Tamaulipas'
        },
        {
            value: 'MX-TLA',
            labelcz: 'Tlaxcala'
        },
        {
            value: 'MX-VER',
            labelcz: 'Veracruz de Ignacio de la Llave'
        },
        {
            value: 'MX-YUC',
            labelcz: 'Yucatan'
        },
        {
            value: 'MX-ZAC',
            labelcz: 'Zacatecas'
        }
    ],
    MY: [
        {
            value: 'MY-01',
            labelcz: 'Johor'
        },
        {
            value: 'MY-02',
            labelcz: 'Kedah'
        },
        {
            value: 'MY-03',
            labelcz: 'Kelantan'
        },
        {
            value: 'MY-04',
            labelcz: 'Melaka'
        },
        {
            value: 'MY-05',
            labelcz: 'Negeri Sembilan'
        },
        {
            value: 'MY-06',
            labelcz: 'Pahang'
        },
        {
            value: 'MY-08',
            labelcz: 'Perak'
        },
        {
            value: 'MY-09',
            labelcz: 'Perlis'
        },
        {
            value: 'MY-07',
            labelcz: 'Pulau Pinang'
        },
        {
            value: 'MY-12',
            labelcz: 'Sabah'
        },
        {
            value: 'MY-13',
            labelcz: 'Sarawak'
        },
        {
            value: 'MY-10',
            labelcz: 'Selangor'
        },
        {
            value: 'MY-11',
            labelcz: 'Terengganu'
        },
        {
            value: 'MY-14',
            labelcz: 'Wilayah Persekutuan Kuala Lumpur'
        },
        {
            value: 'MY-15',
            labelcz: 'Wilayah Persekutuan Labuan'
        },
        {
            value: 'MY-16',
            labelcz: 'Wilayah Persekutuan Putrajaya'
        }
    ],
    MZ: [
        {
            value: 'MZ-P',
            labelcz: 'Cabo Delgado'
        },
        {
            value: 'MZ-G',
            labelcz: 'Gaza'
        },
        {
            value: 'MZ-I',
            labelcz: 'Inhambane'
        },
        {
            value: 'MZ-B',
            labelcz: 'Manica'
        },
        {
            value: 'MZ-L',
            labelcz: 'Maputo'
        },
        {
            value: 'MZ-N',
            labelcz: 'Nampula'
        },
        {
            value: 'MZ-A',
            labelcz: 'Niassa'
        },
        {
            value: 'MZ-S',
            labelcz: 'Sofala'
        },
        {
            value: 'MZ-T',
            labelcz: 'Tete'
        },
        {
            value: 'MZ-Q',
            labelcz: 'Zambezia'
        }
    ],
    NA: [],
    NC: [
        {
            value: '-',
            labelcz: 'Province Nord'
        },
        {
            value: '-',
            labelcz: 'Province Sud'
        }
    ],
    NE: [
        {
            value: 'NE-1',
            labelcz: 'Agadez'
        },
        {
            value: 'NE-2',
            labelcz: 'Diffa'
        },
        {
            value: 'NE-3',
            labelcz: 'Dosso'
        },
        {
            value: 'NE-4',
            labelcz: 'Maradi'
        },
        {
            value: 'NE-8',
            labelcz: 'Niamey'
        },
        {
            value: 'NE-5',
            labelcz: 'Tahoua'
        },
        {
            value: 'NE-6',
            labelcz: 'Tillaberi'
        },
        {
            value: 'NE-7',
            labelcz: 'Zinder'
        }
    ],
    NF: [
        {
            value: '-',
            labelcz: 'Norfolk Island'
        }
    ],
    NG: [
        {
            value: 'NG-AB',
            labelcz: 'Abia'
        },
        {
            value: 'NG-FC',
            labelcz: 'Abuja Federal Capital Territory'
        },
        {
            value: 'NG-AD',
            labelcz: 'Adamawa'
        },
        {
            value: 'NG-AK',
            labelcz: 'Akwa Ibom'
        },
        {
            value: 'NG-AN',
            labelcz: 'Anambra'
        },
        {
            value: 'NG-BA',
            labelcz: 'Bauchi'
        },
        {
            value: 'NG-BY',
            labelcz: 'Bayelsa'
        },
        {
            value: 'NG-BE',
            labelcz: 'Benue'
        },
        {
            value: 'NG-BO',
            labelcz: 'Borno'
        },
        {
            value: 'NG-CR',
            labelcz: 'Cross River'
        },
        {
            value: 'NG-DE',
            labelcz: 'Delta'
        },
        {
            value: 'NG-EB',
            labelcz: 'Ebonyi'
        },
        {
            value: 'NG-ED',
            labelcz: 'Edo'
        },
        {
            value: 'NG-EK',
            labelcz: 'Ekiti'
        },
        {
            value: 'NG-EN',
            labelcz: 'Enugu'
        },
        {
            value: 'NG-GO',
            labelcz: 'Gombe'
        },
        {
            value: 'NG-IM',
            labelcz: 'Imo'
        },
        {
            value: 'NG-JI',
            labelcz: 'Jigawa'
        },
        {
            value: 'NG-KD',
            labelcz: 'Kaduna'
        },
        {
            value: 'NG-KN',
            labelcz: 'Kano'
        },
        {
            value: 'NG-KT',
            labelcz: 'Katsina'
        },
        {
            value: 'NG-KE',
            labelcz: 'Kebbi'
        },
        {
            value: 'NG-KO',
            labelcz: 'Kogi'
        },
        {
            value: 'NG-KW',
            labelcz: 'Kwara'
        },
        {
            value: 'NG-LA',
            labelcz: 'Lagos'
        },
        {
            value: 'NG-NA',
            labelcz: 'Nasarawa'
        },
        {
            value: 'NG-NI',
            labelcz: 'Niger'
        },
        {
            value: 'NG-OG',
            labelcz: 'Ogun'
        },
        {
            value: 'NG-ON',
            labelcz: 'Ondo'
        },
        {
            value: 'NG-OS',
            labelcz: 'Osun'
        },
        {
            value: 'NG-OY',
            labelcz: 'Oyo'
        },
        {
            value: 'NG-PL',
            labelcz: 'Plateau'
        },
        {
            value: 'NG-RI',
            labelcz: 'Rivers'
        },
        {
            value: 'NG-SO',
            labelcz: 'Sokoto'
        },
        {
            value: 'NG-TA',
            labelcz: 'Taraba'
        },
        {
            value: 'NG-YO',
            labelcz: 'Yobe'
        },
        {
            value: 'NG-ZA',
            labelcz: 'Zamfara'
        }
    ],
    NI: [
        {
            value: 'NI-BO',
            labelcz: 'Boaco'
        },
        {
            value: 'NI-CA',
            labelcz: 'Carazo'
        },
        {
            value: 'NI-CI',
            labelcz: 'Chinandega'
        },
        {
            value: 'NI-CO',
            labelcz: 'Chontales'
        },
        {
            value: 'NI-AN',
            labelcz: 'Costa Caribe Norte'
        },
        {
            value: 'NI-AS',
            labelcz: 'Costa Caribe Sur'
        },
        {
            value: 'NI-ES',
            labelcz: 'Esteli'
        },
        {
            value: 'NI-GR',
            labelcz: 'Granada'
        },
        {
            value: 'NI-JI',
            labelcz: 'Jinotega'
        },
        {
            value: 'NI-LE',
            labelcz: 'Leon'
        },
        {
            value: 'NI-MD',
            labelcz: 'Madriz'
        },
        {
            value: 'NI-MN',
            labelcz: 'Managua'
        },
        {
            value: 'NI-MS',
            labelcz: 'Masaya'
        },
        {
            value: 'NI-MT',
            labelcz: 'Matagalpa'
        },
        {
            value: 'NI-NS',
            labelcz: 'Nueva Segovia'
        },
        {
            value: 'NI-SJ',
            labelcz: 'Rio San Juan'
        },
        {
            value: 'NI-RI',
            labelcz: 'Rivas'
        }
    ],

    NO: [
        {
            value: 'NO-42',
            labelcz: 'Agder'
        },
        {
            value: 'NO-34',
            labelcz: 'Innlandet'
        },
        {
            value: 'NO-15',
            labelcz: 'More og Romsdal'
        },
        {
            value: 'NO-18',
            labelcz: 'Nordland'
        },
        {
            value: 'NO-03',
            labelcz: 'Oslo'
        },
        {
            value: 'NO-11',
            labelcz: 'Rogaland'
        },
        {
            value: 'NO-54',
            labelcz: 'Troms og Finnmark'
        },
        {
            value: 'NO-50',
            labelcz: 'Trondelag'
        },
        {
            value: 'NO-38',
            labelcz: 'Vestfold og Telemark'
        },
        {
            value: 'NO-46',
            labelcz: 'Vestland'
        },
        {
            value: 'NO-30',
            labelcz: 'Viken'
        }
    ],
    NP: [
        {
            value: 'NP-BA',
            labelcz: 'Bagmati'
        },
        {
            value: 'NP-BH',
            labelcz: 'Bheri'
        },
        {
            value: 'NP-DH',
            labelcz: 'Dhawalagiri'
        },
        {
            value: 'NP-GA',
            labelcz: 'Gandaki'
        },
        {
            value: 'NP-JA',
            labelcz: 'Janakpur'
        },
        {
            value: 'NP-KA',
            labelcz: 'Karnali'
        },
        {
            value: 'NP-KO',
            labelcz: 'Kosi'
        },
        {
            value: 'NP-LU',
            labelcz: 'Lumbini'
        },
        {
            value: 'NP-MA',
            labelcz: 'Mahakali'
        },
        {
            value: 'NP-ME',
            labelcz: 'Mechi'
        },
        {
            value: 'NP-NA',
            labelcz: 'Narayani'
        },
        {
            value: 'NP-RA',
            labelcz: 'Rapti'
        },
        {
            value: 'NP-SA',
            labelcz: 'Sagarmatha'
        },
        {
            value: 'NP-SE',
            labelcz: 'Seti'
        }
    ],
    NR: [
        {
            value: 'NR-01',
            labelcz: 'Aiwo'
        },
        {
            value: 'NR-03',
            labelcz: 'Anetan'
        },
        {
            value: 'NR-14',
            labelcz: 'Yaren'
        }
    ],
    NU: [
        {
            value: '-',
            labelcz: 'Niue'
        }
    ],
    NZ: [
        {
            value: 'NZ-AUK',
            labelcz: 'Auckland'
        },
        {
            value: 'NZ-BOP',
            labelcz: 'Bay of Plenty'
        },
        {
            value: 'NZ-CAN',
            labelcz: 'Canterbury'
        },
        {
            value: 'NZ-CIT',
            labelcz: 'Chatham Islands Territory'
        },
        {
            value: 'NZ-GIS',
            labelcz: 'Gisborne'
        },
        {
            value: 'NZ-HKB',
            labelcz: "Hawke's Bay"
        },
        {
            value: 'NZ-MWT',
            labelcz: 'Manawatu-Wanganui'
        },
        {
            value: 'NZ-MBH',
            labelcz: 'Marlborough'
        },
        {
            value: 'NZ-NSN',
            labelcz: 'Nelson'
        },
        {
            value: 'NZ-NTL',
            labelcz: 'Northland'
        },
        {
            value: 'NZ-OTA',
            labelcz: 'Otago'
        },
        {
            value: 'NZ-STL',
            labelcz: 'Southland'
        },
        {
            value: 'NZ-TKI',
            labelcz: 'Taranaki'
        },
        {
            value: 'NZ-TAS',
            labelcz: 'Tasman'
        },
        {
            value: 'NZ-WKO',
            labelcz: 'Waikato'
        },
        {
            value: 'NZ-WGN',
            labelcz: 'Wellington'
        },
        {
            value: 'NZ-WTC',
            labelcz: 'West Coast'
        }
    ],
    OM: [
        {
            value: 'OM-DA',
            labelcz: 'Ad Dakhiliyah'
        },
        {
            value: 'OM-BU',
            labelcz: 'Al Buraymi'
        },
        {
            value: 'OM-WU',
            labelcz: 'Al Wusta'
        },
        {
            value: 'OM-ZA',
            labelcz: 'Az Zahirah'
        },
        {
            value: 'OM-BJ',
            labelcz: 'Janub al Batinah'
        },
        {
            value: 'OM-SJ',
            labelcz: 'Janub ash Sharqiyah'
        },
        {
            value: 'OM-MA',
            labelcz: 'Masqat'
        },
        {
            value: 'OM-MU',
            labelcz: 'Musandam'
        },
        {
            value: 'OM-BS',
            labelcz: 'Shamal al Batinah'
        },
        {
            value: 'OM-SS',
            labelcz: 'Shamal ash Sharqiyah'
        },
        {
            value: 'OM-ZU',
            labelcz: 'Zufar'
        }
    ],
    PA: [
        {
            value: 'PA-1',
            labelcz: 'Bocas del Toro'
        },
        {
            value: 'PA-4',
            labelcz: 'Chiriqui'
        },
        {
            value: 'PA-2',
            labelcz: 'Cocle'
        },
        {
            value: 'PA-3',
            labelcz: 'Colon'
        },
        {
            value: 'PA-5',
            labelcz: 'Darien'
        },
        {
            value: 'PA-6',
            labelcz: 'Herrera'
        },
        {
            value: 'PA-7',
            labelcz: 'Los Santos'
        },
        {
            value: 'PA-NB',
            labelcz: 'Ngobe-Bugle'
        },
        {
            value: 'PA-8',
            labelcz: 'Panama'
        },
        {
            value: 'PA-9',
            labelcz: 'Veraguas'
        }
    ],
    PE: [
        {
            value: 'PE-AMA',
            labelcz: 'Amazonas'
        },
        {
            value: 'PE-ANC',
            labelcz: 'Ancash'
        },
        {
            value: 'PE-APU',
            labelcz: 'Apurimac'
        },
        {
            value: 'PE-ARE',
            labelcz: 'Arequipa'
        },
        {
            value: 'PE-AYA',
            labelcz: 'Ayacucho'
        },
        {
            value: 'PE-CAJ',
            labelcz: 'Cajamarca'
        },
        {
            value: 'PE-CUS',
            labelcz: 'Cusco'
        },
        {
            value: 'PE-CAL',
            labelcz: 'El Callao'
        },
        {
            value: 'PE-HUV',
            labelcz: 'Huancavelica'
        },
        {
            value: 'PE-HUC',
            labelcz: 'Huanuco'
        },
        {
            value: 'PE-ICA',
            labelcz: 'Ica'
        },
        {
            value: 'PE-JUN',
            labelcz: 'Junin'
        },
        {
            value: 'PE-LAL',
            labelcz: 'La Libertad'
        },
        {
            value: 'PE-LAM',
            labelcz: 'Lambayeque'
        },
        {
            value: 'PE-LIM',
            labelcz: 'Lima'
        },
        {
            value: 'PE-LOR',
            labelcz: 'Loreto'
        },
        {
            value: 'PE-MDD',
            labelcz: 'Madre de Dios'
        },
        {
            value: 'PE-MOQ',
            labelcz: 'Moquegua'
        },
        {
            value: 'PE-PAS',
            labelcz: 'Pasco'
        },
        {
            value: 'PE-PIU',
            labelcz: 'Piura'
        },
        {
            value: 'PE-PUN',
            labelcz: 'Puno'
        },
        {
            value: 'PE-SAM',
            labelcz: 'San Martin'
        },
        {
            value: 'PE-TAC',
            labelcz: 'Tacna'
        },
        {
            value: 'PE-TUM',
            labelcz: 'Tumbes'
        },
        {
            value: 'PE-UCA',
            labelcz: 'Ucayali'
        }
    ],
    PF: [
        {
            value: '-',
            labelcz: 'Iles Australes'
        },
        {
            value: '-',
            labelcz: 'Iles Marquises'
        },
        {
            value: '-',
            labelcz: 'Iles Sous-le-Vent'
        },
        {
            value: '-',
            labelcz: 'Iles Tuamotu-Gambier'
        },
        {
            value: '-',
            labelcz: 'Iles du Vent'
        }
    ],
    PG: [
        {
            value: 'PG-NSB',
            labelcz: 'Bougainville'
        },
        {
            value: 'PG-CPM',
            labelcz: 'Central'
        },
        {
            value: 'PG-CPK',
            labelcz: 'Chimbu'
        },
        {
            value: 'PG-EBR',
            labelcz: 'East New Britain'
        },
        {
            value: 'PG-ESW',
            labelcz: 'East Sepik'
        },
        {
            value: 'PG-EHG',
            labelcz: 'Eastern Highlands'
        },
        {
            value: 'PG-MPM',
            labelcz: 'Madang'
        },
        {
            value: 'PG-MRL',
            labelcz: 'Manus'
        },
        {
            value: 'PG-MBA',
            labelcz: 'Milne Bay'
        },
        {
            value: 'PG-MPL',
            labelcz: 'Morobe'
        },
        {
            value: 'PG-NCD',
            labelcz: 'National Capital District (Port Moresby)'
        },
        {
            value: 'PG-NIK',
            labelcz: 'New Ireland'
        },
        {
            value: 'PG-SHM',
            labelcz: 'Southern Highlands'
        },
        {
            value: 'PG-WBK',
            labelcz: 'West New Britain'
        },
        {
            value: 'PG-SAN',
            labelcz: 'West Sepik'
        },
        {
            value: 'PG-WPD',
            labelcz: 'Western'
        },
        {
            value: 'PG-WHM',
            labelcz: 'Western Highlands'
        }
    ],
    PH: [
        {
            value: 'PH-ABR',
            labelcz: 'Abra'
        },
        {
            value: 'PH-AGN',
            labelcz: 'Agusan del Norte'
        },
        {
            value: 'PH-AGS',
            labelcz: 'Agusan del Sur'
        },
        {
            value: 'PH-AKL',
            labelcz: 'Aklan'
        },
        {
            value: 'PH-ALB',
            labelcz: 'Albay'
        },
        {
            value: 'PH-ANT',
            labelcz: 'Antique'
        },
        {
            value: 'PH-APA',
            labelcz: 'Apayao'
        },
        {
            value: 'PH-AUR',
            labelcz: 'Aurora'
        },
        {
            value: 'PH-BAS',
            labelcz: 'Basilan'
        },
        {
            value: 'PH-BAN',
            labelcz: 'Bataan'
        },
        {
            value: 'PH-BTN',
            labelcz: 'Batanes'
        },
        {
            value: 'PH-BTG',
            labelcz: 'Batangas'
        },
        {
            value: 'PH-BEN',
            labelcz: 'Benguet'
        },
        {
            value: 'PH-BIL',
            labelcz: 'Biliran'
        },
        {
            value: 'PH-BOH',
            labelcz: 'Bohol'
        },
        {
            value: 'PH-BUK',
            labelcz: 'Bukidnon'
        },
        {
            value: 'PH-BUL',
            labelcz: 'Bulacan'
        },
        {
            value: 'PH-CAG',
            labelcz: 'Cagayan'
        },
        {
            value: 'PH-CAN',
            labelcz: 'Camarines Norte'
        },
        {
            value: 'PH-CAS',
            labelcz: 'Camarines Sur'
        },
        {
            value: 'PH-CAM',
            labelcz: 'Camiguin'
        },
        {
            value: 'PH-CAP',
            labelcz: 'Capiz'
        },
        {
            value: 'PH-CAT',
            labelcz: 'Catanduanes'
        },
        {
            value: 'PH-CAV',
            labelcz: 'Cavite'
        },
        {
            value: 'PH-CEB',
            labelcz: 'Cebu'
        },
        {
            value: 'PH-NCO',
            labelcz: 'Cotabato'
        },
        {
            value: 'PH-DAO',
            labelcz: 'Davao Oriental'
        },
        {
            value: 'PH-COM',
            labelcz: 'Davao de Oro'
        },
        {
            value: 'PH-DAV',
            labelcz: 'Davao del Norte'
        },
        {
            value: 'PH-DAS',
            labelcz: 'Davao del Sur'
        },
        {
            value: 'PH-DIN',
            labelcz: 'Dinagat Islands'
        },
        {
            value: 'PH-EAS',
            labelcz: 'Eastern Samar'
        },
        {
            value: 'PH-GUI',
            labelcz: 'Guimaras'
        },
        {
            value: 'PH-IFU',
            labelcz: 'Ifugao'
        },
        {
            value: 'PH-ILN',
            labelcz: 'Ilocos Norte'
        },
        {
            value: 'PH-ILS',
            labelcz: 'Ilocos Sur'
        },
        {
            value: 'PH-ILI',
            labelcz: 'Iloilo'
        },
        {
            value: 'PH-ISA',
            labelcz: 'Isabela'
        },
        {
            value: 'PH-KAL',
            labelcz: 'Kalinga'
        },
        {
            value: 'PH-LUN',
            labelcz: 'La Union'
        },
        {
            value: 'PH-LAG',
            labelcz: 'Laguna'
        },
        {
            value: 'PH-LAN',
            labelcz: 'Lanao del Norte'
        },
        {
            value: 'PH-LAS',
            labelcz: 'Lanao del Sur'
        },
        {
            value: 'PH-LEY',
            labelcz: 'Leyte'
        },
        {
            value: 'PH-MAG',
            labelcz: 'Maguindanao'
        },
        {
            value: 'PH-MAD',
            labelcz: 'Marinduque'
        },
        {
            value: 'PH-MAS',
            labelcz: 'Masbate'
        },
        {
            value: 'PH-MDC',
            labelcz: 'Mindoro Occidental'
        },
        {
            value: 'PH-MDR',
            labelcz: 'Mindoro Oriental'
        },
        {
            value: 'PH-MSC',
            labelcz: 'Misamis Occidental'
        },
        {
            value: 'PH-MSR',
            labelcz: 'Misamis Oriental'
        },
        {
            value: 'PH-MOU',
            labelcz: 'Mountain Province'
        },
        {
            value: 'PH-00',
            labelcz: 'National Capital Region'
        },
        {
            value: 'PH-NEC',
            labelcz: 'Negros Occidental'
        },
        {
            value: 'PH-NER',
            labelcz: 'Negros Oriental'
        },
        {
            value: 'PH-NSA',
            labelcz: 'Northern Samar'
        },
        {
            value: 'PH-NUE',
            labelcz: 'Nueva Ecija'
        },
        {
            value: 'PH-NUV',
            labelcz: 'Nueva Vizcaya'
        },
        {
            value: 'PH-PLW',
            labelcz: 'Palawan'
        },
        {
            value: 'PH-PAM',
            labelcz: 'Pampanga'
        },
        {
            value: 'PH-PAN',
            labelcz: 'Pangasinan'
        },
        {
            value: 'PH-QUE',
            labelcz: 'Quezon'
        },
        {
            value: 'PH-QUI',
            labelcz: 'Quirino'
        },
        {
            value: 'PH-RIZ',
            labelcz: 'Rizal'
        },
        {
            value: 'PH-ROM',
            labelcz: 'Romblon'
        },
        {
            value: 'PH-WSA',
            labelcz: 'Samar'
        },
        {
            value: 'PH-SAR',
            labelcz: 'Sarangani'
        },
        {
            value: 'PH-SIG',
            labelcz: 'Siquijor'
        },
        {
            value: 'PH-SOR',
            labelcz: 'Sorsogon'
        },
        {
            value: 'PH-SCO',
            labelcz: 'South Cotabato'
        },
        {
            value: 'PH-SLE',
            labelcz: 'Southern Leyte'
        },
        {
            value: 'PH-SUK',
            labelcz: 'Sultan Kudarat'
        },
        {
            value: 'PH-SLU',
            labelcz: 'Sulu'
        },
        {
            value: 'PH-SUN',
            labelcz: 'Surigao del Norte'
        },
        {
            value: 'PH-SUR',
            labelcz: 'Surigao del Sur'
        },
        {
            value: 'PH-TAR',
            labelcz: 'Tarlac'
        },
        {
            value: 'PH-TAW',
            labelcz: 'Tawi-Tawi'
        },
        {
            value: 'PH-ZMB',
            labelcz: 'Zambales'
        },
        {
            value: 'PH-ZSI',
            labelcz: 'Zamboanga Sibugay'
        },
        {
            value: 'PH-ZAN',
            labelcz: 'Zamboanga del Norte'
        },
        {
            value: 'PH-ZAS',
            labelcz: 'Zamboanga del Sur'
        }
    ],
    PK: [
        {
            value: 'PK-JK',
            labelcz: 'Azad Jammu and Kashmir'
        },
        {
            value: 'PK-BA',
            labelcz: 'Balochistan'
        },
        {
            value: 'PK-GB',
            labelcz: 'Gilgit-Baltistan'
        },
        {
            value: 'PK-IS',
            labelcz: 'Islamabad'
        },
        {
            value: 'PK-KP',
            labelcz: 'Khyber Pakhtunkhwa'
        },
        {
            value: 'PK-PB',
            labelcz: 'Punjab'
        },
        {
            value: 'PK-SD',
            labelcz: 'Sindh'
        }
    ],
    PM: [
        {
            value: '-',
            labelcz: 'Saint Pierre and Miquelon'
        }
    ],
    PN: [
        {
            value: '-',
            labelcz: 'Pitcairn'
        }
    ],
    PR: [
        {
            value: '-',
            labelcz: 'Adjuntas'
        },
        {
            value: '-',
            labelcz: 'Aguada'
        },
        {
            value: '-',
            labelcz: 'Aguadilla'
        },
        {
            value: '-',
            labelcz: 'Aguas Buenas'
        },
        {
            value: '-',
            labelcz: 'Aibonito'
        },
        {
            value: '-',
            labelcz: 'Anasco'
        },
        {
            value: '-',
            labelcz: 'Arecibo'
        },
        {
            value: '-',
            labelcz: 'Arroyo'
        },
        {
            value: '-',
            labelcz: 'Barceloneta'
        },
        {
            value: '-',
            labelcz: 'Barranquitas'
        },
        {
            value: '-',
            labelcz: 'Bayamon'
        },
        {
            value: '-',
            labelcz: 'Cabo Rojo'
        },
        {
            value: '-',
            labelcz: 'Caguas'
        },
        {
            value: '-',
            labelcz: 'Camuy'
        },
        {
            value: '-',
            labelcz: 'Canovanas'
        },
        {
            value: '-',
            labelcz: 'Carolina'
        },
        {
            value: '-',
            labelcz: 'Catano'
        },
        {
            value: '-',
            labelcz: 'Cayey'
        },
        {
            value: '-',
            labelcz: 'Ceiba'
        },
        {
            value: '-',
            labelcz: 'Ciales'
        },
        {
            value: '-',
            labelcz: 'Cidra'
        },
        {
            value: '-',
            labelcz: 'Coamo'
        },
        {
            value: '-',
            labelcz: 'Comerio'
        },
        {
            value: '-',
            labelcz: 'Corozal'
        },
        {
            value: '-',
            labelcz: 'Culebra'
        },
        {
            value: '-',
            labelcz: 'Dorado'
        },
        {
            value: '-',
            labelcz: 'Fajardo'
        },
        {
            value: '-',
            labelcz: 'Florida'
        },
        {
            value: '-',
            labelcz: 'Guanica'
        },
        {
            value: '-',
            labelcz: 'Guayama'
        },
        {
            value: '-',
            labelcz: 'Guayanilla'
        },
        {
            value: '-',
            labelcz: 'Guaynabo'
        },
        {
            value: '-',
            labelcz: 'Gurabo'
        },
        {
            value: '-',
            labelcz: 'Hatillo'
        },
        {
            value: '-',
            labelcz: 'Hormigueros'
        },
        {
            value: '-',
            labelcz: 'Humacao'
        },
        {
            value: '-',
            labelcz: 'Isabela'
        },
        {
            value: '-',
            labelcz: 'Juana Diaz'
        },
        {
            value: '-',
            labelcz: 'Lajas'
        },
        {
            value: '-',
            labelcz: 'Lares'
        },
        {
            value: '-',
            labelcz: 'Las Marias'
        },
        {
            value: '-',
            labelcz: 'Las Piedras'
        },
        {
            value: '-',
            labelcz: 'Loiza'
        },
        {
            value: '-',
            labelcz: 'Luquillo'
        },
        {
            value: '-',
            labelcz: 'Manati'
        },
        {
            value: '-',
            labelcz: 'Maunabo'
        },
        {
            value: '-',
            labelcz: 'Mayaguez'
        },
        {
            value: '-',
            labelcz: 'Moca'
        },
        {
            value: '-',
            labelcz: 'Morovis'
        },
        {
            value: '-',
            labelcz: 'Municipio de Jayuya'
        },
        {
            value: '-',
            labelcz: 'Municipio de Juncos'
        },
        {
            value: '-',
            labelcz: 'Naguabo'
        },
        {
            value: '-',
            labelcz: 'Naranjito'
        },
        {
            value: '-',
            labelcz: 'Patillas'
        },
        {
            value: '-',
            labelcz: 'Penuelas'
        },
        {
            value: '-',
            labelcz: 'Ponce'
        },
        {
            value: '-',
            labelcz: 'Quebradillas'
        },
        {
            value: '-',
            labelcz: 'Rincon'
        },
        {
            value: '-',
            labelcz: 'Rio Grande'
        },
        {
            value: '-',
            labelcz: 'Sabana Grande'
        },
        {
            value: '-',
            labelcz: 'Salinas'
        },
        {
            value: '-',
            labelcz: 'San German'
        },
        {
            value: '-',
            labelcz: 'San Juan'
        },
        {
            value: '-',
            labelcz: 'San Lorenzo'
        },
        {
            value: '-',
            labelcz: 'San Sebastian'
        },
        {
            value: '-',
            labelcz: 'Santa Isabel Municipio'
        },
        {
            value: '-',
            labelcz: 'Toa Alta'
        },
        {
            value: '-',
            labelcz: 'Toa Baja'
        },
        {
            value: '-',
            labelcz: 'Trujillo Alto'
        },
        {
            value: '-',
            labelcz: 'Utuado'
        },
        {
            value: '-',
            labelcz: 'Vega Alta'
        },
        {
            value: '-',
            labelcz: 'Vega Baja'
        },
        {
            value: '-',
            labelcz: 'Vieques'
        },
        {
            value: '-',
            labelcz: 'Villalba'
        },
        {
            value: '-',
            labelcz: 'Yabucoa'
        },
        {
            value: '-',
            labelcz: 'Yauco'
        }
    ],
    PS: [
        {
            value: 'PS-BTH',
            labelcz: 'Bethlehem'
        },
        {
            value: 'PS-DEB',
            labelcz: 'Deir El Balah'
        },
        {
            value: 'PS-GZA',
            labelcz: 'Gaza'
        },
        {
            value: 'PS-HBN',
            labelcz: 'Hebron'
        },
        {
            value: 'PS-JEN',
            labelcz: 'Jenin'
        },
        {
            value: 'PS-JRH',
            labelcz: 'Jericho and Al Aghwar'
        },
        {
            value: 'PS-JEM',
            labelcz: 'Jerusalem'
        },
        {
            value: 'PS-KYS',
            labelcz: 'Khan Yunis'
        },
        {
            value: 'PS-NBS',
            labelcz: 'Nablus'
        },
        {
            value: 'PS-QQA',
            labelcz: 'Qalqilya'
        },
        {
            value: 'PS-RFH',
            labelcz: 'Rafah'
        },
        {
            value: 'PS-RBH',
            labelcz: 'Ramallah'
        },
        {
            value: 'PS-SLT',
            labelcz: 'Salfit'
        },
        {
            value: 'PS-TBS',
            labelcz: 'Tubas'
        },
        {
            value: 'PS-TKM',
            labelcz: 'Tulkarm'
        }
    ],
    PT: [
        {
            value: 'PT-01',
            labelcz: 'Aveiro'
        },
        {
            value: 'PT-02',
            labelcz: 'Beja'
        },
        {
            value: 'PT-03',
            labelcz: 'Braga'
        },
        {
            value: 'PT-04',
            labelcz: 'Braganca'
        },
        {
            value: 'PT-05',
            labelcz: 'Castelo Branco'
        },
        {
            value: 'PT-06',
            labelcz: 'Coimbra'
        },
        {
            value: 'PT-07',
            labelcz: 'Evora'
        },
        {
            value: 'PT-08',
            labelcz: 'Faro'
        },
        {
            value: 'PT-09',
            labelcz: 'Guarda'
        },
        {
            value: 'PT-10',
            labelcz: 'Leiria'
        },
        {
            value: 'PT-11',
            labelcz: 'Lisboa'
        },
        {
            value: 'PT-12',
            labelcz: 'Portalegre'
        },
        {
            value: 'PT-13',
            labelcz: 'Porto'
        },
        {
            value: 'PT-30',
            labelcz: 'Regiao Autonoma da Madeira'
        },
        {
            value: 'PT-20',
            labelcz: 'Regiao Autonoma dos Acores'
        },
        {
            value: 'PT-14',
            labelcz: 'Santarem'
        },
        {
            value: 'PT-15',
            labelcz: 'Setubal'
        },
        {
            value: 'PT-16',
            labelcz: 'Viana do Castelo'
        },
        {
            value: 'PT-17',
            labelcz: 'Vila Real'
        },
        {
            value: 'PT-18',
            labelcz: 'Viseu'
        }
    ],
    PW: [
        {
            value: 'PW-004',
            labelcz: 'Airai'
        },
        {
            value: 'PW-150',
            labelcz: 'Koror'
        },
        {
            value: 'PW-212',
            labelcz: 'Melekeok'
        }
    ],
    PY: [
        {
            value: 'PY-10',
            labelcz: 'Alto Parana'
        },
        {
            value: 'PY-13',
            labelcz: 'Amambay'
        },
        {
            value: 'PY-ASU',
            labelcz: 'Asuncion'
        },
        {
            value: 'PY-19',
            labelcz: 'Boqueron'
        },
        {
            value: 'PY-5',
            labelcz: 'Caaguazu'
        },
        {
            value: 'PY-6',
            labelcz: 'Caazapa'
        },
        {
            value: 'PY-14',
            labelcz: 'Canindeyu'
        },
        {
            value: 'PY-11',
            labelcz: 'Central'
        },
        {
            value: 'PY-1',
            labelcz: 'Concepcion'
        },
        {
            value: 'PY-3',
            labelcz: 'Cordillera'
        },
        {
            value: 'PY-4',
            labelcz: 'Guaira'
        },
        {
            value: 'PY-7',
            labelcz: 'Itapua'
        },
        {
            value: 'PY-8',
            labelcz: 'Misiones'
        },
        {
            value: 'PY-12',
            labelcz: 'Neembucu'
        },
        {
            value: 'PY-9',
            labelcz: 'Paraguari'
        },
        {
            value: 'PY-15',
            labelcz: 'Presidente Hayes'
        },
        {
            value: 'PY-2',
            labelcz: 'San Pedro'
        }
    ],
    QA: [
        {
            value: 'QA-DA',
            labelcz: 'Ad Dawhah'
        },
        {
            value: 'QA-KH',
            labelcz: 'Al Khawr wa adh Dhakhirah'
        },
        {
            value: 'QA-WA',
            labelcz: 'Al Wakrah'
        },
        {
            value: 'QA-RA',
            labelcz: 'Ar Rayyan'
        },
        {
            value: 'QA-MS',
            labelcz: 'Ash Shamal'
        },
        {
            value: 'QA-ZA',
            labelcz: "Az Za'ayin"
        },
        {
            value: 'QA-US',
            labelcz: 'Umm Salal'
        }
    ],
    RE: [
        {
            value: '-',
            labelcz: 'Reunion'
        }
    ],
    RW: [
        {
            value: 'RW-02',
            labelcz: 'Est'
        },
        {
            value: 'RW-03',
            labelcz: 'Nord'
        },
        {
            value: 'RW-04',
            labelcz: 'Ouest'
        },
        {
            value: 'RW-05',
            labelcz: 'Sud'
        },
        {
            value: 'RW-01',
            labelcz: 'Ville de Kigali'
        }
    ],
    SA: [
        {
            value: 'SA-14',
            labelcz: "'Asir"
        },
        {
            value: 'SA-11',
            labelcz: 'Al Bahah'
        },
        {
            value: 'SA-08',
            labelcz: 'Al Hudud ash Shamaliyah'
        },
        {
            value: 'SA-12',
            labelcz: 'Al Jawf'
        },
        {
            value: 'SA-03',
            labelcz: 'Al Madinah al Munawwarah'
        },
        {
            value: 'SA-05',
            labelcz: 'Al Qasim'
        },
        {
            value: 'SA-01',
            labelcz: 'Ar Riyad'
        },
        {
            value: 'SA-04',
            labelcz: 'Ash Sharqiyah'
        },
        {
            value: 'SA-06',
            labelcz: "Ha'il"
        },
        {
            value: 'SA-09',
            labelcz: 'Jazan'
        },
        {
            value: 'SA-02',
            labelcz: 'Makkah al Mukarramah'
        },
        {
            value: 'SA-10',
            labelcz: 'Najran'
        },
        {
            value: 'SA-07',
            labelcz: 'Tabuk'
        }
    ],
    SB: [
        {
            value: 'SB-CH',
            labelcz: 'Choiseul'
        },
        {
            value: 'SB-GU',
            labelcz: 'Guadalcanal'
        },
        {
            value: 'SB-WE',
            labelcz: 'Western'
        }
    ],
    SC: [
        {
            value: 'SC-02',
            labelcz: 'Anse Boileau'
        },
        {
            value: 'SC-05',
            labelcz: 'Anse Royale'
        },
        {
            value: 'SC-01',
            labelcz: 'Anse aux Pins'
        },
        {
            value: 'SC-06',
            labelcz: 'Baie Lazare'
        },
        {
            value: 'SC-07',
            labelcz: 'Baie Sainte Anne'
        },
        {
            value: 'SC-08',
            labelcz: 'Beau Vallon'
        },
        {
            value: 'SC-10',
            labelcz: 'Bel Ombre'
        },
        {
            value: 'SC-11',
            labelcz: 'Cascade'
        },
        {
            value: 'SC-16',
            labelcz: 'English River'
        },
        {
            value: 'SC-13',
            labelcz: 'Grand Anse Mahe'
        },
        {
            value: 'SC-14',
            labelcz: 'Grand Anse Praslin'
        },
        {
            value: 'SC-15',
            labelcz: 'La Digue'
        },
        {
            value: 'SC-20',
            labelcz: 'Pointe Larue'
        },
        {
            value: 'SC-23',
            labelcz: 'Takamaka'
        }
    ],
    SD: [
        {
            value: 'SD-NB',
            labelcz: 'Blue Nile'
        },
        {
            value: 'SD-DC',
            labelcz: 'Central Darfur'
        },
        {
            value: 'SD-GD',
            labelcz: 'Gedaref'
        },
        {
            value: 'SD-GZ',
            labelcz: 'Gezira'
        },
        {
            value: 'SD-KA',
            labelcz: 'Kassala'
        },
        {
            value: 'SD-KH',
            labelcz: 'Khartoum'
        },
        {
            value: 'SD-DN',
            labelcz: 'North Darfur'
        },
        {
            value: 'SD-KN',
            labelcz: 'North Kordofan'
        },
        {
            value: 'SD-NO',
            labelcz: 'Northern'
        },
        {
            value: 'SD-RS',
            labelcz: 'Red Sea'
        },
        {
            value: 'SD-NR',
            labelcz: 'River Nile'
        },
        {
            value: 'SD-SI',
            labelcz: 'Sennar'
        },
        {
            value: 'SD-DS',
            labelcz: 'South Darfur'
        },
        {
            value: 'SD-KS',
            labelcz: 'South Kordofan'
        },
        {
            value: 'SD-DW',
            labelcz: 'West Darfur'
        },
        {
            value: 'SD-GK',
            labelcz: 'West Kordofan'
        },
        {
            value: 'SD-NW',
            labelcz: 'White Nile'
        }
    ],

    SG: [
        {
            value: '-',
            labelcz: 'Singapore'
        }
    ],

    SJ: [
        {
            value: '-',
            labelcz: 'Svalbard and Jan Mayen'
        }
    ],

    SL: [
        {
            value: 'SL-E',
            labelcz: 'Eastern'
        },
        {
            value: 'SL-NW',
            labelcz: 'North Western'
        },
        {
            value: 'SL-N',
            labelcz: 'Northern'
        },
        {
            value: 'SL-S',
            labelcz: 'Southern'
        },
        {
            value: 'SL-W',
            labelcz: 'Western Area'
        }
    ],
    SM: [
        {
            value: 'SM-02',
            labelcz: 'Chiesanuova'
        },
        {
            value: 'SM-07',
            labelcz: 'Citta di San Marino'
        },
        {
            value: 'SM-04',
            labelcz: 'Faetano'
        },
        {
            value: 'SM-09',
            labelcz: 'Serravalle'
        }
    ],
    SN: [
        {
            value: 'SN-DK',
            labelcz: 'Dakar'
        },
        {
            value: 'SN-DB',
            labelcz: 'Diourbel'
        },
        {
            value: 'SN-FK',
            labelcz: 'Fatick'
        },
        {
            value: 'SN-KA',
            labelcz: 'Kaffrine'
        },
        {
            value: 'SN-KL',
            labelcz: 'Kaolack'
        },
        {
            value: 'SN-KE',
            labelcz: 'Kedougou'
        },
        {
            value: 'SN-KD',
            labelcz: 'Kolda'
        },
        {
            value: 'SN-LG',
            labelcz: 'Louga'
        },
        {
            value: 'SN-MT',
            labelcz: 'Matam'
        },
        {
            value: 'SN-SL',
            labelcz: 'Saint-Louis'
        },
        {
            value: 'SN-SE',
            labelcz: 'Sedhiou'
        },
        {
            value: 'SN-TC',
            labelcz: 'Tambacounda'
        },
        {
            value: 'SN-TH',
            labelcz: 'Thies'
        },
        {
            value: 'SN-ZG',
            labelcz: 'Ziguinchor'
        }
    ],
    SO: [
        {
            value: 'SO-AW',
            labelcz: 'Awdal'
        },
        {
            value: 'SO-BN',
            labelcz: 'Banaadir'
        },
        {
            value: 'SO-BR',
            labelcz: 'Bari'
        },
        {
            value: 'SO-BY',
            labelcz: 'Bay'
        },
        {
            value: 'SO-GA',
            labelcz: 'Galguduud'
        },
        {
            value: 'SO-GE',
            labelcz: 'Gedo'
        },
        {
            value: 'SO-HI',
            labelcz: 'Hiiraan'
        },
        {
            value: 'SO-JH',
            labelcz: 'Jubbada Hoose'
        },
        {
            value: 'SO-MU',
            labelcz: 'Mudug'
        },
        {
            value: 'SO-NU',
            labelcz: 'Nugaal'
        },
        {
            value: 'SO-SO',
            labelcz: 'Sool'
        },
        {
            value: 'SO-TO',
            labelcz: 'Togdheer'
        },
        {
            value: 'SO-WO',
            labelcz: 'Woqooyi Galbeed'
        }
    ],
    SR: [
        {
            value: 'SR-BR',
            labelcz: 'Brokopondo'
        },
        {
            value: 'SR-CM',
            labelcz: 'Commewijne'
        },
        {
            value: 'SR-CR',
            labelcz: 'Coronie'
        },
        {
            value: 'SR-NI',
            labelcz: 'Nickerie'
        },
        {
            value: 'SR-PR',
            labelcz: 'Para'
        },
        {
            value: 'SR-PM',
            labelcz: 'Paramaribo'
        },
        {
            value: 'SR-SA',
            labelcz: 'Saramacca'
        },
        {
            value: 'SR-SI',
            labelcz: 'Sipaliwini'
        },
        {
            value: 'SR-WA',
            labelcz: 'Wanica'
        }
    ],
    SS: [
        {
            value: 'SS-EC',
            labelcz: 'Central Equatoria'
        },
        {
            value: 'SS-EE',
            labelcz: 'Eastern Equatoria'
        },
        {
            value: 'SS-BN',
            labelcz: 'Northern Bahr el Ghazal'
        },
        {
            value: 'SS-UY',
            labelcz: 'Unity'
        },
        {
            value: 'SS-NU',
            labelcz: 'Upper Nile'
        },
        {
            value: 'SS-EW',
            labelcz: 'Western Equatoria'
        }
    ],
    ST: [
        {
            value: 'ST-01',
            labelcz: 'Agua Grande'
        }
    ],
    SV: [
        {
            value: 'SV-AH',
            labelcz: 'Ahuachapan'
        },
        {
            value: 'SV-CA',
            labelcz: 'Cabanas'
        },
        {
            value: 'SV-CH',
            labelcz: 'Chalatenango'
        },
        {
            value: 'SV-CU',
            labelcz: 'Cuscatlan'
        },
        {
            value: 'SV-LI',
            labelcz: 'La Libertad'
        },
        {
            value: 'SV-PA',
            labelcz: 'La Paz'
        },
        {
            value: 'SV-UN',
            labelcz: 'La Union'
        },
        {
            value: 'SV-MO',
            labelcz: 'Morazan'
        },
        {
            value: 'SV-SM',
            labelcz: 'San Miguel'
        },
        {
            value: 'SV-SS',
            labelcz: 'San Salvador'
        },
        {
            value: 'SV-SV',
            labelcz: 'San Vicente'
        },
        {
            value: 'SV-SA',
            labelcz: 'Santa Ana'
        },
        {
            value: 'SV-SO',
            labelcz: 'Sonsonate'
        },
        {
            value: 'SV-US',
            labelcz: 'Usulutan'
        }
    ],
    SX: [
        {
            value: '-',
            labelcz: 'Sint Maarten (Dutch Part)'
        }
    ],
    SY: [
        {
            value: 'SY-HA',
            labelcz: 'Al Hasakah'
        },
        {
            value: 'SY-LA',
            labelcz: 'Al Ladhiqiyah'
        },
        {
            value: 'SY-QU',
            labelcz: 'Al Qunaytirah'
        },
        {
            value: 'SY-RA',
            labelcz: 'Ar Raqqah'
        },
        {
            value: 'SY-SU',
            labelcz: "As Suwayda'"
        },
        {
            value: 'SY-DR',
            labelcz: "Dar'a"
        },
        {
            value: 'SY-DY',
            labelcz: 'Dayr az Zawr'
        },
        {
            value: 'SY-DI',
            labelcz: 'Dimashq'
        },
        {
            value: 'SY-HL',
            labelcz: 'Halab'
        },
        {
            value: 'SY-HM',
            labelcz: 'Hamah'
        },
        {
            value: 'SY-HI',
            labelcz: 'Hims'
        },
        {
            value: 'SY-ID',
            labelcz: 'Idlib'
        },
        {
            value: 'SY-RD',
            labelcz: 'Rif Dimashq'
        },
        {
            value: 'SY-TA',
            labelcz: 'Tartus'
        }
    ],
    SZ: [
        {
            value: 'SZ-HH',
            labelcz: 'Hhohho'
        },
        {
            value: 'SZ-LU',
            labelcz: 'Lubombo'
        },
        {
            value: 'SZ-MA',
            labelcz: 'Manzini'
        }
    ],
    TC: [
        {
            value: '-',
            labelcz: 'Turks and Caicos Islands'
        }
    ],
    TD: [
        {
            value: 'TD-BG',
            labelcz: 'Bahr el Ghazal'
        },
        {
            value: 'TD-CB',
            labelcz: 'Chari-Baguirmi'
        },
        {
            value: 'TD-GR',
            labelcz: 'Guera'
        },
        {
            value: 'TD-LC',
            labelcz: 'Lac'
        },
        {
            value: 'TD-LR',
            labelcz: 'Logone-Oriental'
        },
        {
            value: 'TD-OD',
            labelcz: 'Ouaddai'
        },
        {
            value: 'TD-ND',
            labelcz: 'Ville de Ndjamena'
        }
    ],
    TF: [
        {
            value: '-',
            labelcz: 'French Southern Territories'
        }
    ],
    TG: [
        {
            value: 'TG-C',
            labelcz: 'Centrale'
        },
        {
            value: 'TG-K',
            labelcz: 'Kara'
        },
        {
            value: 'TG-M',
            labelcz: 'Maritime'
        },
        {
            value: 'TG-P',
            labelcz: 'Plateaux'
        },
        {
            value: 'TG-S',
            labelcz: 'Savanes'
        }
    ],
    TH: [
        {
            value: 'TH-37',
            labelcz: 'Amnat Charoen'
        },
        {
            value: 'TH-15',
            labelcz: 'Ang Thong'
        },
        {
            value: 'TH-38',
            labelcz: 'Bueng Kan'
        },
        {
            value: 'TH-31',
            labelcz: 'Buri Ram'
        },
        {
            value: 'TH-24',
            labelcz: 'Chachoengsao'
        },
        {
            value: 'TH-18',
            labelcz: 'Chai Nat'
        },
        {
            value: 'TH-36',
            labelcz: 'Chaiyaphum'
        },
        {
            value: 'TH-22',
            labelcz: 'Chanthaburi'
        },
        {
            value: 'TH-50',
            labelcz: 'Chiang Mai'
        },
        {
            value: 'TH-57',
            labelcz: 'Chiang Rai'
        },
        {
            value: 'TH-20',
            labelcz: 'Chon Buri'
        },
        {
            value: 'TH-86',
            labelcz: 'Chumphon'
        },
        {
            value: 'TH-46',
            labelcz: 'Kalasin'
        },
        {
            value: 'TH-62',
            labelcz: 'Kamphaeng Phet'
        },
        {
            value: 'TH-71',
            labelcz: 'Kanchanaburi'
        },
        {
            value: 'TH-40',
            labelcz: 'Khon Kaen'
        },
        {
            value: 'TH-81',
            labelcz: 'Krabi'
        },
        {
            value: 'TH-10',
            labelcz: 'Krung Thep Maha Nakhon'
        },
        {
            value: 'TH-52',
            labelcz: 'Lampang'
        },
        {
            value: 'TH-51',
            labelcz: 'Lamphun'
        },
        {
            value: 'TH-42',
            labelcz: 'Loei'
        },
        {
            value: 'TH-16',
            labelcz: 'Lop Buri'
        },
        {
            value: 'TH-58',
            labelcz: 'Mae Hong Son'
        },
        {
            value: 'TH-44',
            labelcz: 'Maha Sarakham'
        },
        {
            value: 'TH-49',
            labelcz: 'Mukdahan'
        },
        {
            value: 'TH-26',
            labelcz: 'Nakhon Nayok'
        },
        {
            value: 'TH-73',
            labelcz: 'Nakhon Pathom'
        },
        {
            value: 'TH-48',
            labelcz: 'Nakhon Phanom'
        },
        {
            value: 'TH-30',
            labelcz: 'Nakhon Ratchasima'
        },
        {
            value: 'TH-60',
            labelcz: 'Nakhon Sawan'
        },
        {
            value: 'TH-80',
            labelcz: 'Nakhon Si Thammarat'
        },
        {
            value: 'TH-55',
            labelcz: 'Nan'
        },
        {
            value: 'TH-96',
            labelcz: 'Narathiwat'
        },
        {
            value: 'TH-39',
            labelcz: 'Nong Bua Lam Phu'
        },
        {
            value: 'TH-43',
            labelcz: 'Nong Khai'
        },
        {
            value: 'TH-12',
            labelcz: 'Nonthaburi'
        },
        {
            value: 'TH-13',
            labelcz: 'Pathum Thani'
        },
        {
            value: 'TH-94',
            labelcz: 'Pattani'
        },
        {
            value: 'TH-82',
            labelcz: 'Phangnga'
        },
        {
            value: 'TH-93',
            labelcz: 'Phatthalung'
        },
        {
            value: 'TH-56',
            labelcz: 'Phayao'
        },
        {
            value: 'TH-67',
            labelcz: 'Phetchabun'
        },
        {
            value: 'TH-76',
            labelcz: 'Phetchaburi'
        },
        {
            value: 'TH-66',
            labelcz: 'Phichit'
        },
        {
            value: 'TH-65',
            labelcz: 'Phitsanulok'
        },
        {
            value: 'TH-14',
            labelcz: 'Phra Nakhon Si Ayutthaya'
        },
        {
            value: 'TH-54',
            labelcz: 'Phrae'
        },
        {
            value: 'TH-83',
            labelcz: 'Phuket'
        },
        {
            value: 'TH-25',
            labelcz: 'Prachin Buri'
        },
        {
            value: 'TH-77',
            labelcz: 'Prachuap Khiri Khan'
        },
        {
            value: 'TH-85',
            labelcz: 'Ranong'
        },
        {
            value: 'TH-70',
            labelcz: 'Ratchaburi'
        },
        {
            value: 'TH-21',
            labelcz: 'Rayong'
        },
        {
            value: 'TH-45',
            labelcz: 'Roi Et'
        },
        {
            value: 'TH-27',
            labelcz: 'Sa Kaeo'
        },
        {
            value: 'TH-47',
            labelcz: 'Sakon Nakhon'
        },
        {
            value: 'TH-11',
            labelcz: 'Samut Prakan'
        },
        {
            value: 'TH-74',
            labelcz: 'Samut Sakhon'
        },
        {
            value: 'TH-75',
            labelcz: 'Samut Songkhram'
        },
        {
            value: 'TH-19',
            labelcz: 'Saraburi'
        },
        {
            value: 'TH-91',
            labelcz: 'Satun'
        },
        {
            value: 'TH-33',
            labelcz: 'Si Sa Ket'
        },
        {
            value: 'TH-17',
            labelcz: 'Sing Buri'
        },
        {
            value: 'TH-90',
            labelcz: 'Songkhla'
        },
        {
            value: 'TH-64',
            labelcz: 'Sukhothai'
        },
        {
            value: 'TH-72',
            labelcz: 'Suphan Buri'
        },
        {
            value: 'TH-84',
            labelcz: 'Surat Thani'
        },
        {
            value: 'TH-32',
            labelcz: 'Surin'
        },
        {
            value: 'TH-63',
            labelcz: 'Tak'
        },
        {
            value: 'TH-92',
            labelcz: 'Trang'
        },
        {
            value: 'TH-23',
            labelcz: 'Trat'
        },
        {
            value: 'TH-34',
            labelcz: 'Ubon Ratchathani'
        },
        {
            value: 'TH-41',
            labelcz: 'Udon Thani'
        },
        {
            value: 'TH-61',
            labelcz: 'Uthai Thani'
        },
        {
            value: 'TH-53',
            labelcz: 'Uttaradit'
        },
        {
            value: 'TH-95',
            labelcz: 'Yala'
        },
        {
            value: 'TH-35',
            labelcz: 'Yasothon'
        }
    ],
    TJ: [
        {
            value: 'TJ-DU',
            labelcz: 'Dushanbe'
        },
        {
            value: 'TJ-KT',
            labelcz: 'Khatlon'
        },
        {
            value: 'TJ-GB',
            labelcz: 'Kuhistoni Badakhshon'
        },
        {
            value: 'TJ-RA',
            labelcz: 'Nohiyahoi Tobei Jumhuri'
        },
        {
            value: 'TJ-SU',
            labelcz: 'Sughd'
        }
    ],
    TK: [
        {
            value: '-',
            labelcz: 'Tokelau'
        }
    ],
    TL: [
        {
            value: 'TL-AL',
            labelcz: 'Aileu'
        },
        {
            value: 'TL-AN',
            labelcz: 'Ainaro'
        },
        {
            value: 'TL-CO',
            labelcz: 'Cova Lima'
        },
        {
            value: 'TL-DI',
            labelcz: 'Dili'
        },
        {
            value: 'TL-LI',
            labelcz: 'Liquica'
        }
    ],
    TM: [
        {
            value: 'TM-A',
            labelcz: 'Ahal'
        },
        {
            value: 'TM-B',
            labelcz: 'Balkan'
        },
        {
            value: 'TM-D',
            labelcz: 'Dasoguz'
        },
        {
            value: 'TM-L',
            labelcz: 'Lebap'
        },
        {
            value: 'TM-M',
            labelcz: 'Mary'
        }
    ],
    TN: [
        {
            value: 'TN-31',
            labelcz: 'Beja'
        },
        {
            value: 'TN-13',
            labelcz: 'Ben Arous'
        },
        {
            value: 'TN-23',
            labelcz: 'Bizerte'
        },
        {
            value: 'TN-81',
            labelcz: 'Gabes'
        },
        {
            value: 'TN-71',
            labelcz: 'Gafsa'
        },
        {
            value: 'TN-32',
            labelcz: 'Jendouba'
        },
        {
            value: 'TN-41',
            labelcz: 'Kairouan'
        },
        {
            value: 'TN-42',
            labelcz: 'Kasserine'
        },
        {
            value: 'TN-73',
            labelcz: 'Kebili'
        },
        {
            value: 'TN-12',
            labelcz: "L'Ariana"
        },
        {
            value: 'TN-14',
            labelcz: 'La Manouba'
        },
        {
            value: 'TN-33',
            labelcz: 'Le Kef'
        },
        {
            value: 'TN-53',
            labelcz: 'Mahdia'
        },
        {
            value: 'TN-82',
            labelcz: 'Medenine'
        },
        {
            value: 'TN-52',
            labelcz: 'Monastir'
        },
        {
            value: 'TN-21',
            labelcz: 'Nabeul'
        },
        {
            value: 'TN-61',
            labelcz: 'Sfax'
        },
        {
            value: 'TN-43',
            labelcz: 'Sidi Bouzid'
        },
        {
            value: 'TN-34',
            labelcz: 'Siliana'
        },
        {
            value: 'TN-51',
            labelcz: 'Sousse'
        },
        {
            value: 'TN-83',
            labelcz: 'Tataouine'
        },
        {
            value: 'TN-72',
            labelcz: 'Tozeur'
        },
        {
            value: 'TN-11',
            labelcz: 'Tunis'
        },
        {
            value: 'TN-22',
            labelcz: 'Zaghouan'
        }
    ],
    TO: [
        {
            value: 'TO-01',
            labelcz: "'Eua"
        },
        {
            value: 'TO-02',
            labelcz: "Ha'apai"
        },
        {
            value: 'TO-03',
            labelcz: 'Niuas'
        },
        {
            value: 'TO-04',
            labelcz: 'Tongatapu'
        },
        {
            value: 'TO-05',
            labelcz: "Vava'u"
        }
    ],
    TR: [
        {
            value: 'TR-01',
            labelcz: 'Adana'
        },
        {
            value: 'TR-02',
            labelcz: 'Adiyaman'
        },
        {
            value: 'TR-03',
            labelcz: 'Afyonkarahisar'
        },
        {
            value: 'TR-04',
            labelcz: 'Agri'
        },
        {
            value: 'TR-68',
            labelcz: 'Aksaray'
        },
        {
            value: 'TR-05',
            labelcz: 'Amasya'
        },
        {
            value: 'TR-06',
            labelcz: 'Ankara'
        },
        {
            value: 'TR-07',
            labelcz: 'Antalya'
        },
        {
            value: 'TR-75',
            labelcz: 'Ardahan'
        },
        {
            value: 'TR-08',
            labelcz: 'Artvin'
        },
        {
            value: 'TR-09',
            labelcz: 'Aydin'
        },
        {
            value: 'TR-10',
            labelcz: 'Balikesir'
        },
        {
            value: 'TR-74',
            labelcz: 'Bartin'
        },
        {
            value: 'TR-72',
            labelcz: 'Batman'
        },
        {
            value: 'TR-69',
            labelcz: 'Bayburt'
        },
        {
            value: 'TR-11',
            labelcz: 'Bilecik'
        },
        {
            value: 'TR-12',
            labelcz: 'Bingol'
        },
        {
            value: 'TR-13',
            labelcz: 'Bitlis'
        },
        {
            value: 'TR-14',
            labelcz: 'Bolu'
        },
        {
            value: 'TR-15',
            labelcz: 'Burdur'
        },
        {
            value: 'TR-16',
            labelcz: 'Bursa'
        },
        {
            value: 'TR-17',
            labelcz: 'Canakkale'
        },
        {
            value: 'TR-18',
            labelcz: 'Cankiri'
        },
        {
            value: 'TR-19',
            labelcz: 'Corum'
        },
        {
            value: 'TR-20',
            labelcz: 'Denizli'
        },
        {
            value: 'TR-21',
            labelcz: 'Diyarbakir'
        },
        {
            value: 'TR-81',
            labelcz: 'Duzce'
        },
        {
            value: 'TR-22',
            labelcz: 'Edirne'
        },
        {
            value: 'TR-23',
            labelcz: 'Elazig'
        },
        {
            value: 'TR-24',
            labelcz: 'Erzincan'
        },
        {
            value: 'TR-25',
            labelcz: 'Erzurum'
        },
        {
            value: 'TR-26',
            labelcz: 'Eskisehir'
        },
        {
            value: 'TR-27',
            labelcz: 'Gaziantep'
        },
        {
            value: 'TR-28',
            labelcz: 'Giresun'
        },
        {
            value: 'TR-29',
            labelcz: 'Gumushane'
        },
        {
            value: 'TR-30',
            labelcz: 'Hakkari'
        },
        {
            value: 'TR-31',
            labelcz: 'Hatay'
        },
        {
            value: 'TR-76',
            labelcz: 'Igdir'
        },
        {
            value: 'TR-32',
            labelcz: 'Isparta'
        },
        {
            value: 'TR-34',
            labelcz: 'Istanbul'
        },
        {
            value: 'TR-35',
            labelcz: 'Izmir'
        },
        {
            value: 'TR-46',
            labelcz: 'Kahramanmaras'
        },
        {
            value: 'TR-78',
            labelcz: 'Karabuk'
        },
        {
            value: 'TR-70',
            labelcz: 'Karaman'
        },
        {
            value: 'TR-36',
            labelcz: 'Kars'
        },
        {
            value: 'TR-37',
            labelcz: 'Kastamonu'
        },
        {
            value: 'TR-38',
            labelcz: 'Kayseri'
        },
        {
            value: 'TR-79',
            labelcz: 'Kilis'
        },
        {
            value: 'TR-71',
            labelcz: 'Kirikkale'
        },
        {
            value: 'TR-39',
            labelcz: 'Kirklareli'
        },
        {
            value: 'TR-40',
            labelcz: 'Kirsehir'
        },
        {
            value: 'TR-41',
            labelcz: 'Kocaeli'
        },
        {
            value: 'TR-42',
            labelcz: 'Konya'
        },
        {
            value: 'TR-43',
            labelcz: 'Kutahya'
        },
        {
            value: 'TR-44',
            labelcz: 'Malatya'
        },
        {
            value: 'TR-45',
            labelcz: 'Manisa'
        },
        {
            value: 'TR-47',
            labelcz: 'Mardin'
        },
        {
            value: 'TR-33',
            labelcz: 'Mersin'
        },
        {
            value: 'TR-48',
            labelcz: 'Mugla'
        },
        {
            value: 'TR-49',
            labelcz: 'Mus'
        },
        {
            value: 'TR-50',
            labelcz: 'Nevsehir'
        },
        {
            value: 'TR-51',
            labelcz: 'Nigde'
        },
        {
            value: 'TR-52',
            labelcz: 'Ordu'
        },
        {
            value: 'TR-80',
            labelcz: 'Osmaniye'
        },
        {
            value: 'TR-53',
            labelcz: 'Rize'
        },
        {
            value: 'TR-54',
            labelcz: 'Sakarya'
        },
        {
            value: 'TR-55',
            labelcz: 'Samsun'
        },
        {
            value: 'TR-63',
            labelcz: 'Sanliurfa'
        },
        {
            value: 'TR-56',
            labelcz: 'Siirt'
        },
        {
            value: 'TR-57',
            labelcz: 'Sinop'
        },
        {
            value: 'TR-73',
            labelcz: 'Sirnak'
        },
        {
            value: 'TR-58',
            labelcz: 'Sivas'
        },
        {
            value: 'TR-59',
            labelcz: 'Tekirdag'
        },
        {
            value: 'TR-60',
            labelcz: 'Tokat'
        },
        {
            value: 'TR-61',
            labelcz: 'Trabzon'
        },
        {
            value: 'TR-62',
            labelcz: 'Tunceli'
        },
        {
            value: 'TR-64',
            labelcz: 'Usak'
        },
        {
            value: 'TR-65',
            labelcz: 'Van'
        },
        {
            value: 'TR-77',
            labelcz: 'Yalova'
        },
        {
            value: 'TR-66',
            labelcz: 'Yozgat'
        },
        {
            value: 'TR-67',
            labelcz: 'Zonguldak'
        }
    ],
    TT: [
        {
            value: 'TT-ARI',
            labelcz: 'Arima'
        },
        {
            value: 'TT-CHA',
            labelcz: 'Chaguanas'
        },
        {
            value: 'TT-CTT',
            labelcz: 'Couva-Tabaquite-Talparo'
        },
        {
            value: 'TT-DMN',
            labelcz: 'Diego Martin'
        },
        {
            value: 'TT-MRC',
            labelcz: 'Mayaro-Rio Claro'
        },
        {
            value: 'TT-PED',
            labelcz: 'Penal-Debe'
        },
        {
            value: 'TT-PTF',
            labelcz: 'Point Fortin'
        },
        {
            value: 'TT-POS',
            labelcz: 'Port of Spain'
        },
        {
            value: 'TT-PRT',
            labelcz: 'Princes Town'
        },
        {
            value: 'TT-SFO',
            labelcz: 'San Fernando'
        },
        {
            value: 'TT-SJL',
            labelcz: 'San Juan-Laventille'
        },
        {
            value: 'TT-SGE',
            labelcz: 'Sangre Grande'
        },
        {
            value: 'TT-SIP',
            labelcz: 'Siparia'
        },
        {
            value: 'TT-TOB',
            labelcz: 'Tobago'
        },
        {
            value: 'TT-TUP',
            labelcz: 'Tunapuna-Piarco'
        }
    ],
    TV: [
        {
            value: 'TV-FUN',
            labelcz: 'Funafuti'
        }
    ],

    TZ: [
        {
            value: 'TZ-01',
            labelcz: 'Arusha'
        },
        {
            value: 'TZ-02',
            labelcz: 'Dar es Salaam'
        },
        {
            value: 'TZ-03',
            labelcz: 'Dodoma'
        },
        {
            value: 'TZ-27',
            labelcz: 'Geita'
        },
        {
            value: 'TZ-04',
            labelcz: 'Iringa'
        },
        {
            value: 'TZ-05',
            labelcz: 'Kagera'
        },
        {
            value: 'TZ-06',
            labelcz: 'Kaskazini Pemba'
        },
        {
            value: 'TZ-07',
            labelcz: 'Kaskazini Unguja'
        },
        {
            value: 'TZ-28',
            labelcz: 'Katavi'
        },
        {
            value: 'TZ-08',
            labelcz: 'Kigoma'
        },
        {
            value: 'TZ-09',
            labelcz: 'Kilimanjaro'
        },
        {
            value: 'TZ-10',
            labelcz: 'Kusini Pemba'
        },
        {
            value: 'TZ-11',
            labelcz: 'Kusini Unguja'
        },
        {
            value: 'TZ-12',
            labelcz: 'Lindi'
        },
        {
            value: 'TZ-26',
            labelcz: 'Manyara'
        },
        {
            value: 'TZ-13',
            labelcz: 'Mara'
        },
        {
            value: 'TZ-14',
            labelcz: 'Mbeya'
        },
        {
            value: 'TZ-15',
            labelcz: 'Mjini Magharibi'
        },
        {
            value: 'TZ-16',
            labelcz: 'Morogoro'
        },
        {
            value: 'TZ-17',
            labelcz: 'Mtwara'
        },
        {
            value: 'TZ-18',
            labelcz: 'Mwanza'
        },
        {
            value: 'TZ-29',
            labelcz: 'Njombe'
        },
        {
            value: 'TZ-19',
            labelcz: 'Pwani'
        },
        {
            value: 'TZ-20',
            labelcz: 'Rukwa'
        },
        {
            value: 'TZ-21',
            labelcz: 'Ruvuma'
        },
        {
            value: 'TZ-22',
            labelcz: 'Shinyanga'
        },
        {
            value: 'TZ-30',
            labelcz: 'Simiyu'
        },
        {
            value: 'TZ-23',
            labelcz: 'Singida'
        },
        {
            value: 'TZ-31',
            labelcz: 'Songwe'
        },
        {
            value: 'TZ-24',
            labelcz: 'Tabora'
        },
        {
            value: 'TZ-25',
            labelcz: 'Tanga'
        }
    ],
    UA: [
        {
            value: 'UA-43',
            labelcz: 'Avtonomna Respublika Krym'
        },
        {
            value: 'UA-71',
            labelcz: 'Cherkaska oblast'
        },
        {
            value: 'UA-74',
            labelcz: 'Chernihivska oblast'
        },
        {
            value: 'UA-77',
            labelcz: 'Chernivetska oblast'
        },
        {
            value: 'UA-12',
            labelcz: 'Dnipropetrovska oblast'
        },
        {
            value: 'UA-14',
            labelcz: 'Donetska oblast'
        },
        {
            value: 'UA-26',
            labelcz: 'Ivano-Frankivska oblast'
        },
        {
            value: 'UA-63',
            labelcz: 'Kharkivska oblast'
        },
        {
            value: 'UA-65',
            labelcz: 'Khersonska oblast'
        },
        {
            value: 'UA-68',
            labelcz: 'Khmelnytska oblast'
        },
        {
            value: 'UA-35',
            labelcz: 'Kirovohradska oblast'
        },
        {
            value: 'UA-30',
            labelcz: 'Kyiv'
        },
        {
            value: 'UA-32',
            labelcz: 'Kyivska oblast'
        },
        {
            value: 'UA-09',
            labelcz: 'Luhanska oblast'
        },
        {
            value: 'UA-46',
            labelcz: 'Lvivska oblast'
        },
        {
            value: 'UA-48',
            labelcz: 'Mykolaivska oblast'
        },
        {
            value: 'UA-51',
            labelcz: 'Odeska oblast'
        },
        {
            value: 'UA-53',
            labelcz: 'Poltavska oblast'
        },
        {
            value: 'UA-56',
            labelcz: 'Rivnenska oblast'
        },
        {
            value: 'UA-40',
            labelcz: 'Sevastopol'
        },
        {
            value: 'UA-59',
            labelcz: 'Sumska oblast'
        },
        {
            value: 'UA-61',
            labelcz: 'Ternopilska oblast'
        },
        {
            value: 'UA-05',
            labelcz: 'Vinnytska oblast'
        },
        {
            value: 'UA-07',
            labelcz: 'Volynska oblast'
        },
        {
            value: 'UA-21',
            labelcz: 'Zakarpatska oblast'
        },
        {
            value: 'UA-23',
            labelcz: 'Zaporizka oblast'
        },
        {
            value: 'UA-18',
            labelcz: 'Zhytomyrska oblast'
        }
    ],
    UG: [
        {
            value: 'UG-314',
            labelcz: 'Abim'
        },
        {
            value: 'UG-301',
            labelcz: 'Adjumani'
        },
        {
            value: 'UG-322',
            labelcz: 'Agago'
        },
        {
            value: 'UG-323',
            labelcz: 'Alebtong'
        },
        {
            value: 'UG-302',
            labelcz: 'Apac'
        },
        {
            value: 'UG-303',
            labelcz: 'Arua'
        },
        {
            value: 'UG-218',
            labelcz: 'Bududa'
        },
        {
            value: 'UG-201',
            labelcz: 'Bugiri'
        },
        {
            value: 'UG-420',
            labelcz: 'Buhweju'
        },
        {
            value: 'UG-117',
            labelcz: 'Buikwe'
        },
        {
            value: 'UG-219',
            labelcz: 'Bukedea'
        },
        {
            value: 'UG-118',
            labelcz: 'Bukomansibi'
        },
        {
            value: 'UG-225',
            labelcz: 'Bulambuli'
        },
        {
            value: 'UG-401',
            labelcz: 'Bundibugyo'
        },
        {
            value: 'UG-402',
            labelcz: 'Bushenyi'
        },
        {
            value: 'UG-202',
            labelcz: 'Busia'
        },
        {
            value: 'UG-120',
            labelcz: 'Buvuma'
        },
        {
            value: 'UG-226',
            labelcz: 'Buyende'
        },
        {
            value: 'UG-121',
            labelcz: 'Gomba'
        },
        {
            value: 'UG-304',
            labelcz: 'Gulu'
        },
        {
            value: 'UG-403',
            labelcz: 'Hoima'
        },
        {
            value: 'UG-417',
            labelcz: 'Ibanda'
        },
        {
            value: 'UG-203',
            labelcz: 'Iganga'
        },
        {
            value: 'UG-418',
            labelcz: 'Isingiro'
        },
        {
            value: 'UG-204',
            labelcz: 'Jinja'
        },
        {
            value: 'UG-318',
            labelcz: 'Kaabong'
        },
        {
            value: 'UG-404',
            labelcz: 'Kabale'
        },
        {
            value: 'UG-405',
            labelcz: 'Kabarole'
        },
        {
            value: 'UG-213',
            labelcz: 'Kaberamaido'
        },
        {
            value: 'UG-101',
            labelcz: 'Kalangala'
        },
        {
            value: 'UG-222',
            labelcz: 'Kaliro'
        },
        {
            value: 'UG-122',
            labelcz: 'Kalungu'
        },
        {
            value: 'UG-102',
            labelcz: 'Kampala'
        },
        {
            value: 'UG-205',
            labelcz: 'Kamuli'
        },
        {
            value: 'UG-413',
            labelcz: 'Kamwenge'
        },
        {
            value: 'UG-414',
            labelcz: 'Kanungu'
        },
        {
            value: 'UG-206',
            labelcz: 'Kapchorwa'
        },
        {
            value: 'UG-406',
            labelcz: 'Kasese'
        },
        {
            value: 'UG-207',
            labelcz: 'Katakwi'
        },
        {
            value: 'UG-112',
            labelcz: 'Kayunga'
        },
        {
            value: 'UG-407',
            labelcz: 'Kibaale'
        },
        {
            value: 'UG-103',
            labelcz: 'Kiboga'
        },
        {
            value: 'UG-227',
            labelcz: 'Kibuku'
        },
        {
            value: 'UG-419',
            labelcz: 'Kiruhura'
        },
        {
            value: 'UG-421',
            labelcz: 'Kiryandongo'
        },
        {
            value: 'UG-408',
            labelcz: 'Kisoro'
        },
        {
            value: 'UG-305',
            labelcz: 'Kitgum'
        },
        {
            value: 'UG-319',
            labelcz: 'Koboko'
        },
        {
            value: 'UG-325',
            labelcz: 'Kole'
        },
        {
            value: 'UG-228',
            labelcz: 'Kween'
        },
        {
            value: 'UG-123',
            labelcz: 'Kyankwanzi'
        },
        {
            value: 'UG-422',
            labelcz: 'Kyegegwa'
        },
        {
            value: 'UG-415',
            labelcz: 'Kyenjojo'
        },
        {
            value: 'UG-326',
            labelcz: 'Lamwo'
        },
        {
            value: 'UG-307',
            labelcz: 'Lira'
        },
        {
            value: 'UG-229',
            labelcz: 'Luuka'
        },
        {
            value: 'UG-104',
            labelcz: 'Luwero'
        },
        {
            value: 'UG-124',
            labelcz: 'Lwengo'
        },
        {
            value: 'UG-114',
            labelcz: 'Lyantonde'
        },
        {
            value: 'UG-223',
            labelcz: 'Manafwa'
        },
        {
            value: 'UG-320',
            labelcz: 'Maracha'
        },
        {
            value: 'UG-105',
            labelcz: 'Masaka'
        },
        {
            value: 'UG-409',
            labelcz: 'Masindi'
        },
        {
            value: 'UG-214',
            labelcz: 'Mayuge'
        },
        {
            value: 'UG-209',
            labelcz: 'Mbale'
        },
        {
            value: 'UG-410',
            labelcz: 'Mbarara'
        },
        {
            value: 'UG-423',
            labelcz: 'Mitooma'
        },
        {
            value: 'UG-115',
            labelcz: 'Mityana'
        },
        {
            value: 'UG-308',
            labelcz: 'Moroto'
        },
        {
            value: 'UG-309',
            labelcz: 'Moyo'
        },
        {
            value: 'UG-106',
            labelcz: 'Mpigi'
        },
        {
            value: 'UG-107',
            labelcz: 'Mubende'
        },
        {
            value: 'UG-108',
            labelcz: 'Mukono'
        },
        {
            value: 'UG-311',
            labelcz: 'Nakapiripirit'
        },
        {
            value: 'UG-116',
            labelcz: 'Nakaseke'
        },
        {
            value: 'UG-109',
            labelcz: 'Nakasongola'
        },
        {
            value: 'UG-230',
            labelcz: 'Namayingo'
        },
        {
            value: 'UG-327',
            labelcz: 'Napak'
        },
        {
            value: 'UG-310',
            labelcz: 'Nebbi'
        },
        {
            value: 'UG-424',
            labelcz: 'Ntoroko'
        },
        {
            value: 'UG-411',
            labelcz: 'Ntungamo'
        },
        {
            value: 'UG-328',
            labelcz: 'Nwoya'
        },
        {
            value: 'UG-321',
            labelcz: 'Oyam'
        },
        {
            value: 'UG-312',
            labelcz: 'Pader'
        },
        {
            value: 'UG-110',
            labelcz: 'Rakai'
        },
        {
            value: 'UG-425',
            labelcz: 'Rubirizi'
        },
        {
            value: 'UG-412',
            labelcz: 'Rukungiri'
        },
        {
            value: 'UG-111',
            labelcz: 'Sembabule'
        },
        {
            value: 'UG-426',
            labelcz: 'Sheema'
        },
        {
            value: 'UG-215',
            labelcz: 'Sironko'
        },
        {
            value: 'UG-211',
            labelcz: 'Soroti'
        },
        {
            value: 'UG-212',
            labelcz: 'Tororo'
        },
        {
            value: 'UG-113',
            labelcz: 'Wakiso'
        },
        {
            value: 'UG-313',
            labelcz: 'Yumbe'
        },
        {
            value: 'UG-330',
            labelcz: 'Zombo'
        }
    ],
    UM: [
        {
            value: 'UM-95',
            labelcz: 'Palmyra Atoll'
        }
    ],

    UY: [
        {
            value: 'UY-AR',
            labelcz: 'Artigas'
        },
        {
            value: 'UY-CA',
            labelcz: 'Canelones'
        },
        {
            value: 'UY-CL',
            labelcz: 'Cerro Largo'
        },
        {
            value: 'UY-CO',
            labelcz: 'Colonia'
        },
        {
            value: 'UY-DU',
            labelcz: 'Durazno'
        },
        {
            value: 'UY-FS',
            labelcz: 'Flores'
        },
        {
            value: 'UY-FD',
            labelcz: 'Florida'
        },
        {
            value: 'UY-LA',
            labelcz: 'Lavalleja'
        },
        {
            value: 'UY-MA',
            labelcz: 'Maldonado'
        },
        {
            value: 'UY-MO',
            labelcz: 'Montevideo'
        },
        {
            value: 'UY-PA',
            labelcz: 'Paysandu'
        },
        {
            value: 'UY-RN',
            labelcz: 'Rio Negro'
        },
        {
            value: 'UY-RV',
            labelcz: 'Rivera'
        },
        {
            value: 'UY-RO',
            labelcz: 'Rocha'
        },
        {
            value: 'UY-SA',
            labelcz: 'Salto'
        },
        {
            value: 'UY-SJ',
            labelcz: 'San Jose'
        },
        {
            value: 'UY-SO',
            labelcz: 'Soriano'
        },
        {
            value: 'UY-TA',
            labelcz: 'Tacuarembo'
        },
        {
            value: 'UY-TT',
            labelcz: 'Treinta y Tres'
        }
    ],
    UZ: [
        {
            value: 'UZ-AN',
            labelcz: 'Andijon'
        },
        {
            value: 'UZ-BU',
            labelcz: 'Buxoro'
        },
        {
            value: 'UZ-FA',
            labelcz: "Farg'ona"
        },
        {
            value: 'UZ-JI',
            labelcz: 'Jizzax'
        },
        {
            value: 'UZ-NG',
            labelcz: 'Namangan'
        },
        {
            value: 'UZ-NW',
            labelcz: 'Navoiy'
        },
        {
            value: 'UZ-QA',
            labelcz: 'Qashqadaryo'
        },
        {
            value: 'UZ-QR',
            labelcz: "Qoraqalpog'iston Respublikasi"
        },
        {
            value: 'UZ-SA',
            labelcz: 'Samarqand'
        },
        {
            value: 'UZ-SI',
            labelcz: 'Sirdaryo'
        },
        {
            value: 'UZ-SU',
            labelcz: 'Surxondaryo'
        },
        {
            value: 'UZ-TK',
            labelcz: 'Toshkent'
        },
        {
            value: 'UZ-XO',
            labelcz: 'Xorazm'
        }
    ],
    VA: [
        {
            value: '-',
            labelcz: 'Vatican City'
        }
    ],
    VC: [
        {
            value: 'VC-01',
            labelcz: 'Charlotte'
        },
        {
            value: 'VC-06',
            labelcz: 'Grenadines'
        },
        {
            value: 'VC-04',
            labelcz: 'Saint George'
        },
        {
            value: 'VC-05',
            labelcz: 'Saint Patrick'
        }
    ],
    VE: [
        {
            value: 'VE-Z',
            labelcz: 'Amazonas'
        },
        {
            value: 'VE-B',
            labelcz: 'Anzoategui'
        },
        {
            value: 'VE-C',
            labelcz: 'Apure'
        },
        {
            value: 'VE-D',
            labelcz: 'Aragua'
        },
        {
            value: 'VE-E',
            labelcz: 'Barinas'
        },
        {
            value: 'VE-F',
            labelcz: 'Bolivar'
        },
        {
            value: 'VE-G',
            labelcz: 'Carabobo'
        },
        {
            value: 'VE-H',
            labelcz: 'Cojedes'
        },
        {
            value: 'VE-Y',
            labelcz: 'Delta Amacuro'
        },
        {
            value: 'VE-W',
            labelcz: 'Dependencias Federales'
        },
        {
            value: 'VE-A',
            labelcz: 'Distrito Capital'
        },
        {
            value: 'VE-I',
            labelcz: 'Falcon'
        },
        {
            value: 'VE-J',
            labelcz: 'Guarico'
        },
        {
            value: 'VE-X',
            labelcz: 'La Guaira'
        },
        {
            value: 'VE-K',
            labelcz: 'Lara'
        },
        {
            value: 'VE-L',
            labelcz: 'Merida'
        },
        {
            value: 'VE-M',
            labelcz: 'Miranda'
        },
        {
            value: 'VE-N',
            labelcz: 'Monagas'
        },
        {
            value: 'VE-O',
            labelcz: 'Nueva Esparta'
        },
        {
            value: 'VE-P',
            labelcz: 'Portuguesa'
        },
        {
            value: 'VE-R',
            labelcz: 'Sucre'
        },
        {
            value: 'VE-S',
            labelcz: 'Tachira'
        },
        {
            value: 'VE-T',
            labelcz: 'Trujillo'
        },
        {
            value: 'VE-U',
            labelcz: 'Yaracuy'
        },
        {
            value: 'VE-V',
            labelcz: 'Zulia'
        }
    ],
    VG: [
        {
            value: '-',
            labelcz: 'Virgin Islands, British'
        }
    ],
    VI: [
        {
            value: '-',
            labelcz: 'Virgin Islands, U.S.'
        }
    ],
    VN: [
        {
            value: 'VN-44',
            labelcz: 'An Giang'
        },
        {
            value: 'VN-43',
            labelcz: 'Ba Ria - Vung Tau'
        },
        {
            value: 'VN-54',
            labelcz: 'Bac Giang'
        },
        {
            value: 'VN-53',
            labelcz: 'Bac Kan'
        },
        {
            value: 'VN-55',
            labelcz: 'Bac Lieu'
        },
        {
            value: 'VN-56',
            labelcz: 'Bac Ninh'
        },
        {
            value: 'VN-50',
            labelcz: 'Ben Tre'
        },
        {
            value: 'VN-31',
            labelcz: 'Binh Dinh'
        },
        {
            value: 'VN-57',
            labelcz: 'Binh Duong'
        },
        {
            value: 'VN-58',
            labelcz: 'Binh Phuoc'
        },
        {
            value: 'VN-40',
            labelcz: 'Binh Thuan'
        },
        {
            value: 'VN-59',
            labelcz: 'Ca Mau'
        },
        {
            value: 'VN-CT',
            labelcz: 'Can Tho'
        },
        {
            value: 'VN-04',
            labelcz: 'Cao Bang'
        },
        {
            value: 'VN-DN',
            labelcz: 'Da Nang'
        },
        {
            value: 'VN-33',
            labelcz: 'Dak Lak'
        },
        {
            value: 'VN-72',
            labelcz: 'Dak Nong'
        },
        {
            value: 'VN-71',
            labelcz: 'Dien Bien'
        },
        {
            value: 'VN-39',
            labelcz: 'Dong Nai'
        },
        {
            value: 'VN-45',
            labelcz: 'Dong Thap'
        },
        {
            value: 'VN-30',
            labelcz: 'Gia Lai'
        },
        {
            value: 'VN-03',
            labelcz: 'Ha Giang'
        },
        {
            value: 'VN-63',
            labelcz: 'Ha Nam'
        },
        {
            value: 'VN-HN',
            labelcz: 'Ha Noi'
        },
        {
            value: 'VN-23',
            labelcz: 'Ha Tinh'
        },
        {
            value: 'VN-61',
            labelcz: 'Hai Duong'
        },
        {
            value: 'VN-HP',
            labelcz: 'Hai Phong'
        },
        {
            value: 'VN-73',
            labelcz: 'Hau Giang'
        },
        {
            value: 'VN-SG',
            labelcz: 'Ho Chi Minh'
        },
        {
            value: 'VN-14',
            labelcz: 'Hoa Binh'
        },
        {
            value: 'VN-66',
            labelcz: 'Hung Yen'
        },
        {
            value: 'VN-34',
            labelcz: 'Khanh Hoa'
        },
        {
            value: 'VN-47',
            labelcz: 'Kien Giang'
        },
        {
            value: 'VN-28',
            labelcz: 'Kon Tum'
        },
        {
            value: 'VN-01',
            labelcz: 'Lai Chau'
        },
        {
            value: 'VN-35',
            labelcz: 'Lam Dong'
        },
        {
            value: 'VN-09',
            labelcz: 'Lang Son'
        },
        {
            value: 'VN-02',
            labelcz: 'Lao Cai'
        },
        {
            value: 'VN-41',
            labelcz: 'Long An'
        },
        {
            value: 'VN-67',
            labelcz: 'Nam Dinh'
        },
        {
            value: 'VN-22',
            labelcz: 'Nghe An'
        },
        {
            value: 'VN-18',
            labelcz: 'Ninh Binh'
        },
        {
            value: 'VN-36',
            labelcz: 'Ninh Thuan'
        },
        {
            value: 'VN-68',
            labelcz: 'Phu Tho'
        },
        {
            value: 'VN-32',
            labelcz: 'Phu Yen'
        },
        {
            value: 'VN-24',
            labelcz: 'Quang Binh'
        },
        {
            value: 'VN-27',
            labelcz: 'Quang Nam'
        },
        {
            value: 'VN-29',
            labelcz: 'Quang Ngai'
        },
        {
            value: 'VN-13',
            labelcz: 'Quang Ninh'
        },
        {
            value: 'VN-25',
            labelcz: 'Quang Tri'
        },
        {
            value: 'VN-52',
            labelcz: 'Soc Trang'
        },
        {
            value: 'VN-05',
            labelcz: 'Son La'
        },
        {
            value: 'VN-37',
            labelcz: 'Tay Ninh'
        },
        {
            value: 'VN-20',
            labelcz: 'Thai Binh'
        },
        {
            value: 'VN-69',
            labelcz: 'Thai Nguyen'
        },
        {
            value: 'VN-21',
            labelcz: 'Thanh Hoa'
        },
        {
            value: 'VN-26',
            labelcz: 'Thua Thien-Hue'
        },
        {
            value: 'VN-46',
            labelcz: 'Tien Giang'
        },
        {
            value: 'VN-51',
            labelcz: 'Tra Vinh'
        },
        {
            value: 'VN-07',
            labelcz: 'Tuyen Quang'
        },
        {
            value: 'VN-49',
            labelcz: 'Vinh Long'
        },
        {
            value: 'VN-70',
            labelcz: 'Vinh Phuc'
        },
        {
            value: 'VN-06',
            labelcz: 'Yen Bai'
        }
    ],
    VU: [
        {
            value: 'VU-SAM',
            labelcz: 'Sanma'
        },
        {
            value: 'VU-SEE',
            labelcz: 'Shefa'
        },
        {
            value: 'VU-TAE',
            labelcz: 'Tafea'
        },
        {
            value: 'VU-TOB',
            labelcz: 'Torba'
        }
    ],
    WF: [
        {
            value: 'WF-SG',
            labelcz: 'Sigave'
        },
        {
            value: 'WF-UV',
            labelcz: 'Uvea'
        }
    ],
    WS: [
        {
            value: 'WS-AT',
            labelcz: 'Atua'
        },
        {
            value: 'WS-FA',
            labelcz: "Fa'asaleleaga"
        },
        {
            value: 'WS-GI',
            labelcz: 'Gagaifomauga'
        },
        {
            value: 'WS-TU',
            labelcz: 'Tuamasaga'
        }
    ],
    YE: [
        {
            value: 'YE-AD',
            labelcz: "'Adan"
        },
        {
            value: 'YE-AM',
            labelcz: "'Amran"
        },
        {
            value: 'YE-DA',
            labelcz: "Ad Dali'"
        },
        {
            value: 'YE-BA',
            labelcz: "Al Bayda'"
        },
        {
            value: 'YE-HU',
            labelcz: 'Al Hudaydah'
        },
        {
            value: 'YE-JA',
            labelcz: 'Al Jawf'
        },
        {
            value: 'YE-MW',
            labelcz: 'Al Mahwit'
        },
        {
            value: 'YE-SA',
            labelcz: "Amanat al 'Asimah"
        },
        {
            value: 'YE-DH',
            labelcz: 'Dhamar'
        },
        {
            value: 'YE-HD',
            labelcz: 'Hadramawt'
        },
        {
            value: 'YE-HJ',
            labelcz: 'Hajjah'
        },
        {
            value: 'YE-IB',
            labelcz: 'Ibb'
        },
        {
            value: 'YE-LA',
            labelcz: 'Lahij'
        },
        {
            value: 'YE-MA',
            labelcz: "Ma'rib"
        },
        {
            value: 'YE-RA',
            labelcz: 'Raymah'
        },
        {
            value: 'YE-SD',
            labelcz: "Sa'dah"
        },
        {
            value: 'YE-SN',
            labelcz: "San'a'"
        },
        {
            value: 'YE-SH',
            labelcz: 'Shabwah'
        },
        {
            value: 'YE-TA',
            labelcz: "Ta'izz"
        }
    ],
    YT: [
        {
            value: '-',
            labelcz: 'Bandraboua'
        },
        {
            value: '-',
            labelcz: 'Bandrele'
        },
        {
            value: '-',
            labelcz: 'Kani-Keli'
        },
        {
            value: '-',
            labelcz: 'Mamoudzou'
        },
        {
            value: '-',
            labelcz: 'Ouangani'
        },
        {
            value: '-',
            labelcz: 'Pamandzi'
        },
        {
            value: '-',
            labelcz: 'Sada'
        },
        {
            value: '-',
            labelcz: 'Tsingoni'
        }
    ],
    ZA: [
        {
            value: 'ZA-EC',
            labelcz: 'Eastern Cape'
        },
        {
            value: 'ZA-FS',
            labelcz: 'Free State'
        },
        {
            value: 'ZA-GP',
            labelcz: 'Gauteng'
        },
        {
            value: 'ZA-KZN',
            labelcz: 'Kwazulu-Natal'
        },
        {
            value: 'ZA-LP',
            labelcz: 'Limpopo'
        },
        {
            value: 'ZA-MP',
            labelcz: 'Mpumalanga'
        },
        {
            value: 'ZA-NW',
            labelcz: 'North-West'
        },
        {
            value: 'ZA-NC',
            labelcz: 'Northern Cape'
        },
        {
            value: 'ZA-WC',
            labelcz: 'Western Cape'
        }
    ],
    ZM: [
        {
            value: 'ZM-02',
            labelcz: 'Central'
        },
        {
            value: 'ZM-08',
            labelcz: 'Copperbelt'
        },
        {
            value: 'ZM-03',
            labelcz: 'Eastern'
        },
        {
            value: 'ZM-04',
            labelcz: 'Luapula'
        },
        {
            value: 'ZM-09',
            labelcz: 'Lusaka'
        },
        {
            value: 'ZM-10',
            labelcz: 'Muchinga'
        },
        {
            value: 'ZM-06',
            labelcz: 'North-Western'
        },
        {
            value: 'ZM-05',
            labelcz: 'Northern'
        },
        {
            value: 'ZM-07',
            labelcz: 'Southern'
        },
        {
            value: 'ZM-01',
            labelcz: 'Western'
        }
    ],
    ZW: [
        {
            value: 'ZW-BU',
            labelcz: 'Bulawayo'
        },
        {
            value: 'ZW-HA',
            labelcz: 'Harare'
        },
        {
            value: 'ZW-MA',
            labelcz: 'Manicaland'
        },
        {
            value: 'ZW-MC',
            labelcz: 'Mashonaland Central'
        },
        {
            value: 'ZW-ME',
            labelcz: 'Mashonaland East'
        },
        {
            value: 'ZW-MW',
            labelcz: 'Mashonaland West'
        },
        {
            value: 'ZW-MV',
            labelcz: 'Masvingo'
        },
        {
            value: 'ZW-MN',
            labelcz: 'Matabeleland North'
        },
        {
            value: 'ZW-MS',
            labelcz: 'Matabeleland South'
        },
        {
            value: 'ZW-MI',
            labelcz: 'Midlands'
        }
    ]
};
